// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AcceptHomeInvitePublicApiHomeHomeInvitesTokenAcceptPostData,
  AcceptHomeInvitePublicApiHomeHomeInvitesTokenAcceptPostErrors,
  AcceptHomeInvitePublicApiHomeHomeInvitesTokenAcceptPostResponses,
  AcceptInvitePublicApiExploreInvitesTokenAcceptPostData,
  AcceptInvitePublicApiExploreInvitesTokenAcceptPostErrors,
  AcceptInvitePublicApiExploreInvitesTokenAcceptPostResponses,
  AcceptSuggestionsApiFinanceBankStatementsHomeHomeIdAcceptSuggestionsPostData,
  AcceptSuggestionsApiFinanceBankStatementsHomeHomeIdAcceptSuggestionsPostErrors,
  AcceptSuggestionsApiFinanceBankStatementsHomeHomeIdAcceptSuggestionsPostResponses,
  ActivateHomeApiHomeHomesHomeIdActivatePostData,
  ActivateHomeApiHomeHomesHomeIdActivatePostErrors,
  ActivateHomeApiHomeHomesHomeIdActivatePostResponses,
  AddListingPhotoUrlsApiExploreListingsListingIdPhotosUrlsPostData,
  AddListingPhotoUrlsApiExploreListingsListingIdPhotosUrlsPostErrors,
  AddListingPhotoUrlsApiExploreListingsListingIdPhotosUrlsPostResponses,
  ApplyNotificationPreferencesToAllApiNotificationPreferencesApplyAllPostData,
  ApplyNotificationPreferencesToAllApiNotificationPreferencesApplyAllPostErrors,
  ApplyNotificationPreferencesToAllApiNotificationPreferencesApplyAllPostResponses,
  ArchiveAssetApiAssetsAssetIdArchivePostData,
  ArchiveAssetApiAssetsAssetIdArchivePostErrors,
  ArchiveAssetApiAssetsAssetIdArchivePostResponses,
  AttachDocumentsToExpenseApiFinanceExpensesExpenseIdAttachmentsPostData,
  AttachDocumentsToExpenseApiFinanceExpensesExpenseIdAttachmentsPostErrors,
  AttachDocumentsToExpenseApiFinanceExpensesExpenseIdAttachmentsPostResponses,
  CommitImportApiFinanceBankStatementsImportsStatementImportIdCommitPostData,
  CommitImportApiFinanceBankStatementsImportsStatementImportIdCommitPostErrors,
  CommitImportApiFinanceBankStatementsImportsStatementImportIdCommitPostResponses,
  CommitPayoutImportApiIntegrationIntegrationIdPayoutsCommitPostData,
  CommitPayoutImportApiIntegrationIntegrationIdPayoutsCommitPostErrors,
  CommitPayoutImportApiIntegrationIntegrationIdPayoutsCommitPostResponses,
  CompleteExtractionJobApiExtractionHomesHomeIdJobsJobIdCompletePostData,
  CompleteExtractionJobApiExtractionHomesHomeIdJobsJobIdCompletePostErrors,
  CompleteExtractionJobApiExtractionHomesHomeIdJobsJobIdCompletePostResponses,
  ConfirmCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionSessionIdConfirmPostData,
  ConfirmCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionSessionIdConfirmPostErrors,
  ConfirmCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionSessionIdConfirmPostResponses,
  ConnectAirbnbApiIntegrationHomeHomeIdAirbnbPostData,
  ConnectAirbnbApiIntegrationHomeHomeIdAirbnbPostErrors,
  ConnectAirbnbApiIntegrationHomeHomeIdAirbnbPostResponses,
  ConnectGoogleCalendarApiIntegrationHomeHomeIdGoogleCalendarPostData,
  ConnectGoogleCalendarApiIntegrationHomeHomeIdGoogleCalendarPostErrors,
  ConnectGoogleCalendarApiIntegrationHomeHomeIdGoogleCalendarPostResponses,
  CreateAssetApiAssetsPostData,
  CreateAssetApiAssetsPostErrors,
  CreateAssetApiAssetsPostResponses,
  CreateAssetCategoryApiAssetsCategoriesPostData,
  CreateAssetCategoryApiAssetsCategoriesPostErrors,
  CreateAssetCategoryApiAssetsCategoriesPostResponses,
  CreateAssetFromExpenseApiAssetsFromExpenseExpenseIdPutData,
  CreateAssetFromExpenseApiAssetsFromExpenseExpenseIdPutErrors,
  CreateAssetFromExpenseApiAssetsFromExpenseExpenseIdPutResponses,
  CreateCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionPostData,
  CreateCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionPostErrors,
  CreateCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionPostResponses,
  CreateCommentApiExploreListingsListingIdCommentsPostData,
  CreateCommentApiExploreListingsListingIdCommentsPostErrors,
  CreateCommentApiExploreListingsListingIdCommentsPostResponses,
  CreateDepositApiFinanceBankStatementsTransactionsTransactionIdCreateDepositPostData,
  CreateDepositApiFinanceBankStatementsTransactionsTransactionIdCreateDepositPostErrors,
  CreateDepositApiFinanceBankStatementsTransactionsTransactionIdCreateDepositPostResponses,
  CreateDocumentCategoryApiDocumentCategoriesPostData,
  CreateDocumentCategoryApiDocumentCategoriesPostErrors,
  CreateDocumentCategoryApiDocumentCategoriesPostResponses,
  CreateExpenseApiFinanceBankStatementsTransactionsTransactionIdCreateExpensePostData,
  CreateExpenseApiFinanceBankStatementsTransactionsTransactionIdCreateExpensePostErrors,
  CreateExpenseApiFinanceBankStatementsTransactionsTransactionIdCreateExpensePostResponses,
  CreateExpenseApiFinanceExpensesPostData,
  CreateExpenseApiFinanceExpensesPostErrors,
  CreateExpenseApiFinanceExpensesPostResponses,
  CreateExpenseCategoryApiFinanceExpensesCategoriesPostData,
  CreateExpenseCategoryApiFinanceExpensesCategoriesPostErrors,
  CreateExpenseCategoryApiFinanceExpensesCategoriesPostResponses,
  CreateExtractionJobApiExtractionHomesHomeIdJobsPostData,
  CreateExtractionJobApiExtractionHomesHomeIdJobsPostErrors,
  CreateExtractionJobApiExtractionHomesHomeIdJobsPostResponses,
  CreateExtractionJobBatchApiExtractionHomesHomeIdJobsBatchPostData,
  CreateExtractionJobBatchApiExtractionHomesHomeIdJobsBatchPostErrors,
  CreateExtractionJobBatchApiExtractionHomesHomeIdJobsBatchPostResponses,
  CreateGroupAmenityApiExploreGroupsGroupIdAmenitiesPostData,
  CreateGroupAmenityApiExploreGroupsGroupIdAmenitiesPostErrors,
  CreateGroupAmenityApiExploreGroupsGroupIdAmenitiesPostResponses,
  CreateGroupApiExploreGroupsPostData,
  CreateGroupApiExploreGroupsPostErrors,
  CreateGroupApiExploreGroupsPostResponses,
  CreateHomeApiHomeHomesPostData,
  CreateHomeApiHomeHomesPostErrors,
  CreateHomeApiHomeHomesPostResponses,
  CreateHomeEventApiScheduleHomeHomeIdEventsPostData,
  CreateHomeEventApiScheduleHomeHomeIdEventsPostErrors,
  CreateHomeEventApiScheduleHomeHomeIdEventsPostResponses,
  CreateHomeInviteApiHomeHomesHomeIdInvitesPostData,
  CreateHomeInviteApiHomeHomesHomeIdInvitesPostErrors,
  CreateHomeInviteApiHomeHomesHomeIdInvitesPostResponses,
  CreateInviteApiExploreGroupsGroupIdInvitesPostData,
  CreateInviteApiExploreGroupsGroupIdInvitesPostErrors,
  CreateInviteApiExploreGroupsGroupIdInvitesPostResponses,
  CreateListingApiExploreGroupsGroupIdListingsPostData,
  CreateListingApiExploreGroupsGroupIdListingsPostErrors,
  CreateListingApiExploreGroupsGroupIdListingsPostResponses,
  CreateListingVisitApiExploreListingsListingIdVisitsPostData,
  CreateListingVisitApiExploreListingsListingIdVisitsPostErrors,
  CreateListingVisitApiExploreListingsListingIdVisitsPostResponses,
  CreateListingVisitNoteApiExploreVisitsVisitIdNotesPostData,
  CreateListingVisitNoteApiExploreVisitsVisitIdNotesPostErrors,
  CreateListingVisitNoteApiExploreVisitsVisitIdNotesPostResponses,
  CreatePortalSessionApiBillingOwnerTypeOwnerIdPortalSessionPostData,
  CreatePortalSessionApiBillingOwnerTypeOwnerIdPortalSessionPostErrors,
  CreatePortalSessionApiBillingOwnerTypeOwnerIdPortalSessionPostResponses,
  CreateProfileApiFinanceBankStatementsProfilesPostData,
  CreateProfileApiFinanceBankStatementsProfilesPostErrors,
  CreateProfileApiFinanceBankStatementsProfilesPostResponses,
  CreateRecurringExpenseApiFinanceExpensesRecurringPostData,
  CreateRecurringExpenseApiFinanceExpensesRecurringPostErrors,
  CreateRecurringExpenseApiFinanceExpensesRecurringPostResponses,
  CreateReservationApiBookingPostData,
  CreateReservationApiBookingPostErrors,
  CreateReservationApiBookingPostResponses,
  CreateVoteApiExploreListingsListingIdVotesPostData,
  CreateVoteApiExploreListingsListingIdVotesPostErrors,
  CreateVoteApiExploreListingsListingIdVotesPostResponses,
  DeclineHomeInvitePublicApiHomeHomeInvitesTokenDeclinePostData,
  DeclineHomeInvitePublicApiHomeHomeInvitesTokenDeclinePostErrors,
  DeclineHomeInvitePublicApiHomeHomeInvitesTokenDeclinePostResponses,
  DeclineInvitePublicApiExploreInvitesTokenDeclinePostData,
  DeclineInvitePublicApiExploreInvitesTokenDeclinePostErrors,
  DeclineInvitePublicApiExploreInvitesTokenDeclinePostResponses,
  DeleteCommentApiExploreCommentsCommentIdDeleteData,
  DeleteCommentApiExploreCommentsCommentIdDeleteErrors,
  DeleteCommentApiExploreCommentsCommentIdDeleteResponses,
  DeleteCurrentUserApiAuthMeDeleteData,
  DeleteCurrentUserApiAuthMeDeleteErrors,
  DeleteCurrentUserApiAuthMeDeleteResponses,
  DeleteDocumentApiDocumentDocumentIdDeleteData,
  DeleteDocumentApiDocumentDocumentIdDeleteErrors,
  DeleteDocumentApiDocumentDocumentIdDeleteResponses,
  DeleteDocumentCategoryApiDocumentCategoriesCategoryIdDeleteData,
  DeleteDocumentCategoryApiDocumentCategoriesCategoryIdDeleteErrors,
  DeleteDocumentCategoryApiDocumentCategoriesCategoryIdDeleteResponses,
  DeleteDraftHomeApiHomeHomesHomeIdDeleteData,
  DeleteDraftHomeApiHomeHomesHomeIdDeleteErrors,
  DeleteDraftHomeApiHomeHomesHomeIdDeleteResponses,
  DeleteExpenseApiFinanceExpensesExpenseIdDeleteData,
  DeleteExpenseApiFinanceExpensesExpenseIdDeleteErrors,
  DeleteExpenseApiFinanceExpensesExpenseIdDeleteResponses,
  DeleteExpenseCategoryApiFinanceExpensesCategoriesCategoryIdDeleteData,
  DeleteExpenseCategoryApiFinanceExpensesCategoriesCategoryIdDeleteErrors,
  DeleteExpenseCategoryApiFinanceExpensesCategoriesCategoryIdDeleteResponses,
  DeleteGroupApiExploreGroupsGroupIdDeleteData,
  DeleteGroupApiExploreGroupsGroupIdDeleteErrors,
  DeleteGroupApiExploreGroupsGroupIdDeleteResponses,
  DeleteHomeEventApiScheduleEventsEventIdDeleteData,
  DeleteHomeEventApiScheduleEventsEventIdDeleteErrors,
  DeleteHomeEventApiScheduleEventsEventIdDeleteResponses,
  DeleteListingApiExploreListingsListingIdDeleteData,
  DeleteListingApiExploreListingsListingIdDeleteErrors,
  DeleteListingApiExploreListingsListingIdDeleteResponses,
  DeleteListingVisitApiExploreVisitsVisitIdDeleteData,
  DeleteListingVisitApiExploreVisitsVisitIdDeleteErrors,
  DeleteListingVisitApiExploreVisitsVisitIdDeleteResponses,
  DeleteListingVisitNoteApiExploreVisitNotesNoteIdDeleteData,
  DeleteListingVisitNoteApiExploreVisitNotesNoteIdDeleteErrors,
  DeleteListingVisitNoteApiExploreVisitNotesNoteIdDeleteResponses,
  DeleteListingVisitNotePhotoApiExploreVisitNotePhotosPhotoIdDeleteData,
  DeleteListingVisitNotePhotoApiExploreVisitNotePhotosPhotoIdDeleteErrors,
  DeleteListingVisitNotePhotoApiExploreVisitNotePhotosPhotoIdDeleteResponses,
  DeleteRecurringExpenseApiFinanceExpensesRecurringRecurringIdDeleteData,
  DeleteRecurringExpenseApiFinanceExpensesRecurringRecurringIdDeleteErrors,
  DeleteRecurringExpenseApiFinanceExpensesRecurringRecurringIdDeleteResponses,
  DeleteReservationApiBookingReservationIdDeleteData,
  DeleteReservationApiBookingReservationIdDeleteErrors,
  DeleteReservationApiBookingReservationIdDeleteResponses,
  DeleteVoteApiExploreVotesVoteIdDeleteData,
  DeleteVoteApiExploreVotesVoteIdDeleteErrors,
  DeleteVoteApiExploreVotesVoteIdDeleteResponses,
  DepositToLedgerApiFinanceLedgerHomeIdDepositPostData,
  DepositToLedgerApiFinanceLedgerHomeIdDepositPostErrors,
  DepositToLedgerApiFinanceLedgerHomeIdDepositPostResponses,
  DisableMyCalendarApiIntegrationMeCalendarDeleteData,
  DisableMyCalendarApiIntegrationMeCalendarDeleteErrors,
  DisableMyCalendarApiIntegrationMeCalendarDeleteResponses,
  DisconnectIntegrationApiIntegrationIntegrationIdDeleteData,
  DisconnectIntegrationApiIntegrationIntegrationIdDeleteErrors,
  DisconnectIntegrationApiIntegrationIntegrationIdDeleteResponses,
  DismissExtractionJobApiExtractionHomesHomeIdJobsJobIdDismissPostData,
  DismissExtractionJobApiExtractionHomesHomeIdJobsJobIdDismissPostErrors,
  DismissExtractionJobApiExtractionHomesHomeIdJobsJobIdDismissPostResponses,
  EnableMyCalendarApiIntegrationMeCalendarPostData,
  EnableMyCalendarApiIntegrationMeCalendarPostErrors,
  EnableMyCalendarApiIntegrationMeCalendarPostResponses,
  ExcludeTransactionApiFinanceBankStatementsTransactionsTransactionIdExcludePostData,
  ExcludeTransactionApiFinanceBankStatementsTransactionsTransactionIdExcludePostErrors,
  ExcludeTransactionApiFinanceBankStatementsTransactionsTransactionIdExcludePostResponses,
  ExtractAndCreateAssetApiAssetsHomeHomeIdExtractPostData,
  ExtractAndCreateAssetApiAssetsHomeHomeIdExtractPostErrors,
  ExtractAndCreateAssetApiAssetsHomeHomeIdExtractPostResponses,
  ExtractAndCreateListingApiExploreGroupsGroupIdListingsExtractPostData,
  ExtractAndCreateListingApiExploreGroupsGroupIdListingsExtractPostErrors,
  ExtractAndCreateListingApiExploreGroupsGroupIdListingsExtractPostResponses,
  ExtractAndUpdateAssetApiAssetsAssetIdExtractPostData,
  ExtractAndUpdateAssetApiAssetsAssetIdExtractPostErrors,
  ExtractAndUpdateAssetApiAssetsAssetIdExtractPostResponses,
  ExtractAndUpdateListingApiExploreListingsListingIdExtractPostData,
  ExtractAndUpdateListingApiExploreListingsListingIdExtractPostErrors,
  ExtractAndUpdateListingApiExploreListingsListingIdExtractPostResponses,
  ExtractionEventsApiExtractionHomesHomeIdEventsGetData,
  ExtractionEventsApiExtractionHomesHomeIdEventsGetErrors,
  ExtractionEventsApiExtractionHomesHomeIdEventsGetResponses,
  ForgotPasswordApiAuthForgotPasswordPostData,
  ForgotPasswordApiAuthForgotPasswordPostErrors,
  ForgotPasswordApiAuthForgotPasswordPostResponses,
  GenerateExpenseApiFinanceExpensesRecurringRecurringIdGeneratePostData,
  GenerateExpenseApiFinanceExpensesRecurringRecurringIdGeneratePostErrors,
  GenerateExpenseApiFinanceExpensesRecurringRecurringIdGeneratePostResponses,
  GetAllLedgerAccountsApiFinanceLedgerHomeIdAccountsGetData,
  GetAllLedgerAccountsApiFinanceLedgerHomeIdAccountsGetErrors,
  GetAllLedgerAccountsApiFinanceLedgerHomeIdAccountsGetResponses,
  GetAllNotificationsApiNotificationNotificationsGetData,
  GetAllNotificationsApiNotificationNotificationsGetErrors,
  GetAllNotificationsApiNotificationNotificationsGetResponses,
  GetAmenitiesApiExploreOptionsAmenitiesGetData,
  GetAmenitiesApiExploreOptionsAmenitiesGetErrors,
  GetAmenitiesApiExploreOptionsAmenitiesGetResponses,
  GetAssetApiAssetsAssetIdGetData,
  GetAssetApiAssetsAssetIdGetErrors,
  GetAssetApiAssetsAssetIdGetResponses,
  GetAssetFromExpenseApiAssetsFromExpenseExpenseIdGetData,
  GetAssetFromExpenseApiAssetsFromExpenseExpenseIdGetErrors,
  GetAssetFromExpenseApiAssetsFromExpenseExpenseIdGetResponses,
  GetCommentsApiExploreListingsListingIdCommentsGetData,
  GetCommentsApiExploreListingsListingIdCommentsGetErrors,
  GetCommentsApiExploreListingsListingIdCommentsGetResponses,
  GetCurrenciesApiExploreOptionsCurrenciesGetData,
  GetCurrenciesApiExploreOptionsCurrenciesGetErrors,
  GetCurrenciesApiExploreOptionsCurrenciesGetResponses,
  GetCurrentHomeApiHomeHomesCurrentGetData,
  GetCurrentHomeApiHomeHomesCurrentGetErrors,
  GetCurrentHomeApiHomeHomesCurrentGetResponses,
  GetCurrentUserProfileApiAuthMeGetData,
  GetCurrentUserProfileApiAuthMeGetErrors,
  GetCurrentUserProfileApiAuthMeGetResponses,
  GetDocumentApiDocumentDocumentIdGetData,
  GetDocumentApiDocumentDocumentIdGetErrors,
  GetDocumentApiDocumentDocumentIdGetResponses,
  GetDocumentCategoriesApiDocumentCategoriesHomeHomeIdGetData,
  GetDocumentCategoriesApiDocumentCategoriesHomeHomeIdGetErrors,
  GetDocumentCategoriesApiDocumentCategoriesHomeHomeIdGetResponses,
  GetDocumentUrlApiDocumentDocumentIdUrlGetData,
  GetDocumentUrlApiDocumentDocumentIdUrlGetErrors,
  GetDocumentUrlApiDocumentDocumentIdUrlGetResponses,
  GetDocumentVaultOverviewApiDocumentHomeHomeIdOverviewGetData,
  GetDocumentVaultOverviewApiDocumentHomeHomeIdOverviewGetErrors,
  GetDocumentVaultOverviewApiDocumentHomeHomeIdOverviewGetResponses,
  GetDraftHomeApiHomeHomesHomeIdGetData,
  GetDraftHomeApiHomeHomesHomeIdGetErrors,
  GetDraftHomeApiHomeHomesHomeIdGetResponses,
  GetEmailAliasAvailabilityApiNotificationEmailAliasesAvailabilityGetData,
  GetEmailAliasAvailabilityApiNotificationEmailAliasesAvailabilityGetErrors,
  GetEmailAliasAvailabilityApiNotificationEmailAliasesAvailabilityGetResponses,
  GetExpenseApiFinanceExpensesExpenseIdGetData,
  GetExpenseApiFinanceExpensesExpenseIdGetErrors,
  GetExpenseApiFinanceExpensesExpenseIdGetResponses,
  GetExpenseAttachmentsApiFinanceExpensesExpenseIdAttachmentsGetData,
  GetExpenseAttachmentsApiFinanceExpensesExpenseIdAttachmentsGetErrors,
  GetExpenseAttachmentsApiFinanceExpensesExpenseIdAttachmentsGetResponses,
  GetExpenseCategoriesApiFinanceExpensesCategoriesHomeHomeIdGetData,
  GetExpenseCategoriesApiFinanceExpensesCategoriesHomeHomeIdGetErrors,
  GetExpenseCategoriesApiFinanceExpensesCategoriesHomeHomeIdGetResponses,
  GetExpensesApiFinanceExpensesGetData,
  GetExpensesApiFinanceExpensesGetErrors,
  GetExpensesApiFinanceExpensesGetResponses,
  GetExpenseTransactionsApiFinanceExpensesExpenseIdTransactionsGetData,
  GetExpenseTransactionsApiFinanceExpensesExpenseIdTransactionsGetErrors,
  GetExpenseTransactionsApiFinanceExpensesExpenseIdTransactionsGetResponses,
  GetExtractionJobApiExtractionHomesHomeIdJobsJobIdGetData,
  GetExtractionJobApiExtractionHomesHomeIdJobsJobIdGetErrors,
  GetExtractionJobApiExtractionHomesHomeIdJobsJobIdGetResponses,
  GetFairUseApiBookingHomeHomeIdFairUseGetData,
  GetFairUseApiBookingHomeHomeIdFairUseGetErrors,
  GetFairUseApiBookingHomeHomeIdFairUseGetResponses,
  GetGroupAmenitiesApiExploreGroupsGroupIdAmenitiesGetData,
  GetGroupAmenitiesApiExploreGroupsGroupIdAmenitiesGetErrors,
  GetGroupAmenitiesApiExploreGroupsGroupIdAmenitiesGetResponses,
  GetGroupApiExploreGroupsGroupIdGetData,
  GetGroupApiExploreGroupsGroupIdGetErrors,
  GetGroupApiExploreGroupsGroupIdGetResponses,
  GetGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdGetData,
  GetGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdGetErrors,
  GetGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdGetResponses,
  GetGroupPreferencesApiExploreGroupsGroupIdMemberPreferencesGetData,
  GetGroupPreferencesApiExploreGroupsGroupIdMemberPreferencesGetErrors,
  GetGroupPreferencesApiExploreGroupsGroupIdMemberPreferencesGetResponses,
  GetGroupsApiExploreGroupsGetData,
  GetGroupsApiExploreGroupsGetErrors,
  GetGroupsApiExploreGroupsGetResponses,
  GetHomeByIdApiHomeHomeIdGetData,
  GetHomeByIdApiHomeHomeIdGetErrors,
  GetHomeByIdApiHomeHomeIdGetResponses,
  GetHomeDashboardApiHomeHomeIdDashboardGetData,
  GetHomeDashboardApiHomeHomeIdDashboardGetErrors,
  GetHomeDashboardApiHomeHomeIdDashboardGetResponses,
  GetHomeDocumentsApiDocumentHomeHomeIdGetData,
  GetHomeDocumentsApiDocumentHomeHomeIdGetErrors,
  GetHomeDocumentsApiDocumentHomeHomeIdGetResponses,
  GetHomeEventApiScheduleEventsEventIdGetData,
  GetHomeEventApiScheduleEventsEventIdGetErrors,
  GetHomeEventApiScheduleEventsEventIdGetResponses,
  GetHomeExpensesApiFinanceExpensesHomeHomeIdGetData,
  GetHomeExpensesApiFinanceExpensesHomeHomeIdGetErrors,
  GetHomeExpensesApiFinanceExpensesHomeHomeIdGetResponses,
  GetHomeFinanceSummaryApiFinanceSummaryHomeHomeIdGetData,
  GetHomeFinanceSummaryApiFinanceSummaryHomeHomeIdGetErrors,
  GetHomeFinanceSummaryApiFinanceSummaryHomeHomeIdGetResponses,
  GetHomeInvitesApiHomeHomesHomeIdInvitesGetData,
  GetHomeInvitesApiHomeHomesHomeIdInvitesGetErrors,
  GetHomeInvitesApiHomeHomesHomeIdInvitesGetResponses,
  GetHomeMaintenanceRequestsApiMaintenanceHomeHomeIdGetData,
  GetHomeMaintenanceRequestsApiMaintenanceHomeHomeIdGetErrors,
  GetHomeMaintenanceRequestsApiMaintenanceHomeHomeIdGetResponses,
  GetHomeMembersApiHomeHomeIdMembersGetData,
  GetHomeMembersApiHomeHomeIdMembersGetErrors,
  GetHomeMembersApiHomeHomeIdMembersGetResponses,
  GetHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdGetData,
  GetHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdGetErrors,
  GetHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdGetResponses,
  GetHomesApiHomeGetData,
  GetHomesApiHomeGetErrors,
  GetHomesApiHomeGetResponses,
  GetHomeScheduleApiScheduleHomeHomeIdGetData,
  GetHomeScheduleApiScheduleHomeHomeIdGetErrors,
  GetHomeScheduleApiScheduleHomeHomeIdGetResponses,
  GetHomeScheduleOverviewApiScheduleHomeHomeIdOverviewGetData,
  GetHomeScheduleOverviewApiScheduleHomeHomeIdOverviewGetErrors,
  GetHomeScheduleOverviewApiScheduleHomeHomeIdOverviewGetResponses,
  GetHomeSettlementsApiFinanceSettlementsHomeHomeIdGetData,
  GetHomeSettlementsApiFinanceSettlementsHomeHomeIdGetErrors,
  GetHomeSettlementsApiFinanceSettlementsHomeHomeIdGetResponses,
  GetHomeTransactionsApiFinanceTransactionsHomeHomeIdGetData,
  GetHomeTransactionsApiFinanceTransactionsHomeHomeIdGetErrors,
  GetHomeTransactionsApiFinanceTransactionsHomeHomeIdGetResponses,
  GetHomeTypesApiExploreOptionsHomeTypesGetData,
  GetHomeTypesApiExploreOptionsHomeTypesGetErrors,
  GetHomeTypesApiExploreOptionsHomeTypesGetResponses,
  GetHomeTypesApiHomeTypesGetData,
  GetHomeTypesApiHomeTypesGetResponses,
  GetHouseFeedApiIntegrationHouseExportTokenIcsGetData,
  GetHouseFeedApiIntegrationHouseExportTokenIcsGetErrors,
  GetHouseFeedApiIntegrationHouseExportTokenIcsGetResponses,
  GetIntegrationApiIntegrationIntegrationIdGetData,
  GetIntegrationApiIntegrationIntegrationIdGetErrors,
  GetIntegrationApiIntegrationIntegrationIdGetResponses,
  GetInvitesApiExploreGroupsGroupIdInvitesGetData,
  GetInvitesApiExploreGroupsGroupIdInvitesGetErrors,
  GetInvitesApiExploreGroupsGroupIdInvitesGetResponses,
  GetLedgerAccountApiFinanceLedgerHomeIdGetData,
  GetLedgerAccountApiFinanceLedgerHomeIdGetErrors,
  GetLedgerAccountApiFinanceLedgerHomeIdGetResponses,
  GetLedgerBalanceApiFinanceLedgerHomeIdBalanceGetData,
  GetLedgerBalanceApiFinanceLedgerHomeIdBalanceGetErrors,
  GetLedgerBalanceApiFinanceLedgerHomeIdBalanceGetResponses,
  GetLedgerBalanceHistoryApiFinanceLedgerHomeIdBalanceHistoryGetData,
  GetLedgerBalanceHistoryApiFinanceLedgerHomeIdBalanceHistoryGetErrors,
  GetLedgerBalanceHistoryApiFinanceLedgerHomeIdBalanceHistoryGetResponses,
  GetLedgerTransactionsApiFinanceLedgerHomeIdTransactionsGetData,
  GetLedgerTransactionsApiFinanceLedgerHomeIdTransactionsGetErrors,
  GetLedgerTransactionsApiFinanceLedgerHomeIdTransactionsGetResponses,
  GetListingApiExploreListingsListingIdGetData,
  GetListingApiExploreListingsListingIdGetErrors,
  GetListingApiExploreListingsListingIdGetResponses,
  GetListingsApiExploreGroupsGroupIdListingsGetData,
  GetListingsApiExploreGroupsGroupIdListingsGetErrors,
  GetListingsApiExploreGroupsGroupIdListingsGetResponses,
  GetListingVisitsApiExploreListingsListingIdVisitsGetData,
  GetListingVisitsApiExploreListingsListingIdVisitsGetErrors,
  GetListingVisitsApiExploreListingsListingIdVisitsGetResponses,
  GetMaintenanceRequestApiMaintenanceRequestIdGetData,
  GetMaintenanceRequestApiMaintenanceRequestIdGetErrors,
  GetMaintenanceRequestApiMaintenanceRequestIdGetResponses,
  GetMaintenanceRequestsApiMaintenanceGetData,
  GetMaintenanceRequestsApiMaintenanceGetErrors,
  GetMaintenanceRequestsApiMaintenanceGetResponses,
  GetMembersApiExploreGroupsGroupIdMembersGetData,
  GetMembersApiExploreGroupsGroupIdMembersGetErrors,
  GetMembersApiExploreGroupsGroupIdMembersGetResponses,
  GetMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthGetData,
  GetMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthGetErrors,
  GetMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthGetResponses,
  GetMyCalendarApiIntegrationMeCalendarGetData,
  GetMyCalendarApiIntegrationMeCalendarGetErrors,
  GetMyCalendarApiIntegrationMeCalendarGetResponses,
  GetMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesGetData,
  GetMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesGetErrors,
  GetMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesGetResponses,
  GetNotificationApiNotificationNotificationsNotificationIdGetData,
  GetNotificationApiNotificationNotificationsNotificationIdGetErrors,
  GetNotificationApiNotificationNotificationsNotificationIdGetResponses,
  GetNotificationCatalogApiNotificationPreferencesCatalogGetData,
  GetNotificationCatalogApiNotificationPreferencesCatalogGetResponses,
  GetNotificationPreferencesApiNotificationPreferencesGetData,
  GetNotificationPreferencesApiNotificationPreferencesGetErrors,
  GetNotificationPreferencesApiNotificationPreferencesGetResponses,
  GetOpenWindowsApiBookingHomeHomeIdOpenWindowsGetData,
  GetOpenWindowsApiBookingHomeHomeIdOpenWindowsGetErrors,
  GetOpenWindowsApiBookingHomeHomeIdOpenWindowsGetResponses,
  GetOwnerBillingDetailsApiBillingOwnerTypeOwnerIdBillingDetailsGetData,
  GetOwnerBillingDetailsApiBillingOwnerTypeOwnerIdBillingDetailsGetErrors,
  GetOwnerBillingDetailsApiBillingOwnerTypeOwnerIdBillingDetailsGetResponses,
  GetOwnerEntitlementsApiBillingOwnerTypeOwnerIdEntitlementsGetData,
  GetOwnerEntitlementsApiBillingOwnerTypeOwnerIdEntitlementsGetErrors,
  GetOwnerEntitlementsApiBillingOwnerTypeOwnerIdEntitlementsGetResponses,
  GetOwnerSubscriptionApiBillingOwnerTypeOwnerIdSubscriptionGetData,
  GetOwnerSubscriptionApiBillingOwnerTypeOwnerIdSubscriptionGetErrors,
  GetOwnerSubscriptionApiBillingOwnerTypeOwnerIdSubscriptionGetResponses,
  GetPersonalCalendarFeedApiIntegrationCalendarTokenIcsGetData,
  GetPersonalCalendarFeedApiIntegrationCalendarTokenIcsGetErrors,
  GetPersonalCalendarFeedApiIntegrationCalendarTokenIcsGetResponses,
  GetPlansApiBillingPlansGetData,
  GetPlansApiBillingPlansGetErrors,
  GetPlansApiBillingPlansGetResponses,
  GetPropertyTypesApiExploreOptionsPropertyTypesGetData,
  GetPropertyTypesApiExploreOptionsPropertyTypesGetErrors,
  GetPropertyTypesApiExploreOptionsPropertyTypesGetResponses,
  GetPublicFeedApiIntegrationFeedsExportTokenIcsGetData,
  GetPublicFeedApiIntegrationFeedsExportTokenIcsGetErrors,
  GetPublicFeedApiIntegrationFeedsExportTokenIcsGetResponses,
  GetReconciliationApiFinanceBankStatementsHomeHomeIdReconciliationGetData,
  GetReconciliationApiFinanceBankStatementsHomeHomeIdReconciliationGetErrors,
  GetReconciliationApiFinanceBankStatementsHomeHomeIdReconciliationGetResponses,
  GetRecurringExpensesApiFinanceExpensesRecurringHomeHomeIdGetData,
  GetRecurringExpensesApiFinanceExpensesRecurringHomeHomeIdGetErrors,
  GetRecurringExpensesApiFinanceExpensesRecurringHomeHomeIdGetResponses,
  GetRequestsApiBookingHomeHomeIdRequestsGetData,
  GetRequestsApiBookingHomeHomeIdRequestsGetErrors,
  GetRequestsApiBookingHomeHomeIdRequestsGetResponses,
  GetReservationApiBookingReservationIdGetData,
  GetReservationApiBookingReservationIdGetErrors,
  GetReservationApiBookingReservationIdGetResponses,
  GetReservationsApiBookingHomeHomeIdGetData,
  GetReservationsApiBookingHomeHomeIdGetErrors,
  GetReservationsApiBookingHomeHomeIdGetResponses,
  GetSettlePlanApiFinanceBalancesHomeHomeIdSettlePlanGetData,
  GetSettlePlanApiFinanceBalancesHomeHomeIdSettlePlanGetErrors,
  GetSettlePlanApiFinanceBalancesHomeHomeIdSettlePlanGetResponses,
  GetTaskStatusApiNotificationTasksTaskIdGetData,
  GetTaskStatusApiNotificationTasksTaskIdGetErrors,
  GetTaskStatusApiNotificationTasksTaskIdGetResponses,
  GetUserBalancesApiFinanceBalancesHomeHomeIdGetData,
  GetUserBalancesApiFinanceBalancesHomeHomeIdGetErrors,
  GetUserBalancesApiFinanceBalancesHomeHomeIdGetResponses,
  GetUserHomeInvitesApiHomeHomeInvitesGetData,
  GetUserHomeInvitesApiHomeHomeInvitesGetErrors,
  GetUserHomeInvitesApiHomeHomeInvitesGetResponses,
  GetUserInvitesApiExploreInvitesGetData,
  GetUserInvitesApiExploreInvitesGetErrors,
  GetUserInvitesApiExploreInvitesGetResponses,
  GetUserNotificationsApiNotificationNotificationsUserRecipientIdGetData,
  GetUserNotificationsApiNotificationNotificationsUserRecipientIdGetErrors,
  GetUserNotificationsApiNotificationNotificationsUserRecipientIdGetResponses,
  GetVotesApiExploreListingsListingIdVotesGetData,
  GetVotesApiExploreListingsListingIdVotesGetErrors,
  GetVotesApiExploreListingsListingIdVotesGetResponses,
  GetYearlyBudgetApiFinanceBudgetsHomeHomeIdYearGetData,
  GetYearlyBudgetApiFinanceBudgetsHomeHomeIdYearGetErrors,
  GetYearlyBudgetApiFinanceBudgetsHomeHomeIdYearGetResponses,
  GroupCountApiActivityGroupsGroupIdCountGetData,
  GroupCountApiActivityGroupsGroupIdCountGetErrors,
  GroupCountApiActivityGroupsGroupIdCountGetResponses,
  GroupFeedApiActivityGroupsGroupIdGetData,
  GroupFeedApiActivityGroupsGroupIdGetErrors,
  GroupFeedApiActivityGroupsGroupIdGetResponses,
  GroupListingEventsApiExploreGroupsGroupIdEventsGetData,
  GroupListingEventsApiExploreGroupsGroupIdEventsGetErrors,
  GroupListingEventsApiExploreGroupsGroupIdEventsGetResponses,
  HandleInboundEmailApiEmailsInboundPostData,
  HandleInboundEmailApiEmailsInboundPostResponses,
  HealthCheckApiHealthGetData,
  HealthCheckApiHealthGetResponses,
  HealthLiveApiHealthLiveGetData,
  HealthLiveApiHealthLiveGetResponses,
  HealthReadyApiHealthReadyGetData,
  HealthReadyApiHealthReadyGetResponses,
  HomeCountApiActivityHomesHomeIdCountGetData,
  HomeCountApiActivityHomesHomeIdCountGetErrors,
  HomeCountApiActivityHomesHomeIdCountGetResponses,
  HomeFeedApiActivityHomesHomeIdGetData,
  HomeFeedApiActivityHomesHomeIdGetErrors,
  HomeFeedApiActivityHomesHomeIdGetResponses,
  HomeWorkspaceEventsApiHomeHomeIdEventsGetData,
  HomeWorkspaceEventsApiHomeHomeIdEventsGetErrors,
  HomeWorkspaceEventsApiHomeHomeIdEventsGetResponses,
  ImportSummaryApiFinanceBankStatementsImportsStatementImportIdSummaryGetData,
  ImportSummaryApiFinanceBankStatementsImportsStatementImportIdSummaryGetErrors,
  ImportSummaryApiFinanceBankStatementsImportsStatementImportIdSummaryGetResponses,
  InviteSessionApiAuthInviteSessionPostData,
  InviteSessionApiAuthInviteSessionPostErrors,
  InviteSessionApiAuthInviteSessionPostResponses,
  LinkAssetDocumentsApiAssetsAssetIdDocumentsPostData,
  LinkAssetDocumentsApiAssetsAssetIdDocumentsPostErrors,
  LinkAssetDocumentsApiAssetsAssetIdDocumentsPostResponses,
  ListAssetCategoriesApiAssetsCategoriesHomeHomeIdGetData,
  ListAssetCategoriesApiAssetsCategoriesHomeHomeIdGetErrors,
  ListAssetCategoriesApiAssetsCategoriesHomeHomeIdGetResponses,
  ListDocumentVaultRowsApiDocumentHomeHomeIdRowsGetData,
  ListDocumentVaultRowsApiDocumentHomeHomeIdRowsGetErrors,
  ListDocumentVaultRowsApiDocumentHomeHomeIdRowsGetResponses,
  ListExtractionJobsApiExtractionHomesHomeIdJobsGetData,
  ListExtractionJobsApiExtractionHomesHomeIdJobsGetErrors,
  ListExtractionJobsApiExtractionHomesHomeIdJobsGetResponses,
  ListHomeAssetsApiAssetsHomeHomeIdGetData,
  ListHomeAssetsApiAssetsHomeHomeIdGetErrors,
  ListHomeAssetsApiAssetsHomeHomeIdGetResponses,
  ListHomeAssetsPageApiAssetsHomeHomeIdPageGetData,
  ListHomeAssetsPageApiAssetsHomeHomeIdPageGetErrors,
  ListHomeAssetsPageApiAssetsHomeHomeIdPageGetResponses,
  ListHomeEventsApiScheduleHomeHomeIdEventsGetData,
  ListHomeEventsApiScheduleHomeHomeIdEventsGetErrors,
  ListHomeEventsApiScheduleHomeHomeIdEventsGetResponses,
  ListImportsApiFinanceBankStatementsProfilesProfileIdImportsGetData,
  ListImportsApiFinanceBankStatementsProfilesProfileIdImportsGetErrors,
  ListImportsApiFinanceBankStatementsProfilesProfileIdImportsGetResponses,
  ListIntegrationsApiIntegrationHomeHomeIdGetData,
  ListIntegrationsApiIntegrationHomeHomeIdGetErrors,
  ListIntegrationsApiIntegrationHomeHomeIdGetResponses,
  ListPayoutImportsApiIntegrationIntegrationIdPayoutsGetData,
  ListPayoutImportsApiIntegrationIntegrationIdPayoutsGetErrors,
  ListPayoutImportsApiIntegrationIntegrationIdPayoutsGetResponses,
  ListProfilesApiFinanceBankStatementsProfilesHomeHomeIdGetData,
  ListProfilesApiFinanceBankStatementsProfilesHomeHomeIdGetErrors,
  ListProfilesApiFinanceBankStatementsProfilesHomeHomeIdGetResponses,
  MarkExpensePaidApiFinanceExpensesExpenseIdPayPostData,
  MarkExpensePaidApiFinanceExpensesExpenseIdPayPostErrors,
  MarkExpensePaidApiFinanceExpensesExpenseIdPayPostResponses,
  MarkGroupReadApiActivityGroupsGroupIdReadPostData,
  MarkGroupReadApiActivityGroupsGroupIdReadPostErrors,
  MarkGroupReadApiActivityGroupsGroupIdReadPostResponses,
  MarkHomeReadApiActivityHomesHomeIdReadPostData,
  MarkHomeReadApiActivityHomesHomeIdReadPostErrors,
  MarkHomeReadApiActivityHomesHomeIdReadPostResponses,
  MarkNotificationAsReadApiNotificationNotificationsNotificationIdReadPatchData,
  MarkNotificationAsReadApiNotificationNotificationsNotificationIdReadPatchErrors,
  MarkNotificationAsReadApiNotificationNotificationsNotificationIdReadPatchResponses,
  MarkSettlementPaidApiFinanceSettlementsSettlementIdMarkPaidPostData,
  MarkSettlementPaidApiFinanceSettlementsSettlementIdMarkPaidPostErrors,
  MarkSettlementPaidApiFinanceSettlementsSettlementIdMarkPaidPostResponses,
  MatchDepositApiFinanceBankStatementsTransactionsTransactionIdMatchDepositPostData,
  MatchDepositApiFinanceBankStatementsTransactionsTransactionIdMatchDepositPostErrors,
  MatchDepositApiFinanceBankStatementsTransactionsTransactionIdMatchDepositPostResponses,
  MatchExpenseApiFinanceBankStatementsTransactionsTransactionIdMatchExpensePostData,
  MatchExpenseApiFinanceBankStatementsTransactionsTransactionIdMatchExpensePostErrors,
  MatchExpenseApiFinanceBankStatementsTransactionsTransactionIdMatchExpensePostResponses,
  PreviewAirbnbFeedApiIntegrationHomeHomeIdAirbnbPreviewPostData,
  PreviewAirbnbFeedApiIntegrationHomeHomeIdAirbnbPreviewPostErrors,
  PreviewAirbnbFeedApiIntegrationHomeHomeIdAirbnbPreviewPostResponses,
  PreviewPayoutCsvApiIntegrationIntegrationIdPayoutsPreviewPostData,
  PreviewPayoutCsvApiIntegrationIntegrationIdPayoutsPreviewPostErrors,
  PreviewPayoutCsvApiIntegrationIntegrationIdPayoutsPreviewPostResponses,
  PreviewStatementApiFinanceBankStatementsProfilesProfileIdPreviewPostData,
  PreviewStatementApiFinanceBankStatementsProfilesProfileIdPreviewPostErrors,
  PreviewStatementApiFinanceBankStatementsProfilesProfileIdPreviewPostResponses,
  RecordSettlePlanPaymentApiFinanceBalancesHomeHomeIdSettlePlanRecordPostData,
  RecordSettlePlanPaymentApiFinanceBalancesHomeHomeIdSettlePlanRecordPostErrors,
  RecordSettlePlanPaymentApiFinanceBalancesHomeHomeIdSettlePlanRecordPostResponses,
  RefreshSessionApiAuthRefreshPostData,
  RefreshSessionApiAuthRefreshPostErrors,
  RefreshSessionApiAuthRefreshPostResponses,
  RemoveAssetImageApiAssetsAssetIdImageDeleteData,
  RemoveAssetImageApiAssetsAssetIdImageDeleteErrors,
  RemoveAssetImageApiAssetsAssetIdImageDeleteResponses,
  RemoveGroupCoverApiExploreGroupsGroupIdCoverDeleteData,
  RemoveGroupCoverApiExploreGroupsGroupIdCoverDeleteErrors,
  RemoveGroupCoverApiExploreGroupsGroupIdCoverDeleteResponses,
  RemoveHomeCoverApiHomeHomeIdCoverDeleteData,
  RemoveHomeCoverApiHomeHomeIdCoverDeleteErrors,
  RemoveHomeCoverApiHomeHomeIdCoverDeleteResponses,
  RemoveMemberApiExploreMembersMemberIdDeleteData,
  RemoveMemberApiExploreMembersMemberIdDeleteErrors,
  RemoveMemberApiExploreMembersMemberIdDeleteResponses,
  ResendConfirmationEmailApiAuthResendConfirmationPostData,
  ResendConfirmationEmailApiAuthResendConfirmationPostErrors,
  ResendConfirmationEmailApiAuthResendConfirmationPostResponses,
  ResendHomeInviteApiHomeHomeInvitesInviteIdResendPostData,
  ResendHomeInviteApiHomeHomeInvitesInviteIdResendPostErrors,
  ResendHomeInviteApiHomeHomeInvitesInviteIdResendPostResponses,
  ResendInviteApiExploreInvitesInviteIdResendPostData,
  ResendInviteApiExploreInvitesInviteIdResendPostErrors,
  ResendInviteApiExploreInvitesInviteIdResendPostResponses,
  ResetPasswordApiAuthResetPasswordPostData,
  ResetPasswordApiAuthResetPasswordPostErrors,
  ResetPasswordApiAuthResetPasswordPostResponses,
  ResetTransactionApiFinanceBankStatementsTransactionsTransactionIdResetPostData,
  ResetTransactionApiFinanceBankStatementsTransactionsTransactionIdResetPostErrors,
  ResetTransactionApiFinanceBankStatementsTransactionsTransactionIdResetPostResponses,
  RetryExtractionJobApiExtractionHomesHomeIdJobsJobIdRetryPostData,
  RetryExtractionJobApiExtractionHomesHomeIdJobsJobIdRetryPostErrors,
  RetryExtractionJobApiExtractionHomesHomeIdJobsJobIdRetryPostResponses,
  RotateExportTokenApiIntegrationIntegrationIdRotateTokenPostData,
  RotateExportTokenApiIntegrationIntegrationIdRotateTokenPostErrors,
  RotateExportTokenApiIntegrationIntegrationIdRotateTokenPostResponses,
  RotateMyCalendarTokenApiIntegrationMeCalendarRotatePostData,
  RotateMyCalendarTokenApiIntegrationMeCalendarRotatePostErrors,
  RotateMyCalendarTokenApiIntegrationMeCalendarRotatePostResponses,
  SendNotificationToAllUsersApiNotificationSendAllUsersPostData,
  SendNotificationToAllUsersApiNotificationSendAllUsersPostErrors,
  SendNotificationToAllUsersApiNotificationSendAllUsersPostResponses,
  SendNotificationToHomeMembersApiNotificationSendHomeMembersPostData,
  SendNotificationToHomeMembersApiNotificationSendHomeMembersPostErrors,
  SendNotificationToHomeMembersApiNotificationSendHomeMembersPostResponses,
  SendNotificationToUserApiNotificationSendUserPostData,
  SendNotificationToUserApiNotificationSendUserPostErrors,
  SendNotificationToUserApiNotificationSendUserPostResponses,
  SettleExpenseFromLedgerApiFinanceLedgerHomeIdSettlePostData,
  SettleExpenseFromLedgerApiFinanceLedgerHomeIdSettlePostErrors,
  SettleExpenseFromLedgerApiFinanceLedgerHomeIdSettlePostResponses,
  SignInApiAuthSigninPostData,
  SignInApiAuthSigninPostErrors,
  SignInApiAuthSigninPostResponses,
  SignInWithIdTokenApiAuthIdTokenPostData,
  SignInWithIdTokenApiAuthIdTokenPostErrors,
  SignInWithIdTokenApiAuthIdTokenPostResponses,
  SignOutApiAuthSignoutPostData,
  SignOutApiAuthSignoutPostErrors,
  SignOutApiAuthSignoutPostResponses,
  SignUpApiAuthSignupPostData,
  SignUpApiAuthSignupPostErrors,
  SignUpApiAuthSignupPostResponses,
  SplitExpenseApiFinanceExpensesExpenseIdSplitPostData,
  SplitExpenseApiFinanceExpensesExpenseIdSplitPostErrors,
  SplitExpenseApiFinanceExpensesExpenseIdSplitPostResponses,
  StripeWebhookApiBillingWebhooksStripePostData,
  StripeWebhookApiBillingWebhooksStripePostErrors,
  StripeWebhookApiBillingWebhooksStripePostResponses,
  SuggestEmailAliasApiNotificationEmailAliasesSuggestionGetData,
  SuggestEmailAliasApiNotificationEmailAliasesSuggestionGetErrors,
  SuggestEmailAliasApiNotificationEmailAliasesSuggestionGetResponses,
  SyncIntegrationApiIntegrationIntegrationIdSyncPostData,
  SyncIntegrationApiIntegrationIntegrationIdSyncPostErrors,
  SyncIntegrationApiIntegrationIntegrationIdSyncPostResponses,
  TransferBetweenAccountsApiFinanceLedgerHomeIdTransferPostData,
  TransferBetweenAccountsApiFinanceLedgerHomeIdTransferPostErrors,
  TransferBetweenAccountsApiFinanceLedgerHomeIdTransferPostResponses,
  UnlinkAssetDocumentApiAssetsAssetIdDocumentsDocumentIdDeleteData,
  UnlinkAssetDocumentApiAssetsAssetIdDocumentsDocumentIdDeleteErrors,
  UnlinkAssetDocumentApiAssetsAssetIdDocumentsDocumentIdDeleteResponses,
  UpdateAssetApiAssetsAssetIdPatchData,
  UpdateAssetApiAssetsAssetIdPatchErrors,
  UpdateAssetApiAssetsAssetIdPatchResponses,
  UpdateCommentApiExploreCommentsCommentIdPatchData,
  UpdateCommentApiExploreCommentsCommentIdPatchErrors,
  UpdateCommentApiExploreCommentsCommentIdPatchResponses,
  UpdateCurrentUserProfileApiAuthMePatchData,
  UpdateCurrentUserProfileApiAuthMePatchErrors,
  UpdateCurrentUserProfileApiAuthMePatchResponses,
  UpdateCurrentUserProfileApiAuthMePutData,
  UpdateCurrentUserProfileApiAuthMePutErrors,
  UpdateCurrentUserProfileApiAuthMePutResponses,
  UpdateDocumentApiDocumentDocumentIdPatchData,
  UpdateDocumentApiDocumentDocumentIdPatchErrors,
  UpdateDocumentApiDocumentDocumentIdPatchResponses,
  UpdateDocumentCategoryApiDocumentCategoriesCategoryIdPatchData,
  UpdateDocumentCategoryApiDocumentCategoriesCategoryIdPatchErrors,
  UpdateDocumentCategoryApiDocumentCategoriesCategoryIdPatchResponses,
  UpdateExpenseApiFinanceExpensesExpenseIdPutData,
  UpdateExpenseApiFinanceExpensesExpenseIdPutErrors,
  UpdateExpenseApiFinanceExpensesExpenseIdPutResponses,
  UpdateExpenseCategoryApiFinanceExpensesCategoriesCategoryIdPatchData,
  UpdateExpenseCategoryApiFinanceExpensesCategoriesCategoryIdPatchErrors,
  UpdateExpenseCategoryApiFinanceExpensesCategoriesCategoryIdPatchResponses,
  UpdateGroupApiExploreGroupsGroupIdPatchData,
  UpdateGroupApiExploreGroupsGroupIdPatchErrors,
  UpdateGroupApiExploreGroupsGroupIdPatchResponses,
  UpdateGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdPutData,
  UpdateGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdPutErrors,
  UpdateGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdPutResponses,
  UpdateHomeApiHomeHomeIdPutData,
  UpdateHomeApiHomeHomeIdPutErrors,
  UpdateHomeApiHomeHomeIdPutResponses,
  UpdateHomeEventApiScheduleEventsEventIdPatchData,
  UpdateHomeEventApiScheduleEventsEventIdPatchErrors,
  UpdateHomeEventApiScheduleEventsEventIdPatchResponses,
  UpdateHomeInviteApiHomeHomeInvitesInviteIdPatchData,
  UpdateHomeInviteApiHomeHomeInvitesInviteIdPatchErrors,
  UpdateHomeInviteApiHomeHomeInvitesInviteIdPatchResponses,
  UpdateHomeInviteShareApiHomeHomeInvitesInviteIdSharePatchData,
  UpdateHomeInviteShareApiHomeHomeInvitesInviteIdSharePatchErrors,
  UpdateHomeInviteShareApiHomeHomeInvitesInviteIdSharePatchResponses,
  UpdateHomeMembershipsApiHomeHomeIdMembershipsPatchData,
  UpdateHomeMembershipsApiHomeHomeIdMembershipsPatchErrors,
  UpdateHomeMembershipsApiHomeHomeIdMembershipsPatchResponses,
  UpdateHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdPutData,
  UpdateHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdPutErrors,
  UpdateHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdPutResponses,
  UpdateIntegrationApiIntegrationIntegrationIdPatchData,
  UpdateIntegrationApiIntegrationIntegrationIdPatchErrors,
  UpdateIntegrationApiIntegrationIntegrationIdPatchResponses,
  UpdateInviteApiExploreInvitesInviteIdPatchData,
  UpdateInviteApiExploreInvitesInviteIdPatchErrors,
  UpdateInviteApiExploreInvitesInviteIdPatchResponses,
  UpdateListingApiExploreListingsListingIdPatchData,
  UpdateListingApiExploreListingsListingIdPatchErrors,
  UpdateListingApiExploreListingsListingIdPatchResponses,
  UpdateListingVisitApiExploreVisitsVisitIdPatchData,
  UpdateListingVisitApiExploreVisitsVisitIdPatchErrors,
  UpdateListingVisitApiExploreVisitsVisitIdPatchResponses,
  UpdateListingVisitNoteApiExploreVisitNotesNoteIdPatchData,
  UpdateListingVisitNoteApiExploreVisitNotesNoteIdPatchErrors,
  UpdateListingVisitNoteApiExploreVisitNotesNoteIdPatchResponses,
  UpdateMemberApiExploreMembersMemberIdPatchData,
  UpdateMemberApiExploreMembersMemberIdPatchErrors,
  UpdateMemberApiExploreMembersMemberIdPatchResponses,
  UpdateMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthPutData,
  UpdateMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthPutErrors,
  UpdateMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthPutResponses,
  UpdateNotificationPreferencesApiNotificationPreferencesPutData,
  UpdateNotificationPreferencesApiNotificationPreferencesPutErrors,
  UpdateNotificationPreferencesApiNotificationPreferencesPutResponses,
  UpdateProfileApiFinanceBankStatementsProfilesProfileIdPatchData,
  UpdateProfileApiFinanceBankStatementsProfilesProfileIdPatchErrors,
  UpdateProfileApiFinanceBankStatementsProfilesProfileIdPatchResponses,
  UpdateRecurringExpenseApiFinanceExpensesRecurringRecurringIdPutData,
  UpdateRecurringExpenseApiFinanceExpensesRecurringRecurringIdPutErrors,
  UpdateRecurringExpenseApiFinanceExpensesRecurringRecurringIdPutResponses,
  UpdateReservationApiBookingReservationIdPatchData,
  UpdateReservationApiBookingReservationIdPatchErrors,
  UpdateReservationApiBookingReservationIdPatchResponses,
  UpdateVoteApiExploreVotesVoteIdPatchData,
  UpdateVoteApiExploreVotesVoteIdPatchErrors,
  UpdateVoteApiExploreVotesVoteIdPatchResponses,
  UploadAssetImageApiAssetsAssetIdImagePostData,
  UploadAssetImageApiAssetsAssetIdImagePostErrors,
  UploadAssetImageApiAssetsAssetIdImagePostResponses,
  UploadCurrentUserAvatarApiAuthMeAvatarPostData,
  UploadCurrentUserAvatarApiAuthMeAvatarPostErrors,
  UploadCurrentUserAvatarApiAuthMeAvatarPostResponses,
  UploadDocumentApiDocumentUploadPostData,
  UploadDocumentApiDocumentUploadPostErrors,
  UploadDocumentApiDocumentUploadPostResponses,
  UploadGroupCoverApiExploreGroupsGroupIdCoverPostData,
  UploadGroupCoverApiExploreGroupsGroupIdCoverPostErrors,
  UploadGroupCoverApiExploreGroupsGroupIdCoverPostResponses,
  UploadHomeCoverApiHomeHomeIdCoverPostData,
  UploadHomeCoverApiHomeHomeIdCoverPostErrors,
  UploadHomeCoverApiHomeHomeIdCoverPostResponses,
  UploadListingPhotoApiExploreListingsListingIdPhotosUploadPostData,
  UploadListingPhotoApiExploreListingsListingIdPhotosUploadPostErrors,
  UploadListingPhotoApiExploreListingsListingIdPhotosUploadPostResponses,
  UploadListingVisitNotePhotoApiExploreVisitNotesNoteIdPhotosUploadPostData,
  UploadListingVisitNotePhotoApiExploreVisitNotesNoteIdPhotosUploadPostErrors,
  UploadListingVisitNotePhotoApiExploreVisitNotesNoteIdPhotosUploadPostResponses,
  UpsertMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesPutData,
  UpsertMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesPutErrors,
  UpsertMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesPutResponses,
  VerifyEmailApiAuthVerifyEmailPostData,
  VerifyEmailApiAuthVerifyEmailPostErrors,
  VerifyEmailApiAuthVerifyEmailPostResponses,
  VoteOnReservationApiBookingReservationIdVotePostData,
  VoteOnReservationApiBookingReservationIdVotePostErrors,
  VoteOnReservationApiBookingReservationIdVotePostResponses,
  WelcomeGetData,
  WelcomeGetResponses,
  WithdrawFromLedgerApiFinanceLedgerHomeIdWithdrawPostData,
  WithdrawFromLedgerApiFinanceLedgerHomeIdWithdrawPostErrors,
  WithdrawFromLedgerApiFinanceLedgerHomeIdWithdrawPostResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Welcome
 */
export const welcomeGet = <ThrowOnError extends boolean = false>(
  options?: Options<WelcomeGetData, ThrowOnError>,
): RequestResult<WelcomeGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<WelcomeGetResponses, unknown, ThrowOnError>({
    url: "/",
    ...options,
  });

/**
 * Create Home
 *
 * Create a new in-progress home.
 */
export const createHomeApiHomeHomesPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CreateHomeApiHomeHomesPostData, ThrowOnError>,
): RequestResult<
  CreateHomeApiHomeHomesPostResponses,
  CreateHomeApiHomeHomesPostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    CreateHomeApiHomeHomesPostResponses,
    CreateHomeApiHomeHomesPostErrors,
    ThrowOnError
  >({ url: "/api/home/homes", ...options });

/**
 * Get Current Home
 *
 * Get the current user's in-progress home if it exists.
 */
export const getCurrentHomeApiHomeHomesCurrentGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCurrentHomeApiHomeHomesCurrentGetData, ThrowOnError>,
): RequestResult<
  GetCurrentHomeApiHomeHomesCurrentGetResponses,
  GetCurrentHomeApiHomeHomesCurrentGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetCurrentHomeApiHomeHomesCurrentGetResponses,
    GetCurrentHomeApiHomeHomesCurrentGetErrors,
    ThrowOnError
  >({ url: "/api/home/homes/current", ...options });

/**
 * Delete Draft Home
 *
 * Delete an in-progress home.
 */
export const deleteDraftHomeApiHomeHomesHomeIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteDraftHomeApiHomeHomesHomeIdDeleteData, ThrowOnError>,
): RequestResult<
  DeleteDraftHomeApiHomeHomesHomeIdDeleteResponses,
  DeleteDraftHomeApiHomeHomesHomeIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteDraftHomeApiHomeHomesHomeIdDeleteResponses,
    DeleteDraftHomeApiHomeHomesHomeIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/home/homes/{home_id}", ...options });

/**
 * Get Draft Home
 *
 * Get a specific in-progress home by id.
 */
export const getDraftHomeApiHomeHomesHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDraftHomeApiHomeHomesHomeIdGetData, ThrowOnError>,
): RequestResult<
  GetDraftHomeApiHomeHomesHomeIdGetResponses,
  GetDraftHomeApiHomeHomesHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetDraftHomeApiHomeHomesHomeIdGetResponses,
    GetDraftHomeApiHomeHomesHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/home/homes/{home_id}", ...options });

/**
 * Activate Home
 *
 * Activate an in-progress home after validation.
 */
export const activateHomeApiHomeHomesHomeIdActivatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ActivateHomeApiHomeHomesHomeIdActivatePostData,
    ThrowOnError
  >,
): RequestResult<
  ActivateHomeApiHomeHomesHomeIdActivatePostResponses,
  ActivateHomeApiHomeHomesHomeIdActivatePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ActivateHomeApiHomeHomesHomeIdActivatePostResponses,
    ActivateHomeApiHomeHomesHomeIdActivatePostErrors,
    ThrowOnError
  >({
    url: "/api/home/homes/{home_id}/activate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Home Types
 *
 * List all available home type categories (e.g., house, condo, cabin).
 */
export const getHomeTypesApiHomeTypesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetHomeTypesApiHomeTypesGetData, ThrowOnError>,
): RequestResult<GetHomeTypesApiHomeTypesGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetHomeTypesApiHomeTypesGetResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/home/types", ...options });

/**
 * Get Homes
 *
 * List completed homes (excludes drafts) where the current user has an active membership.
 */
export const getHomesApiHomeGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomesApiHomeGetData, ThrowOnError>,
): RequestResult<
  GetHomesApiHomeGetResponses,
  GetHomesApiHomeGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetHomesApiHomeGetResponses,
    GetHomesApiHomeGetErrors,
    ThrowOnError
  >({ url: "/api/home/", ...options });

/**
 * Get Home By Id
 *
 * Get a specific home by ID. Requires read access on the home.
 *
 * Deliberately NOT gated on ``home_active``: this is the shell fetch the FE
 * needs to render the home's settings layout, and therefore the Plan &
 * Billing page where a lapsed home re-subscribes. Gating it deadlocked the
 * upgrade path — the 402 upsell sent the user to a page whose own layout
 * fetch 402'd again. It also protected nothing: ``GET /homes`` returns the
 * identical payload for every home the caller belongs to and is un-gated.
 * Everything a plan actually pays for (dashboard, members, updates, and the
 * booking/document/finance/maintenance routers) stays gated below.
 */
export const getHomeByIdApiHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetHomeByIdApiHomeHomeIdGetData, ThrowOnError>,
): RequestResult<
  GetHomeByIdApiHomeHomeIdGetResponses,
  GetHomeByIdApiHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeByIdApiHomeHomeIdGetResponses,
    GetHomeByIdApiHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/home/{home_id}", ...options });

/**
 * Update Home
 *
 * Update home details. Requires the owner role on the home.
 *
 * Gated on ``home_active`` only once the home is activated — onboarding writes
 * the draft's details through this route before any subscription exists.
 */
export const updateHomeApiHomeHomeIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateHomeApiHomeHomeIdPutData, ThrowOnError>,
): RequestResult<
  UpdateHomeApiHomeHomeIdPutResponses,
  UpdateHomeApiHomeHomeIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateHomeApiHomeHomeIdPutResponses,
    UpdateHomeApiHomeHomeIdPutErrors,
    ThrowOnError
  >({
    url: "/api/home/{home_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Home Workspace Events
 *
 * Stream background-work changes for the active Manage workspace.
 */
export const homeWorkspaceEventsApiHomeHomeIdEventsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<HomeWorkspaceEventsApiHomeHomeIdEventsGetData, ThrowOnError>,
): RequestResult<
  HomeWorkspaceEventsApiHomeHomeIdEventsGetResponses,
  HomeWorkspaceEventsApiHomeHomeIdEventsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    HomeWorkspaceEventsApiHomeHomeIdEventsGetResponses,
    HomeWorkspaceEventsApiHomeHomeIdEventsGetErrors,
    ThrowOnError
  >({ url: "/api/home/{home_id}/events", ...options });

/**
 * Remove Home Cover
 *
 * Remove a home's cover photo. Best-effort deletes the stored object.
 * Requires the owner role on the home.
 */
export const removeHomeCoverApiHomeHomeIdCoverDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RemoveHomeCoverApiHomeHomeIdCoverDeleteData, ThrowOnError>,
): RequestResult<
  RemoveHomeCoverApiHomeHomeIdCoverDeleteResponses,
  RemoveHomeCoverApiHomeHomeIdCoverDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RemoveHomeCoverApiHomeHomeIdCoverDeleteResponses,
    RemoveHomeCoverApiHomeHomeIdCoverDeleteErrors,
    ThrowOnError
  >({ url: "/api/home/{home_id}/cover", ...options });

/**
 * Upload Home Cover
 *
 * Upload and set a home's cover photo. The image is shrunk server-side and
 * stored in object storage; only the resulting public URL is persisted on the
 * home. Requires the owner role on the home.
 */
export const uploadHomeCoverApiHomeHomeIdCoverPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadHomeCoverApiHomeHomeIdCoverPostData, ThrowOnError>,
): RequestResult<
  UploadHomeCoverApiHomeHomeIdCoverPostResponses,
  UploadHomeCoverApiHomeHomeIdCoverPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadHomeCoverApiHomeHomeIdCoverPostResponses,
    UploadHomeCoverApiHomeHomeIdCoverPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/home/{home_id}/cover",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Get Home Members
 *
 * List members for a home. Requires read access on the home.
 */
export const getHomeMembersApiHomeHomeIdMembersGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetHomeMembersApiHomeHomeIdMembersGetData, ThrowOnError>,
): RequestResult<
  GetHomeMembersApiHomeHomeIdMembersGetResponses,
  GetHomeMembersApiHomeHomeIdMembersGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeMembersApiHomeHomeIdMembersGetResponses,
    GetHomeMembersApiHomeHomeIdMembersGetErrors,
    ThrowOnError
  >({ url: "/api/home/{home_id}/members", ...options });

/**
 * Get Home Dashboard
 *
 * Get the unified dashboard view for a home. Requires read access.
 */
export const getHomeDashboardApiHomeHomeIdDashboardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetHomeDashboardApiHomeHomeIdDashboardGetData, ThrowOnError>,
): RequestResult<
  GetHomeDashboardApiHomeHomeIdDashboardGetResponses,
  GetHomeDashboardApiHomeHomeIdDashboardGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeDashboardApiHomeHomeIdDashboardGetResponses,
    GetHomeDashboardApiHomeHomeIdDashboardGetErrors,
    ThrowOnError
  >({ url: "/api/home/{home_id}/dashboard", ...options });

/**
 * Update Home Memberships
 *
 * Update ownership shares for a home. Must maintain 100% total ownership, so
 * the whole set is sent at once rather than one member at a time.
 * Requires manage_members permission on the home.
 */
export const updateHomeMembershipsApiHomeHomeIdMembershipsPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateHomeMembershipsApiHomeHomeIdMembershipsPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateHomeMembershipsApiHomeHomeIdMembershipsPatchResponses,
  UpdateHomeMembershipsApiHomeHomeIdMembershipsPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateHomeMembershipsApiHomeHomeIdMembershipsPatchResponses,
    UpdateHomeMembershipsApiHomeHomeIdMembershipsPatchErrors,
    ThrowOnError
  >({
    url: "/api/home/{home_id}/memberships",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get User Home Invites
 *
 * List all pending home invites for the current user. Service filters
 * by user; no per-domain Casbin check applies.
 */
export const getUserHomeInvitesApiHomeHomeInvitesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUserHomeInvitesApiHomeHomeInvitesGetData, ThrowOnError>,
): RequestResult<
  GetUserHomeInvitesApiHomeHomeInvitesGetResponses,
  GetUserHomeInvitesApiHomeHomeInvitesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUserHomeInvitesApiHomeHomeInvitesGetResponses,
    GetUserHomeInvitesApiHomeHomeInvitesGetErrors,
    ThrowOnError
  >({ url: "/api/home/home-invites", ...options });

/**
 * Get Home Invites
 *
 * List all invites for a home (requires home membership).
 */
export const getHomeInvitesApiHomeHomesHomeIdInvitesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHomeInvitesApiHomeHomesHomeIdInvitesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetHomeInvitesApiHomeHomesHomeIdInvitesGetResponses,
  GetHomeInvitesApiHomeHomesHomeIdInvitesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeInvitesApiHomeHomesHomeIdInvitesGetResponses,
    GetHomeInvitesApiHomeHomesHomeIdInvitesGetErrors,
    ThrowOnError
  >({ url: "/api/home/homes/{home_id}/invites", ...options });

/**
 * Create Home Invite
 *
 * Send an invitation to join a home (owner only).
 */
export const createHomeInviteApiHomeHomesHomeIdInvitesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateHomeInviteApiHomeHomesHomeIdInvitesPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateHomeInviteApiHomeHomesHomeIdInvitesPostResponses,
  CreateHomeInviteApiHomeHomesHomeIdInvitesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateHomeInviteApiHomeHomesHomeIdInvitesPostResponses,
    CreateHomeInviteApiHomeHomesHomeIdInvitesPostErrors,
    ThrowOnError
  >({
    url: "/api/home/homes/{home_id}/invites",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Home Invite
 *
 * Update an invite status. Authorization is service-driven: an invitee
 * can accept/reject without home membership; revoke is gated by service-
 * level role check on the invite's home.
 */
export const updateHomeInviteApiHomeHomeInvitesInviteIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateHomeInviteApiHomeHomeInvitesInviteIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateHomeInviteApiHomeHomeInvitesInviteIdPatchResponses,
  UpdateHomeInviteApiHomeHomeInvitesInviteIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateHomeInviteApiHomeHomeInvitesInviteIdPatchResponses,
    UpdateHomeInviteApiHomeHomeInvitesInviteIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/home/home-invites/{invite_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Home Invite Share
 *
 * Update the share percentage of a home invite. Service enforces
 * inviter/owner-only access.
 */
export const updateHomeInviteShareApiHomeHomeInvitesInviteIdSharePatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateHomeInviteShareApiHomeHomeInvitesInviteIdSharePatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateHomeInviteShareApiHomeHomeInvitesInviteIdSharePatchResponses,
  UpdateHomeInviteShareApiHomeHomeInvitesInviteIdSharePatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateHomeInviteShareApiHomeHomeInvitesInviteIdSharePatchResponses,
    UpdateHomeInviteShareApiHomeHomeInvitesInviteIdSharePatchErrors,
    ThrowOnError
  >({
    url: "/api/home/home-invites/{invite_id}/share",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Resend Home Invite
 *
 * Resend a home invitation email. Service enforces owner/manager-only
 * access.
 */
export const resendHomeInviteApiHomeHomeInvitesInviteIdResendPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResendHomeInviteApiHomeHomeInvitesInviteIdResendPostData,
    ThrowOnError
  >,
): RequestResult<
  ResendHomeInviteApiHomeHomeInvitesInviteIdResendPostResponses,
  ResendHomeInviteApiHomeHomeInvitesInviteIdResendPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ResendHomeInviteApiHomeHomeInvitesInviteIdResendPostResponses,
    ResendHomeInviteApiHomeHomeInvitesInviteIdResendPostErrors,
    ThrowOnError
  >({ url: "/api/home/home-invites/{invite_id}/resend", ...options });

/**
 * Accept Home Invite Public
 *
 * Accept a home invite using a public signed token (no auth required).
 */
export const acceptHomeInvitePublicApiHomeHomeInvitesTokenAcceptPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AcceptHomeInvitePublicApiHomeHomeInvitesTokenAcceptPostData,
    ThrowOnError
  >,
): RequestResult<
  AcceptHomeInvitePublicApiHomeHomeInvitesTokenAcceptPostResponses,
  AcceptHomeInvitePublicApiHomeHomeInvitesTokenAcceptPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AcceptHomeInvitePublicApiHomeHomeInvitesTokenAcceptPostResponses,
    AcceptHomeInvitePublicApiHomeHomeInvitesTokenAcceptPostErrors,
    ThrowOnError
  >({
    url: "/api/home/home-invites/token/accept",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Decline Home Invite Public
 *
 * Decline a home invite using a public signed token (no auth required).
 */
export const declineHomeInvitePublicApiHomeHomeInvitesTokenDeclinePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeclineHomeInvitePublicApiHomeHomeInvitesTokenDeclinePostData,
    ThrowOnError
  >,
): RequestResult<
  DeclineHomeInvitePublicApiHomeHomeInvitesTokenDeclinePostResponses,
  DeclineHomeInvitePublicApiHomeHomeInvitesTokenDeclinePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeclineHomeInvitePublicApiHomeHomeInvitesTokenDeclinePostResponses,
    DeclineHomeInvitePublicApiHomeHomeInvitesTokenDeclinePostErrors,
    ThrowOnError
  >({
    url: "/api/home/home-invites/token/decline",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Reservations
 *
 * List reservations for a home, optionally filtered by date range.
 */
export const getReservationsApiBookingHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetReservationsApiBookingHomeHomeIdGetData, ThrowOnError>,
): RequestResult<
  GetReservationsApiBookingHomeHomeIdGetResponses,
  GetReservationsApiBookingHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetReservationsApiBookingHomeHomeIdGetResponses,
    GetReservationsApiBookingHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/booking/home/{home_id}", ...options });

/**
 * Get Fair Use
 *
 * Per-owner nights used vs allotted fair-use share for the current year.
 */
export const getFairUseApiBookingHomeHomeIdFairUseGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFairUseApiBookingHomeHomeIdFairUseGetData, ThrowOnError>,
): RequestResult<
  GetFairUseApiBookingHomeHomeIdFairUseGetResponses,
  GetFairUseApiBookingHomeHomeIdFairUseGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFairUseApiBookingHomeHomeIdFairUseGetResponses,
    GetFairUseApiBookingHomeHomeIdFairUseGetErrors,
    ThrowOnError
  >({ url: "/api/booking/home/{home_id}/fair-use", ...options });

/**
 * Get Open Windows
 *
 * Bookable gaps between reservations within the horizon.
 */
export const getOpenWindowsApiBookingHomeHomeIdOpenWindowsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOpenWindowsApiBookingHomeHomeIdOpenWindowsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetOpenWindowsApiBookingHomeHomeIdOpenWindowsGetResponses,
  GetOpenWindowsApiBookingHomeHomeIdOpenWindowsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOpenWindowsApiBookingHomeHomeIdOpenWindowsGetResponses,
    GetOpenWindowsApiBookingHomeHomeIdOpenWindowsGetErrors,
    ThrowOnError
  >({ url: "/api/booking/home/{home_id}/open-windows", ...options });

/**
 * Get Requests
 *
 * Pending reservations awaiting a group vote, with tallies.
 */
export const getRequestsApiBookingHomeHomeIdRequestsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRequestsApiBookingHomeHomeIdRequestsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetRequestsApiBookingHomeHomeIdRequestsGetResponses,
  GetRequestsApiBookingHomeHomeIdRequestsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetRequestsApiBookingHomeHomeIdRequestsGetResponses,
    GetRequestsApiBookingHomeHomeIdRequestsGetErrors,
    ThrowOnError
  >({ url: "/api/booking/home/{home_id}/requests", ...options });

/**
 * Create Reservation
 *
 * Create a new reservation in the home identified by ``reservation.home_id``.
 */
export const createReservationApiBookingPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateReservationApiBookingPostData, ThrowOnError>,
): RequestResult<
  CreateReservationApiBookingPostResponses,
  CreateReservationApiBookingPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateReservationApiBookingPostResponses,
    CreateReservationApiBookingPostErrors,
    ThrowOnError
  >({
    url: "/api/booking/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Reservation
 *
 * Delete a reservation.
 */
export const deleteReservationApiBookingReservationIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteReservationApiBookingReservationIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  DeleteReservationApiBookingReservationIdDeleteResponses,
  DeleteReservationApiBookingReservationIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteReservationApiBookingReservationIdDeleteResponses,
    DeleteReservationApiBookingReservationIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/booking/{reservation_id}", ...options });

/**
 * Get Reservation
 *
 * Get a specific reservation by ID.
 */
export const getReservationApiBookingReservationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetReservationApiBookingReservationIdGetData, ThrowOnError>,
): RequestResult<
  GetReservationApiBookingReservationIdGetResponses,
  GetReservationApiBookingReservationIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetReservationApiBookingReservationIdGetResponses,
    GetReservationApiBookingReservationIdGetErrors,
    ThrowOnError
  >({ url: "/api/booking/{reservation_id}", ...options });

/**
 * Update Reservation
 *
 * Update an existing reservation.
 */
export const updateReservationApiBookingReservationIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateReservationApiBookingReservationIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateReservationApiBookingReservationIdPatchResponses,
  UpdateReservationApiBookingReservationIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateReservationApiBookingReservationIdPatchResponses,
    UpdateReservationApiBookingReservationIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/booking/{reservation_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Vote On Reservation
 *
 * Cast (or change) the current user's vote on a reservation awaiting approval.
 */
export const voteOnReservationApiBookingReservationIdVotePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    VoteOnReservationApiBookingReservationIdVotePostData,
    ThrowOnError
  >,
): RequestResult<
  VoteOnReservationApiBookingReservationIdVotePostResponses,
  VoteOnReservationApiBookingReservationIdVotePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    VoteOnReservationApiBookingReservationIdVotePostResponses,
    VoteOnReservationApiBookingReservationIdVotePostErrors,
    ThrowOnError
  >({
    url: "/api/booking/{reservation_id}/vote",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Home Schedule
 */
export const getHomeScheduleApiScheduleHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetHomeScheduleApiScheduleHomeHomeIdGetData, ThrowOnError>,
): RequestResult<
  GetHomeScheduleApiScheduleHomeHomeIdGetResponses,
  GetHomeScheduleApiScheduleHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeScheduleApiScheduleHomeHomeIdGetResponses,
    GetHomeScheduleApiScheduleHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/schedule/home/{home_id}", ...options });

/**
 * Get Home Schedule Overview
 */
export const getHomeScheduleOverviewApiScheduleHomeHomeIdOverviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHomeScheduleOverviewApiScheduleHomeHomeIdOverviewGetData,
    ThrowOnError
  >,
): RequestResult<
  GetHomeScheduleOverviewApiScheduleHomeHomeIdOverviewGetResponses,
  GetHomeScheduleOverviewApiScheduleHomeHomeIdOverviewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeScheduleOverviewApiScheduleHomeHomeIdOverviewGetResponses,
    GetHomeScheduleOverviewApiScheduleHomeHomeIdOverviewGetErrors,
    ThrowOnError
  >({ url: "/api/schedule/home/{home_id}/overview", ...options });

/**
 * List Home Events
 */
export const listHomeEventsApiScheduleHomeHomeIdEventsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListHomeEventsApiScheduleHomeHomeIdEventsGetData,
    ThrowOnError
  >,
): RequestResult<
  ListHomeEventsApiScheduleHomeHomeIdEventsGetResponses,
  ListHomeEventsApiScheduleHomeHomeIdEventsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListHomeEventsApiScheduleHomeHomeIdEventsGetResponses,
    ListHomeEventsApiScheduleHomeHomeIdEventsGetErrors,
    ThrowOnError
  >({ url: "/api/schedule/home/{home_id}/events", ...options });

/**
 * Create Home Event
 */
export const createHomeEventApiScheduleHomeHomeIdEventsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateHomeEventApiScheduleHomeHomeIdEventsPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateHomeEventApiScheduleHomeHomeIdEventsPostResponses,
  CreateHomeEventApiScheduleHomeHomeIdEventsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateHomeEventApiScheduleHomeHomeIdEventsPostResponses,
    CreateHomeEventApiScheduleHomeHomeIdEventsPostErrors,
    ThrowOnError
  >({
    url: "/api/schedule/home/{home_id}/events",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Home Event
 */
export const deleteHomeEventApiScheduleEventsEventIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteHomeEventApiScheduleEventsEventIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  DeleteHomeEventApiScheduleEventsEventIdDeleteResponses,
  DeleteHomeEventApiScheduleEventsEventIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteHomeEventApiScheduleEventsEventIdDeleteResponses,
    DeleteHomeEventApiScheduleEventsEventIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/schedule/events/{event_id}", ...options });

/**
 * Get Home Event
 */
export const getHomeEventApiScheduleEventsEventIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetHomeEventApiScheduleEventsEventIdGetData, ThrowOnError>,
): RequestResult<
  GetHomeEventApiScheduleEventsEventIdGetResponses,
  GetHomeEventApiScheduleEventsEventIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeEventApiScheduleEventsEventIdGetResponses,
    GetHomeEventApiScheduleEventsEventIdGetErrors,
    ThrowOnError
  >({ url: "/api/schedule/events/{event_id}", ...options });

/**
 * Update Home Event
 */
export const updateHomeEventApiScheduleEventsEventIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateHomeEventApiScheduleEventsEventIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateHomeEventApiScheduleEventsEventIdPatchResponses,
  UpdateHomeEventApiScheduleEventsEventIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateHomeEventApiScheduleEventsEventIdPatchResponses,
    UpdateHomeEventApiScheduleEventsEventIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/schedule/events/{event_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Maintenance Requests
 *
 * List all maintenance requests (stub; Casbin scoping added when the
 * real listing endpoint takes a home_id).
 */
export const getMaintenanceRequestsApiMaintenanceGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetMaintenanceRequestsApiMaintenanceGetData, ThrowOnError>,
): RequestResult<
  GetMaintenanceRequestsApiMaintenanceGetResponses,
  GetMaintenanceRequestsApiMaintenanceGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetMaintenanceRequestsApiMaintenanceGetResponses,
    GetMaintenanceRequestsApiMaintenanceGetErrors,
    ThrowOnError
  >({ url: "/api/maintenance/", ...options });

/**
 * Get Maintenance Request
 *
 * Get a specific maintenance request by ID (stub; will gain a
 * scope_resolver when the request model is wired up).
 */
export const getMaintenanceRequestApiMaintenanceRequestIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMaintenanceRequestApiMaintenanceRequestIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetMaintenanceRequestApiMaintenanceRequestIdGetResponses,
  GetMaintenanceRequestApiMaintenanceRequestIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMaintenanceRequestApiMaintenanceRequestIdGetResponses,
    GetMaintenanceRequestApiMaintenanceRequestIdGetErrors,
    ThrowOnError
  >({ url: "/api/maintenance/{request_id}", ...options });

/**
 * Get Home Maintenance Requests
 */
export const getHomeMaintenanceRequestsApiMaintenanceHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHomeMaintenanceRequestsApiMaintenanceHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetHomeMaintenanceRequestsApiMaintenanceHomeHomeIdGetResponses,
  GetHomeMaintenanceRequestsApiMaintenanceHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeMaintenanceRequestsApiMaintenanceHomeHomeIdGetResponses,
    GetHomeMaintenanceRequestsApiMaintenanceHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/maintenance/home/{home_id}", ...options });

/**
 * List Asset Categories
 */
export const listAssetCategoriesApiAssetsCategoriesHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListAssetCategoriesApiAssetsCategoriesHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  ListAssetCategoriesApiAssetsCategoriesHomeHomeIdGetResponses,
  ListAssetCategoriesApiAssetsCategoriesHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAssetCategoriesApiAssetsCategoriesHomeHomeIdGetResponses,
    ListAssetCategoriesApiAssetsCategoriesHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/assets/categories/home/{home_id}", ...options });

/**
 * Create Asset Category
 */
export const createAssetCategoryApiAssetsCategoriesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateAssetCategoryApiAssetsCategoriesPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateAssetCategoryApiAssetsCategoriesPostResponses,
  CreateAssetCategoryApiAssetsCategoriesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAssetCategoryApiAssetsCategoriesPostResponses,
    CreateAssetCategoryApiAssetsCategoriesPostErrors,
    ThrowOnError
  >({
    url: "/api/assets/categories",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract And Create Asset
 */
export const extractAndCreateAssetApiAssetsHomeHomeIdExtractPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExtractAndCreateAssetApiAssetsHomeHomeIdExtractPostData,
    ThrowOnError
  >,
): RequestResult<
  ExtractAndCreateAssetApiAssetsHomeHomeIdExtractPostResponses,
  ExtractAndCreateAssetApiAssetsHomeHomeIdExtractPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ExtractAndCreateAssetApiAssetsHomeHomeIdExtractPostResponses,
    ExtractAndCreateAssetApiAssetsHomeHomeIdExtractPostErrors,
    ThrowOnError
  >({
    url: "/api/assets/home/{home_id}/extract",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Home Assets
 */
export const listHomeAssetsApiAssetsHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListHomeAssetsApiAssetsHomeHomeIdGetData, ThrowOnError>,
): RequestResult<
  ListHomeAssetsApiAssetsHomeHomeIdGetResponses,
  ListHomeAssetsApiAssetsHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListHomeAssetsApiAssetsHomeHomeIdGetResponses,
    ListHomeAssetsApiAssetsHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/assets/home/{home_id}", ...options });

/**
 * List Home Assets Page
 */
export const listHomeAssetsPageApiAssetsHomeHomeIdPageGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListHomeAssetsPageApiAssetsHomeHomeIdPageGetData,
    ThrowOnError
  >,
): RequestResult<
  ListHomeAssetsPageApiAssetsHomeHomeIdPageGetResponses,
  ListHomeAssetsPageApiAssetsHomeHomeIdPageGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListHomeAssetsPageApiAssetsHomeHomeIdPageGetResponses,
    ListHomeAssetsPageApiAssetsHomeHomeIdPageGetErrors,
    ThrowOnError
  >({ url: "/api/assets/home/{home_id}/page", ...options });

/**
 * Create Asset
 */
export const createAssetApiAssetsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateAssetApiAssetsPostData, ThrowOnError>,
): RequestResult<
  CreateAssetApiAssetsPostResponses,
  CreateAssetApiAssetsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAssetApiAssetsPostResponses,
    CreateAssetApiAssetsPostErrors,
    ThrowOnError
  >({
    url: "/api/assets/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Asset From Expense
 */
export const getAssetFromExpenseApiAssetsFromExpenseExpenseIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAssetFromExpenseApiAssetsFromExpenseExpenseIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetAssetFromExpenseApiAssetsFromExpenseExpenseIdGetResponses,
  GetAssetFromExpenseApiAssetsFromExpenseExpenseIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAssetFromExpenseApiAssetsFromExpenseExpenseIdGetResponses,
    GetAssetFromExpenseApiAssetsFromExpenseExpenseIdGetErrors,
    ThrowOnError
  >({ url: "/api/assets/from-expense/{expense_id}", ...options });

/**
 * Create Asset From Expense
 */
export const createAssetFromExpenseApiAssetsFromExpenseExpenseIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateAssetFromExpenseApiAssetsFromExpenseExpenseIdPutData,
    ThrowOnError
  >,
): RequestResult<
  CreateAssetFromExpenseApiAssetsFromExpenseExpenseIdPutResponses,
  CreateAssetFromExpenseApiAssetsFromExpenseExpenseIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    CreateAssetFromExpenseApiAssetsFromExpenseExpenseIdPutResponses,
    CreateAssetFromExpenseApiAssetsFromExpenseExpenseIdPutErrors,
    ThrowOnError
  >({
    url: "/api/assets/from-expense/{expense_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract And Update Asset
 */
export const extractAndUpdateAssetApiAssetsAssetIdExtractPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExtractAndUpdateAssetApiAssetsAssetIdExtractPostData,
    ThrowOnError
  >,
): RequestResult<
  ExtractAndUpdateAssetApiAssetsAssetIdExtractPostResponses,
  ExtractAndUpdateAssetApiAssetsAssetIdExtractPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ExtractAndUpdateAssetApiAssetsAssetIdExtractPostResponses,
    ExtractAndUpdateAssetApiAssetsAssetIdExtractPostErrors,
    ThrowOnError
  >({
    url: "/api/assets/{asset_id}/extract",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Asset
 */
export const getAssetApiAssetsAssetIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAssetApiAssetsAssetIdGetData, ThrowOnError>,
): RequestResult<
  GetAssetApiAssetsAssetIdGetResponses,
  GetAssetApiAssetsAssetIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAssetApiAssetsAssetIdGetResponses,
    GetAssetApiAssetsAssetIdGetErrors,
    ThrowOnError
  >({ url: "/api/assets/{asset_id}", ...options });

/**
 * Update Asset
 */
export const updateAssetApiAssetsAssetIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateAssetApiAssetsAssetIdPatchData, ThrowOnError>,
): RequestResult<
  UpdateAssetApiAssetsAssetIdPatchResponses,
  UpdateAssetApiAssetsAssetIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAssetApiAssetsAssetIdPatchResponses,
    UpdateAssetApiAssetsAssetIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/assets/{asset_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove Asset Image
 */
export const removeAssetImageApiAssetsAssetIdImageDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RemoveAssetImageApiAssetsAssetIdImageDeleteData,
    ThrowOnError
  >,
): RequestResult<
  RemoveAssetImageApiAssetsAssetIdImageDeleteResponses,
  RemoveAssetImageApiAssetsAssetIdImageDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RemoveAssetImageApiAssetsAssetIdImageDeleteResponses,
    RemoveAssetImageApiAssetsAssetIdImageDeleteErrors,
    ThrowOnError
  >({ url: "/api/assets/{asset_id}/image", ...options });

/**
 * Upload Asset Image
 */
export const uploadAssetImageApiAssetsAssetIdImagePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadAssetImageApiAssetsAssetIdImagePostData, ThrowOnError>,
): RequestResult<
  UploadAssetImageApiAssetsAssetIdImagePostResponses,
  UploadAssetImageApiAssetsAssetIdImagePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadAssetImageApiAssetsAssetIdImagePostResponses,
    UploadAssetImageApiAssetsAssetIdImagePostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/assets/{asset_id}/image",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Archive Asset
 */
export const archiveAssetApiAssetsAssetIdArchivePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ArchiveAssetApiAssetsAssetIdArchivePostData, ThrowOnError>,
): RequestResult<
  ArchiveAssetApiAssetsAssetIdArchivePostResponses,
  ArchiveAssetApiAssetsAssetIdArchivePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ArchiveAssetApiAssetsAssetIdArchivePostResponses,
    ArchiveAssetApiAssetsAssetIdArchivePostErrors,
    ThrowOnError
  >({ url: "/api/assets/{asset_id}/archive", ...options });

/**
 * Link Asset Documents
 */
export const linkAssetDocumentsApiAssetsAssetIdDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    LinkAssetDocumentsApiAssetsAssetIdDocumentsPostData,
    ThrowOnError
  >,
): RequestResult<
  LinkAssetDocumentsApiAssetsAssetIdDocumentsPostResponses,
  LinkAssetDocumentsApiAssetsAssetIdDocumentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    LinkAssetDocumentsApiAssetsAssetIdDocumentsPostResponses,
    LinkAssetDocumentsApiAssetsAssetIdDocumentsPostErrors,
    ThrowOnError
  >({
    url: "/api/assets/{asset_id}/documents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Unlink Asset Document
 */
export const unlinkAssetDocumentApiAssetsAssetIdDocumentsDocumentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UnlinkAssetDocumentApiAssetsAssetIdDocumentsDocumentIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  UnlinkAssetDocumentApiAssetsAssetIdDocumentsDocumentIdDeleteResponses,
  UnlinkAssetDocumentApiAssetsAssetIdDocumentsDocumentIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    UnlinkAssetDocumentApiAssetsAssetIdDocumentsDocumentIdDeleteResponses,
    UnlinkAssetDocumentApiAssetsAssetIdDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/assets/{asset_id}/documents/{document_id}", ...options });

/**
 * Create Recurring Expense
 *
 * Create a new recurring expense for a home (home_id in body).
 */
export const createRecurringExpenseApiFinanceExpensesRecurringPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateRecurringExpenseApiFinanceExpensesRecurringPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateRecurringExpenseApiFinanceExpensesRecurringPostResponses,
  CreateRecurringExpenseApiFinanceExpensesRecurringPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateRecurringExpenseApiFinanceExpensesRecurringPostResponses,
    CreateRecurringExpenseApiFinanceExpensesRecurringPostErrors,
    ThrowOnError
  >({
    url: "/api/finance/expenses/recurring",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Recurring Expenses
 */
export const getRecurringExpensesApiFinanceExpensesRecurringHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRecurringExpensesApiFinanceExpensesRecurringHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetRecurringExpensesApiFinanceExpensesRecurringHomeHomeIdGetResponses,
  GetRecurringExpensesApiFinanceExpensesRecurringHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetRecurringExpensesApiFinanceExpensesRecurringHomeHomeIdGetResponses,
    GetRecurringExpensesApiFinanceExpensesRecurringHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/finance/expenses/recurring/home/{home_id}", ...options });

/**
 * Delete Recurring Expense
 */
export const deleteRecurringExpenseApiFinanceExpensesRecurringRecurringIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteRecurringExpenseApiFinanceExpensesRecurringRecurringIdDeleteData,
      ThrowOnError
    >,
  ): RequestResult<
    DeleteRecurringExpenseApiFinanceExpensesRecurringRecurringIdDeleteResponses,
    DeleteRecurringExpenseApiFinanceExpensesRecurringRecurringIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteRecurringExpenseApiFinanceExpensesRecurringRecurringIdDeleteResponses,
      DeleteRecurringExpenseApiFinanceExpensesRecurringRecurringIdDeleteErrors,
      ThrowOnError
    >({ url: "/api/finance/expenses/recurring/{recurring_id}", ...options });

/**
 * Update Recurring Expense
 *
 * Update a recurring expense (pause/resume, amount, frequency, etc.).
 */
export const updateRecurringExpenseApiFinanceExpensesRecurringRecurringIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateRecurringExpenseApiFinanceExpensesRecurringRecurringIdPutData,
    ThrowOnError
  >,
): RequestResult<
  UpdateRecurringExpenseApiFinanceExpensesRecurringRecurringIdPutResponses,
  UpdateRecurringExpenseApiFinanceExpensesRecurringRecurringIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateRecurringExpenseApiFinanceExpensesRecurringRecurringIdPutResponses,
    UpdateRecurringExpenseApiFinanceExpensesRecurringRecurringIdPutErrors,
    ThrowOnError
  >({
    url: "/api/finance/expenses/recurring/{recurring_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Generate Expense
 *
 * Manually trigger generation of an expense from a recurring template.
 */
export const generateExpenseApiFinanceExpensesRecurringRecurringIdGeneratePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GenerateExpenseApiFinanceExpensesRecurringRecurringIdGeneratePostData,
      ThrowOnError
    >,
  ): RequestResult<
    GenerateExpenseApiFinanceExpensesRecurringRecurringIdGeneratePostResponses,
    GenerateExpenseApiFinanceExpensesRecurringRecurringIdGeneratePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      GenerateExpenseApiFinanceExpensesRecurringRecurringIdGeneratePostResponses,
      GenerateExpenseApiFinanceExpensesRecurringRecurringIdGeneratePostErrors,
      ThrowOnError
    >({
      url: "/api/finance/expenses/recurring/{recurring_id}/generate",
      ...options,
    });

/**
 * Get Expense Categories
 *
 * Get expense categories for a home (presets + custom).
 */
export const getExpenseCategoriesApiFinanceExpensesCategoriesHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetExpenseCategoriesApiFinanceExpensesCategoriesHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetExpenseCategoriesApiFinanceExpensesCategoriesHomeHomeIdGetResponses,
  GetExpenseCategoriesApiFinanceExpensesCategoriesHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetExpenseCategoriesApiFinanceExpensesCategoriesHomeHomeIdGetResponses,
    GetExpenseCategoriesApiFinanceExpensesCategoriesHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/finance/expenses/categories/home/{home_id}", ...options });

/**
 * Create Expense Category
 *
 * Create a custom expense category for a home (home_id in body).
 */
export const createExpenseCategoryApiFinanceExpensesCategoriesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateExpenseCategoryApiFinanceExpensesCategoriesPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateExpenseCategoryApiFinanceExpensesCategoriesPostResponses,
  CreateExpenseCategoryApiFinanceExpensesCategoriesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateExpenseCategoryApiFinanceExpensesCategoriesPostResponses,
    CreateExpenseCategoryApiFinanceExpensesCategoriesPostErrors,
    ThrowOnError
  >({
    url: "/api/finance/expenses/categories",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Expense Category
 *
 * Delete a home's own expense category; 409 if in use and no ``reassign_to``.
 */
export const deleteExpenseCategoryApiFinanceExpensesCategoriesCategoryIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteExpenseCategoryApiFinanceExpensesCategoriesCategoryIdDeleteData,
      ThrowOnError
    >,
  ): RequestResult<
    DeleteExpenseCategoryApiFinanceExpensesCategoriesCategoryIdDeleteResponses,
    DeleteExpenseCategoryApiFinanceExpensesCategoriesCategoryIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteExpenseCategoryApiFinanceExpensesCategoriesCategoryIdDeleteResponses,
      DeleteExpenseCategoryApiFinanceExpensesCategoriesCategoryIdDeleteErrors,
      ThrowOnError
    >({ url: "/api/finance/expenses/categories/{category_id}", ...options });

/**
 * Update Expense Category
 *
 * Rename a home's own expense category or change its split rule.
 */
export const updateExpenseCategoryApiFinanceExpensesCategoriesCategoryIdPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateExpenseCategoryApiFinanceExpensesCategoriesCategoryIdPatchData,
      ThrowOnError
    >,
  ): RequestResult<
    UpdateExpenseCategoryApiFinanceExpensesCategoriesCategoryIdPatchResponses,
    UpdateExpenseCategoryApiFinanceExpensesCategoriesCategoryIdPatchErrors,
    ThrowOnError
  > =>
    (options.client ?? client).patch<
      UpdateExpenseCategoryApiFinanceExpensesCategoriesCategoryIdPatchResponses,
      UpdateExpenseCategoryApiFinanceExpensesCategoriesCategoryIdPatchErrors,
      ThrowOnError
    >({
      url: "/api/finance/expenses/categories/{category_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get Expenses
 *
 * List expenses across all homes the caller belongs to. Service filters
 * by user membership; no resource scope to enforce here.
 */
export const getExpensesApiFinanceExpensesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetExpensesApiFinanceExpensesGetData, ThrowOnError>,
): RequestResult<
  GetExpensesApiFinanceExpensesGetResponses,
  GetExpensesApiFinanceExpensesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetExpensesApiFinanceExpensesGetResponses,
    GetExpensesApiFinanceExpensesGetErrors,
    ThrowOnError
  >({ url: "/api/finance/expenses", ...options });

/**
 * Create Expense
 *
 * Create an expense for a home (home_id in body).
 */
export const createExpenseApiFinanceExpensesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateExpenseApiFinanceExpensesPostData, ThrowOnError>,
): RequestResult<
  CreateExpenseApiFinanceExpensesPostResponses,
  CreateExpenseApiFinanceExpensesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateExpenseApiFinanceExpensesPostResponses,
    CreateExpenseApiFinanceExpensesPostErrors,
    ThrowOnError
  >({
    url: "/api/finance/expenses",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Expense
 */
export const deleteExpenseApiFinanceExpensesExpenseIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteExpenseApiFinanceExpensesExpenseIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  DeleteExpenseApiFinanceExpensesExpenseIdDeleteResponses,
  DeleteExpenseApiFinanceExpensesExpenseIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteExpenseApiFinanceExpensesExpenseIdDeleteResponses,
    DeleteExpenseApiFinanceExpensesExpenseIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/finance/expenses/{expense_id}", ...options });

/**
 * Get Expense
 */
export const getExpenseApiFinanceExpensesExpenseIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetExpenseApiFinanceExpensesExpenseIdGetData, ThrowOnError>,
): RequestResult<
  GetExpenseApiFinanceExpensesExpenseIdGetResponses,
  GetExpenseApiFinanceExpensesExpenseIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetExpenseApiFinanceExpensesExpenseIdGetResponses,
    GetExpenseApiFinanceExpensesExpenseIdGetErrors,
    ThrowOnError
  >({ url: "/api/finance/expenses/{expense_id}", ...options });

/**
 * Update Expense
 */
export const updateExpenseApiFinanceExpensesExpenseIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateExpenseApiFinanceExpensesExpenseIdPutData,
    ThrowOnError
  >,
): RequestResult<
  UpdateExpenseApiFinanceExpensesExpenseIdPutResponses,
  UpdateExpenseApiFinanceExpensesExpenseIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateExpenseApiFinanceExpensesExpenseIdPutResponses,
    UpdateExpenseApiFinanceExpensesExpenseIdPutErrors,
    ThrowOnError
  >({
    url: "/api/finance/expenses/{expense_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Home Expenses
 */
export const getHomeExpensesApiFinanceExpensesHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHomeExpensesApiFinanceExpensesHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetHomeExpensesApiFinanceExpensesHomeHomeIdGetResponses,
  GetHomeExpensesApiFinanceExpensesHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeExpensesApiFinanceExpensesHomeHomeIdGetResponses,
    GetHomeExpensesApiFinanceExpensesHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/finance/expenses/home/{home_id}", ...options });

/**
 * Split Expense
 */
export const splitExpenseApiFinanceExpensesExpenseIdSplitPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SplitExpenseApiFinanceExpensesExpenseIdSplitPostData,
    ThrowOnError
  >,
): RequestResult<
  SplitExpenseApiFinanceExpensesExpenseIdSplitPostResponses,
  SplitExpenseApiFinanceExpensesExpenseIdSplitPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SplitExpenseApiFinanceExpensesExpenseIdSplitPostResponses,
    SplitExpenseApiFinanceExpensesExpenseIdSplitPostErrors,
    ThrowOnError
  >({
    url: "/api/finance/expenses/{expense_id}/split",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Expense Attachments
 *
 * List document attachments for an expense with full document metadata.
 */
export const getExpenseAttachmentsApiFinanceExpensesExpenseIdAttachmentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetExpenseAttachmentsApiFinanceExpensesExpenseIdAttachmentsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetExpenseAttachmentsApiFinanceExpensesExpenseIdAttachmentsGetResponses,
  GetExpenseAttachmentsApiFinanceExpensesExpenseIdAttachmentsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetExpenseAttachmentsApiFinanceExpensesExpenseIdAttachmentsGetResponses,
    GetExpenseAttachmentsApiFinanceExpensesExpenseIdAttachmentsGetErrors,
    ThrowOnError
  >({ url: "/api/finance/expenses/{expense_id}/attachments", ...options });

/**
 * Attach Documents To Expense
 */
export const attachDocumentsToExpenseApiFinanceExpensesExpenseIdAttachmentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AttachDocumentsToExpenseApiFinanceExpensesExpenseIdAttachmentsPostData,
      ThrowOnError
    >,
  ): RequestResult<
    AttachDocumentsToExpenseApiFinanceExpensesExpenseIdAttachmentsPostResponses,
    AttachDocumentsToExpenseApiFinanceExpensesExpenseIdAttachmentsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      AttachDocumentsToExpenseApiFinanceExpensesExpenseIdAttachmentsPostResponses,
      AttachDocumentsToExpenseApiFinanceExpensesExpenseIdAttachmentsPostErrors,
      ThrowOnError
    >({
      url: "/api/finance/expenses/{expense_id}/attachments",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get Expense Transactions
 *
 * The house-account movements booked against this expense.
 */
export const getExpenseTransactionsApiFinanceExpensesExpenseIdTransactionsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetExpenseTransactionsApiFinanceExpensesExpenseIdTransactionsGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetExpenseTransactionsApiFinanceExpensesExpenseIdTransactionsGetResponses,
    GetExpenseTransactionsApiFinanceExpensesExpenseIdTransactionsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetExpenseTransactionsApiFinanceExpensesExpenseIdTransactionsGetResponses,
      GetExpenseTransactionsApiFinanceExpensesExpenseIdTransactionsGetErrors,
      ThrowOnError
    >({ url: "/api/finance/expenses/{expense_id}/transactions", ...options });

/**
 * Mark Expense Paid
 */
export const markExpensePaidApiFinanceExpensesExpenseIdPayPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MarkExpensePaidApiFinanceExpensesExpenseIdPayPostData,
    ThrowOnError
  >,
): RequestResult<
  MarkExpensePaidApiFinanceExpensesExpenseIdPayPostResponses,
  MarkExpensePaidApiFinanceExpensesExpenseIdPayPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkExpensePaidApiFinanceExpensesExpenseIdPayPostResponses,
    MarkExpensePaidApiFinanceExpensesExpenseIdPayPostErrors,
    ThrowOnError
  >({
    url: "/api/finance/expenses/{expense_id}/pay",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get All Ledger Accounts
 *
 * Get all ledger accounts for a home (operating, reserve, etc.).
 */
export const getAllLedgerAccountsApiFinanceLedgerHomeIdAccountsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAllLedgerAccountsApiFinanceLedgerHomeIdAccountsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetAllLedgerAccountsApiFinanceLedgerHomeIdAccountsGetResponses,
  GetAllLedgerAccountsApiFinanceLedgerHomeIdAccountsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllLedgerAccountsApiFinanceLedgerHomeIdAccountsGetResponses,
    GetAllLedgerAccountsApiFinanceLedgerHomeIdAccountsGetErrors,
    ThrowOnError
  >({ url: "/api/finance/ledger/{home_id}/accounts", ...options });

/**
 * Get Ledger Account
 *
 * Get or create a ledger account for a home.
 */
export const getLedgerAccountApiFinanceLedgerHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLedgerAccountApiFinanceLedgerHomeIdGetData, ThrowOnError>,
): RequestResult<
  GetLedgerAccountApiFinanceLedgerHomeIdGetResponses,
  GetLedgerAccountApiFinanceLedgerHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetLedgerAccountApiFinanceLedgerHomeIdGetResponses,
    GetLedgerAccountApiFinanceLedgerHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/finance/ledger/{home_id}", ...options });

/**
 * Deposit To Ledger
 */
export const depositToLedgerApiFinanceLedgerHomeIdDepositPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DepositToLedgerApiFinanceLedgerHomeIdDepositPostData,
    ThrowOnError
  >,
): RequestResult<
  DepositToLedgerApiFinanceLedgerHomeIdDepositPostResponses,
  DepositToLedgerApiFinanceLedgerHomeIdDepositPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DepositToLedgerApiFinanceLedgerHomeIdDepositPostResponses,
    DepositToLedgerApiFinanceLedgerHomeIdDepositPostErrors,
    ThrowOnError
  >({
    url: "/api/finance/ledger/{home_id}/deposit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Withdraw From Ledger
 */
export const withdrawFromLedgerApiFinanceLedgerHomeIdWithdrawPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    WithdrawFromLedgerApiFinanceLedgerHomeIdWithdrawPostData,
    ThrowOnError
  >,
): RequestResult<
  WithdrawFromLedgerApiFinanceLedgerHomeIdWithdrawPostResponses,
  WithdrawFromLedgerApiFinanceLedgerHomeIdWithdrawPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    WithdrawFromLedgerApiFinanceLedgerHomeIdWithdrawPostResponses,
    WithdrawFromLedgerApiFinanceLedgerHomeIdWithdrawPostErrors,
    ThrowOnError
  >({
    url: "/api/finance/ledger/{home_id}/withdraw",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Settle Expense From Ledger
 */
export const settleExpenseFromLedgerApiFinanceLedgerHomeIdSettlePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SettleExpenseFromLedgerApiFinanceLedgerHomeIdSettlePostData,
    ThrowOnError
  >,
): RequestResult<
  SettleExpenseFromLedgerApiFinanceLedgerHomeIdSettlePostResponses,
  SettleExpenseFromLedgerApiFinanceLedgerHomeIdSettlePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SettleExpenseFromLedgerApiFinanceLedgerHomeIdSettlePostResponses,
    SettleExpenseFromLedgerApiFinanceLedgerHomeIdSettlePostErrors,
    ThrowOnError
  >({
    url: "/api/finance/ledger/{home_id}/settle",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Transfer Between Accounts
 *
 * Transfer money between accounts (e.g., from operating to reserve).
 */
export const transferBetweenAccountsApiFinanceLedgerHomeIdTransferPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TransferBetweenAccountsApiFinanceLedgerHomeIdTransferPostData,
    ThrowOnError
  >,
): RequestResult<
  TransferBetweenAccountsApiFinanceLedgerHomeIdTransferPostResponses,
  TransferBetweenAccountsApiFinanceLedgerHomeIdTransferPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TransferBetweenAccountsApiFinanceLedgerHomeIdTransferPostResponses,
    TransferBetweenAccountsApiFinanceLedgerHomeIdTransferPostErrors,
    ThrowOnError
  >({
    url: "/api/finance/ledger/{home_id}/transfer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Ledger Transactions
 */
export const getLedgerTransactionsApiFinanceLedgerHomeIdTransactionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetLedgerTransactionsApiFinanceLedgerHomeIdTransactionsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetLedgerTransactionsApiFinanceLedgerHomeIdTransactionsGetResponses,
  GetLedgerTransactionsApiFinanceLedgerHomeIdTransactionsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetLedgerTransactionsApiFinanceLedgerHomeIdTransactionsGetResponses,
    GetLedgerTransactionsApiFinanceLedgerHomeIdTransactionsGetErrors,
    ThrowOnError
  >({ url: "/api/finance/ledger/{home_id}/transactions", ...options });

/**
 * Get Ledger Balance
 *
 * Get ledger balance and member contributions for a home.
 */
export const getLedgerBalanceApiFinanceLedgerHomeIdBalanceGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetLedgerBalanceApiFinanceLedgerHomeIdBalanceGetData,
    ThrowOnError
  >,
): RequestResult<
  GetLedgerBalanceApiFinanceLedgerHomeIdBalanceGetResponses,
  GetLedgerBalanceApiFinanceLedgerHomeIdBalanceGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetLedgerBalanceApiFinanceLedgerHomeIdBalanceGetResponses,
    GetLedgerBalanceApiFinanceLedgerHomeIdBalanceGetErrors,
    ThrowOnError
  >({ url: "/api/finance/ledger/{home_id}/balance", ...options });

/**
 * Get Ledger Balance History
 */
export const getLedgerBalanceHistoryApiFinanceLedgerHomeIdBalanceHistoryGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetLedgerBalanceHistoryApiFinanceLedgerHomeIdBalanceHistoryGetData,
    ThrowOnError
  >,
): RequestResult<
  GetLedgerBalanceHistoryApiFinanceLedgerHomeIdBalanceHistoryGetResponses,
  GetLedgerBalanceHistoryApiFinanceLedgerHomeIdBalanceHistoryGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetLedgerBalanceHistoryApiFinanceLedgerHomeIdBalanceHistoryGetResponses,
    GetLedgerBalanceHistoryApiFinanceLedgerHomeIdBalanceHistoryGetErrors,
    ThrowOnError
  >({ url: "/api/finance/ledger/{home_id}/balance/history", ...options });

/**
 * Mark Settlement Paid
 *
 * Record a payment against a settlement, in full or in part.
 */
export const markSettlementPaidApiFinanceSettlementsSettlementIdMarkPaidPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MarkSettlementPaidApiFinanceSettlementsSettlementIdMarkPaidPostData,
    ThrowOnError
  >,
): RequestResult<
  MarkSettlementPaidApiFinanceSettlementsSettlementIdMarkPaidPostResponses,
  MarkSettlementPaidApiFinanceSettlementsSettlementIdMarkPaidPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkSettlementPaidApiFinanceSettlementsSettlementIdMarkPaidPostResponses,
    MarkSettlementPaidApiFinanceSettlementsSettlementIdMarkPaidPostErrors,
    ThrowOnError
  >({
    url: "/api/finance/settlements/{settlement_id}/mark-paid",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Home Settlements
 */
export const getHomeSettlementsApiFinanceSettlementsHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHomeSettlementsApiFinanceSettlementsHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetHomeSettlementsApiFinanceSettlementsHomeHomeIdGetResponses,
  GetHomeSettlementsApiFinanceSettlementsHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeSettlementsApiFinanceSettlementsHomeHomeIdGetResponses,
    GetHomeSettlementsApiFinanceSettlementsHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/finance/settlements/home/{home_id}", ...options });

/**
 * Get Settle Plan
 *
 * The fewest payments that square this home up, one plan per currency.
 */
export const getSettlePlanApiFinanceBalancesHomeHomeIdSettlePlanGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetSettlePlanApiFinanceBalancesHomeHomeIdSettlePlanGetData,
    ThrowOnError
  >,
): RequestResult<
  GetSettlePlanApiFinanceBalancesHomeHomeIdSettlePlanGetResponses,
  GetSettlePlanApiFinanceBalancesHomeHomeIdSettlePlanGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetSettlePlanApiFinanceBalancesHomeHomeIdSettlePlanGetResponses,
    GetSettlePlanApiFinanceBalancesHomeHomeIdSettlePlanGetErrors,
    ThrowOnError
  >({ url: "/api/finance/balances/home/{home_id}/settle-plan", ...options });

/**
 * Record Settle Plan Payment
 *
 * Record one transfer from the settle plan against every debt it clears.
 *
 * A netted payment stands in for a chain — Ana pays Sofia to discharge what
 * Ana owed Bob and Bob owed Sofia — so this closes the underlying rows from
 * both ends rather than one settlement at a time.
 */
export const recordSettlePlanPaymentApiFinanceBalancesHomeHomeIdSettlePlanRecordPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RecordSettlePlanPaymentApiFinanceBalancesHomeHomeIdSettlePlanRecordPostData,
      ThrowOnError
    >,
  ): RequestResult<
    RecordSettlePlanPaymentApiFinanceBalancesHomeHomeIdSettlePlanRecordPostResponses,
    RecordSettlePlanPaymentApiFinanceBalancesHomeHomeIdSettlePlanRecordPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      RecordSettlePlanPaymentApiFinanceBalancesHomeHomeIdSettlePlanRecordPostResponses,
      RecordSettlePlanPaymentApiFinanceBalancesHomeHomeIdSettlePlanRecordPostErrors,
      ThrowOnError
    >({
      url: "/api/finance/balances/home/{home_id}/settle-plan/record",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get User Balances
 *
 * Get balance summary for all members in a home (what each member owes
 * or is owed based on unsettled expenses).
 */
export const getUserBalancesApiFinanceBalancesHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetUserBalancesApiFinanceBalancesHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetUserBalancesApiFinanceBalancesHomeHomeIdGetResponses,
  GetUserBalancesApiFinanceBalancesHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUserBalancesApiFinanceBalancesHomeHomeIdGetResponses,
    GetUserBalancesApiFinanceBalancesHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/finance/balances/home/{home_id}", ...options });

/**
 * Get Home Finance Summary
 *
 * This home's spend position: month to date, what is unpaid, what is
 * overdue, and the last ``months`` months as a series.
 */
export const getHomeFinanceSummaryApiFinanceSummaryHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHomeFinanceSummaryApiFinanceSummaryHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetHomeFinanceSummaryApiFinanceSummaryHomeHomeIdGetResponses,
  GetHomeFinanceSummaryApiFinanceSummaryHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeFinanceSummaryApiFinanceSummaryHomeHomeIdGetResponses,
    GetHomeFinanceSummaryApiFinanceSummaryHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/finance/summary/home/{home_id}", ...options });

/**
 * Get Home Transactions
 *
 * This home's expenses and ledger transactions, merged into one
 * chronologically-sorted feed: scheduled rows first (soonest due date
 * first), then everything else, newest first.
 */
export const getHomeTransactionsApiFinanceTransactionsHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHomeTransactionsApiFinanceTransactionsHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetHomeTransactionsApiFinanceTransactionsHomeHomeIdGetResponses,
  GetHomeTransactionsApiFinanceTransactionsHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeTransactionsApiFinanceTransactionsHomeHomeIdGetResponses,
    GetHomeTransactionsApiFinanceTransactionsHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/finance/transactions/home/{home_id}", ...options });

/**
 * Create Profile
 */
export const createProfileApiFinanceBankStatementsProfilesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateProfileApiFinanceBankStatementsProfilesPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateProfileApiFinanceBankStatementsProfilesPostResponses,
  CreateProfileApiFinanceBankStatementsProfilesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateProfileApiFinanceBankStatementsProfilesPostResponses,
    CreateProfileApiFinanceBankStatementsProfilesPostErrors,
    ThrowOnError
  >({
    url: "/api/finance/bank-statements/profiles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Profiles
 */
export const listProfilesApiFinanceBankStatementsProfilesHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListProfilesApiFinanceBankStatementsProfilesHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  ListProfilesApiFinanceBankStatementsProfilesHomeHomeIdGetResponses,
  ListProfilesApiFinanceBankStatementsProfilesHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListProfilesApiFinanceBankStatementsProfilesHomeHomeIdGetResponses,
    ListProfilesApiFinanceBankStatementsProfilesHomeHomeIdGetErrors,
    ThrowOnError
  >({
    url: "/api/finance/bank-statements/profiles/home/{home_id}",
    ...options,
  });

/**
 * Update Profile
 */
export const updateProfileApiFinanceBankStatementsProfilesProfileIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateProfileApiFinanceBankStatementsProfilesProfileIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateProfileApiFinanceBankStatementsProfilesProfileIdPatchResponses,
  UpdateProfileApiFinanceBankStatementsProfilesProfileIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateProfileApiFinanceBankStatementsProfilesProfileIdPatchResponses,
    UpdateProfileApiFinanceBankStatementsProfilesProfileIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/finance/bank-statements/profiles/{profile_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Preview Statement
 */
export const previewStatementApiFinanceBankStatementsProfilesProfileIdPreviewPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PreviewStatementApiFinanceBankStatementsProfilesProfileIdPreviewPostData,
      ThrowOnError
    >,
  ): RequestResult<
    PreviewStatementApiFinanceBankStatementsProfilesProfileIdPreviewPostResponses,
    PreviewStatementApiFinanceBankStatementsProfilesProfileIdPreviewPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      PreviewStatementApiFinanceBankStatementsProfilesProfileIdPreviewPostResponses,
      PreviewStatementApiFinanceBankStatementsProfilesProfileIdPreviewPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      url: "/api/finance/bank-statements/profiles/{profile_id}/preview",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });

/**
 * Commit Import
 */
export const commitImportApiFinanceBankStatementsImportsStatementImportIdCommitPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CommitImportApiFinanceBankStatementsImportsStatementImportIdCommitPostData,
      ThrowOnError
    >,
  ): RequestResult<
    CommitImportApiFinanceBankStatementsImportsStatementImportIdCommitPostResponses,
    CommitImportApiFinanceBankStatementsImportsStatementImportIdCommitPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CommitImportApiFinanceBankStatementsImportsStatementImportIdCommitPostResponses,
      CommitImportApiFinanceBankStatementsImportsStatementImportIdCommitPostErrors,
      ThrowOnError
    >({
      url: "/api/finance/bank-statements/imports/{statement_import_id}/commit",
      ...options,
    });

/**
 * List Imports
 */
export const listImportsApiFinanceBankStatementsProfilesProfileIdImportsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListImportsApiFinanceBankStatementsProfilesProfileIdImportsGetData,
    ThrowOnError
  >,
): RequestResult<
  ListImportsApiFinanceBankStatementsProfilesProfileIdImportsGetResponses,
  ListImportsApiFinanceBankStatementsProfilesProfileIdImportsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListImportsApiFinanceBankStatementsProfilesProfileIdImportsGetResponses,
    ListImportsApiFinanceBankStatementsProfilesProfileIdImportsGetErrors,
    ThrowOnError
  >({
    url: "/api/finance/bank-statements/profiles/{profile_id}/imports",
    ...options,
  });

/**
 * Get Reconciliation
 */
export const getReconciliationApiFinanceBankStatementsHomeHomeIdReconciliationGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetReconciliationApiFinanceBankStatementsHomeHomeIdReconciliationGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetReconciliationApiFinanceBankStatementsHomeHomeIdReconciliationGetResponses,
    GetReconciliationApiFinanceBankStatementsHomeHomeIdReconciliationGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetReconciliationApiFinanceBankStatementsHomeHomeIdReconciliationGetResponses,
      GetReconciliationApiFinanceBankStatementsHomeHomeIdReconciliationGetErrors,
      ThrowOnError
    >({
      url: "/api/finance/bank-statements/home/{home_id}/reconciliation",
      ...options,
    });

/**
 * Import Summary
 */
export const importSummaryApiFinanceBankStatementsImportsStatementImportIdSummaryGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ImportSummaryApiFinanceBankStatementsImportsStatementImportIdSummaryGetData,
      ThrowOnError
    >,
  ): RequestResult<
    ImportSummaryApiFinanceBankStatementsImportsStatementImportIdSummaryGetResponses,
    ImportSummaryApiFinanceBankStatementsImportsStatementImportIdSummaryGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      ImportSummaryApiFinanceBankStatementsImportsStatementImportIdSummaryGetResponses,
      ImportSummaryApiFinanceBankStatementsImportsStatementImportIdSummaryGetErrors,
      ThrowOnError
    >({
      url: "/api/finance/bank-statements/imports/{statement_import_id}/summary",
      ...options,
    });

/**
 * Accept Suggestions
 */
export const acceptSuggestionsApiFinanceBankStatementsHomeHomeIdAcceptSuggestionsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AcceptSuggestionsApiFinanceBankStatementsHomeHomeIdAcceptSuggestionsPostData,
      ThrowOnError
    >,
  ): RequestResult<
    AcceptSuggestionsApiFinanceBankStatementsHomeHomeIdAcceptSuggestionsPostResponses,
    AcceptSuggestionsApiFinanceBankStatementsHomeHomeIdAcceptSuggestionsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      AcceptSuggestionsApiFinanceBankStatementsHomeHomeIdAcceptSuggestionsPostResponses,
      AcceptSuggestionsApiFinanceBankStatementsHomeHomeIdAcceptSuggestionsPostErrors,
      ThrowOnError
    >({
      url: "/api/finance/bank-statements/home/{home_id}/accept-suggestions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Match Expense
 */
export const matchExpenseApiFinanceBankStatementsTransactionsTransactionIdMatchExpensePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MatchExpenseApiFinanceBankStatementsTransactionsTransactionIdMatchExpensePostData,
      ThrowOnError
    >,
  ): RequestResult<
    MatchExpenseApiFinanceBankStatementsTransactionsTransactionIdMatchExpensePostResponses,
    MatchExpenseApiFinanceBankStatementsTransactionsTransactionIdMatchExpensePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      MatchExpenseApiFinanceBankStatementsTransactionsTransactionIdMatchExpensePostResponses,
      MatchExpenseApiFinanceBankStatementsTransactionsTransactionIdMatchExpensePostErrors,
      ThrowOnError
    >({
      url: "/api/finance/bank-statements/transactions/{transaction_id}/match-expense",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Create Expense
 */
export const createExpenseApiFinanceBankStatementsTransactionsTransactionIdCreateExpensePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateExpenseApiFinanceBankStatementsTransactionsTransactionIdCreateExpensePostData,
      ThrowOnError
    >,
  ): RequestResult<
    CreateExpenseApiFinanceBankStatementsTransactionsTransactionIdCreateExpensePostResponses,
    CreateExpenseApiFinanceBankStatementsTransactionsTransactionIdCreateExpensePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CreateExpenseApiFinanceBankStatementsTransactionsTransactionIdCreateExpensePostResponses,
      CreateExpenseApiFinanceBankStatementsTransactionsTransactionIdCreateExpensePostErrors,
      ThrowOnError
    >({
      url: "/api/finance/bank-statements/transactions/{transaction_id}/create-expense",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Match Deposit
 */
export const matchDepositApiFinanceBankStatementsTransactionsTransactionIdMatchDepositPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MatchDepositApiFinanceBankStatementsTransactionsTransactionIdMatchDepositPostData,
      ThrowOnError
    >,
  ): RequestResult<
    MatchDepositApiFinanceBankStatementsTransactionsTransactionIdMatchDepositPostResponses,
    MatchDepositApiFinanceBankStatementsTransactionsTransactionIdMatchDepositPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      MatchDepositApiFinanceBankStatementsTransactionsTransactionIdMatchDepositPostResponses,
      MatchDepositApiFinanceBankStatementsTransactionsTransactionIdMatchDepositPostErrors,
      ThrowOnError
    >({
      url: "/api/finance/bank-statements/transactions/{transaction_id}/match-deposit",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Create Deposit
 */
export const createDepositApiFinanceBankStatementsTransactionsTransactionIdCreateDepositPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateDepositApiFinanceBankStatementsTransactionsTransactionIdCreateDepositPostData,
      ThrowOnError
    >,
  ): RequestResult<
    CreateDepositApiFinanceBankStatementsTransactionsTransactionIdCreateDepositPostResponses,
    CreateDepositApiFinanceBankStatementsTransactionsTransactionIdCreateDepositPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CreateDepositApiFinanceBankStatementsTransactionsTransactionIdCreateDepositPostResponses,
      CreateDepositApiFinanceBankStatementsTransactionsTransactionIdCreateDepositPostErrors,
      ThrowOnError
    >({
      url: "/api/finance/bank-statements/transactions/{transaction_id}/create-deposit",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Exclude Transaction
 */
export const excludeTransactionApiFinanceBankStatementsTransactionsTransactionIdExcludePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ExcludeTransactionApiFinanceBankStatementsTransactionsTransactionIdExcludePostData,
      ThrowOnError
    >,
  ): RequestResult<
    ExcludeTransactionApiFinanceBankStatementsTransactionsTransactionIdExcludePostResponses,
    ExcludeTransactionApiFinanceBankStatementsTransactionsTransactionIdExcludePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ExcludeTransactionApiFinanceBankStatementsTransactionsTransactionIdExcludePostResponses,
      ExcludeTransactionApiFinanceBankStatementsTransactionsTransactionIdExcludePostErrors,
      ThrowOnError
    >({
      url: "/api/finance/bank-statements/transactions/{transaction_id}/exclude",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Reset Transaction
 */
export const resetTransactionApiFinanceBankStatementsTransactionsTransactionIdResetPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ResetTransactionApiFinanceBankStatementsTransactionsTransactionIdResetPostData,
      ThrowOnError
    >,
  ): RequestResult<
    ResetTransactionApiFinanceBankStatementsTransactionsTransactionIdResetPostResponses,
    ResetTransactionApiFinanceBankStatementsTransactionsTransactionIdResetPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ResetTransactionApiFinanceBankStatementsTransactionsTransactionIdResetPostResponses,
      ResetTransactionApiFinanceBankStatementsTransactionsTransactionIdResetPostErrors,
      ThrowOnError
    >({
      url: "/api/finance/bank-statements/transactions/{transaction_id}/reset",
      ...options,
    });

/**
 * Get Monthly Budget
 *
 * Resolve the budget and cash activity for one calendar month.
 */
export const getMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthGetData,
    ThrowOnError
  >,
): RequestResult<
  GetMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthGetResponses,
  GetMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthGetResponses,
    GetMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthGetErrors,
    ThrowOnError
  >({ url: "/api/finance/budgets/home/{home_id}/month", ...options });

/**
 * Update Monthly Budget
 *
 * Replace the effective category budget from ``month`` onward.
 */
export const updateMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthPutData,
    ThrowOnError
  >,
): RequestResult<
  UpdateMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthPutResponses,
  UpdateMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthPutResponses,
    UpdateMonthlyBudgetApiFinanceBudgetsHomeHomeIdMonthPutErrors,
    ThrowOnError
  >({
    url: "/api/finance/budgets/home/{home_id}/month",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Yearly Budget
 *
 * Return twelve historically resolved budget and spend buckets.
 */
export const getYearlyBudgetApiFinanceBudgetsHomeHomeIdYearGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetYearlyBudgetApiFinanceBudgetsHomeHomeIdYearGetData,
    ThrowOnError
  >,
): RequestResult<
  GetYearlyBudgetApiFinanceBudgetsHomeHomeIdYearGetResponses,
  GetYearlyBudgetApiFinanceBudgetsHomeHomeIdYearGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetYearlyBudgetApiFinanceBudgetsHomeHomeIdYearGetResponses,
    GetYearlyBudgetApiFinanceBudgetsHomeHomeIdYearGetErrors,
    ThrowOnError
  >({ url: "/api/finance/budgets/home/{home_id}/year", ...options });

/**
 * Get Plans
 */
export const getPlansApiBillingPlansGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPlansApiBillingPlansGetData, ThrowOnError>,
): RequestResult<
  GetPlansApiBillingPlansGetResponses,
  GetPlansApiBillingPlansGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPlansApiBillingPlansGetResponses,
    GetPlansApiBillingPlansGetErrors,
    ThrowOnError
  >({ url: "/api/billing/plans", ...options });

/**
 * Get Owner Subscription
 */
export const getOwnerSubscriptionApiBillingOwnerTypeOwnerIdSubscriptionGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOwnerSubscriptionApiBillingOwnerTypeOwnerIdSubscriptionGetData,
    ThrowOnError
  >,
): RequestResult<
  GetOwnerSubscriptionApiBillingOwnerTypeOwnerIdSubscriptionGetResponses,
  GetOwnerSubscriptionApiBillingOwnerTypeOwnerIdSubscriptionGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOwnerSubscriptionApiBillingOwnerTypeOwnerIdSubscriptionGetResponses,
    GetOwnerSubscriptionApiBillingOwnerTypeOwnerIdSubscriptionGetErrors,
    ThrowOnError
  >({ url: "/api/billing/{owner_type}/{owner_id}/subscription", ...options });

/**
 * Get Owner Entitlements
 */
export const getOwnerEntitlementsApiBillingOwnerTypeOwnerIdEntitlementsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOwnerEntitlementsApiBillingOwnerTypeOwnerIdEntitlementsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetOwnerEntitlementsApiBillingOwnerTypeOwnerIdEntitlementsGetResponses,
  GetOwnerEntitlementsApiBillingOwnerTypeOwnerIdEntitlementsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOwnerEntitlementsApiBillingOwnerTypeOwnerIdEntitlementsGetResponses,
    GetOwnerEntitlementsApiBillingOwnerTypeOwnerIdEntitlementsGetErrors,
    ThrowOnError
  >({ url: "/api/billing/{owner_type}/{owner_id}/entitlements", ...options });

/**
 * Get Owner Billing Details
 *
 * Return live Stripe billing details (card on file, invoices, next charge).
 */
export const getOwnerBillingDetailsApiBillingOwnerTypeOwnerIdBillingDetailsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetOwnerBillingDetailsApiBillingOwnerTypeOwnerIdBillingDetailsGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetOwnerBillingDetailsApiBillingOwnerTypeOwnerIdBillingDetailsGetResponses,
    GetOwnerBillingDetailsApiBillingOwnerTypeOwnerIdBillingDetailsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetOwnerBillingDetailsApiBillingOwnerTypeOwnerIdBillingDetailsGetResponses,
      GetOwnerBillingDetailsApiBillingOwnerTypeOwnerIdBillingDetailsGetErrors,
      ThrowOnError
    >({
      url: "/api/billing/{owner_type}/{owner_id}/billing-details",
      ...options,
    });

/**
 * Create Checkout Session
 */
export const createCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionPostData,
      ThrowOnError
    >,
  ): RequestResult<
    CreateCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionPostResponses,
    CreateCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CreateCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionPostResponses,
      CreateCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionPostErrors,
      ThrowOnError
    >({
      url: "/api/billing/{owner_type}/{owner_id}/checkout-session",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Create Portal Session
 */
export const createPortalSessionApiBillingOwnerTypeOwnerIdPortalSessionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePortalSessionApiBillingOwnerTypeOwnerIdPortalSessionPostData,
    ThrowOnError
  >,
): RequestResult<
  CreatePortalSessionApiBillingOwnerTypeOwnerIdPortalSessionPostResponses,
  CreatePortalSessionApiBillingOwnerTypeOwnerIdPortalSessionPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePortalSessionApiBillingOwnerTypeOwnerIdPortalSessionPostResponses,
    CreatePortalSessionApiBillingOwnerTypeOwnerIdPortalSessionPostErrors,
    ThrowOnError
  >({
    url: "/api/billing/{owner_type}/{owner_id}/portal-session",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confirm Checkout Session
 *
 * Sync a completed checkout immediately so features unlock on return without
 * waiting for the asynchronous Stripe webhook.
 */
export const confirmCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionSessionIdConfirmPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ConfirmCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionSessionIdConfirmPostData,
      ThrowOnError
    >,
  ): RequestResult<
    ConfirmCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionSessionIdConfirmPostResponses,
    ConfirmCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionSessionIdConfirmPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ConfirmCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionSessionIdConfirmPostResponses,
      ConfirmCheckoutSessionApiBillingOwnerTypeOwnerIdCheckoutSessionSessionIdConfirmPostErrors,
      ThrowOnError
    >({
      url: "/api/billing/{owner_type}/{owner_id}/checkout-session/{session_id}/confirm",
      ...options,
    });

/**
 * Stripe Webhook
 */
export const stripeWebhookApiBillingWebhooksStripePost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    StripeWebhookApiBillingWebhooksStripePostData,
    ThrowOnError
  >,
): RequestResult<
  StripeWebhookApiBillingWebhooksStripePostResponses,
  StripeWebhookApiBillingWebhooksStripePostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    StripeWebhookApiBillingWebhooksStripePostResponses,
    StripeWebhookApiBillingWebhooksStripePostErrors,
    ThrowOnError
  >({ url: "/api/billing/webhooks/stripe", ...options });

/**
 * Get Document Categories
 *
 * Get the smart-shelf categories for a home (presets + custom).
 */
export const getDocumentCategoriesApiDocumentCategoriesHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetDocumentCategoriesApiDocumentCategoriesHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetDocumentCategoriesApiDocumentCategoriesHomeHomeIdGetResponses,
  GetDocumentCategoriesApiDocumentCategoriesHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetDocumentCategoriesApiDocumentCategoriesHomeHomeIdGetResponses,
    GetDocumentCategoriesApiDocumentCategoriesHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/document/categories/home/{home_id}", ...options });

/**
 * Create Document Category
 *
 * Create a custom document category for a home (home_id in body).
 *
 * Preset categories (home_id=None) are seeded via migrations, not the API.
 */
export const createDocumentCategoryApiDocumentCategoriesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateDocumentCategoryApiDocumentCategoriesPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateDocumentCategoryApiDocumentCategoriesPostResponses,
  CreateDocumentCategoryApiDocumentCategoriesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateDocumentCategoryApiDocumentCategoriesPostResponses,
    CreateDocumentCategoryApiDocumentCategoriesPostErrors,
    ThrowOnError
  >({
    url: "/api/document/categories",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Document Category
 *
 * Delete a home's own document category.
 */
export const deleteDocumentCategoryApiDocumentCategoriesCategoryIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteDocumentCategoryApiDocumentCategoriesCategoryIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  DeleteDocumentCategoryApiDocumentCategoriesCategoryIdDeleteResponses,
  DeleteDocumentCategoryApiDocumentCategoriesCategoryIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteDocumentCategoryApiDocumentCategoriesCategoryIdDeleteResponses,
    DeleteDocumentCategoryApiDocumentCategoriesCategoryIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/document/categories/{category_id}", ...options });

/**
 * Update Document Category
 *
 * Rename or restyle a home's own document category.
 */
export const updateDocumentCategoryApiDocumentCategoriesCategoryIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateDocumentCategoryApiDocumentCategoriesCategoryIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateDocumentCategoryApiDocumentCategoriesCategoryIdPatchResponses,
  UpdateDocumentCategoryApiDocumentCategoriesCategoryIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateDocumentCategoryApiDocumentCategoriesCategoryIdPatchResponses,
    UpdateDocumentCategoryApiDocumentCategoriesCategoryIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/document/categories/{category_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upload Document
 *
 * Upload a document to Supabase Storage. Authorizes against the home_id
 * in the form data.
 */
export const uploadDocumentApiDocumentUploadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadDocumentApiDocumentUploadPostData, ThrowOnError>,
): RequestResult<
  UploadDocumentApiDocumentUploadPostResponses,
  UploadDocumentApiDocumentUploadPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadDocumentApiDocumentUploadPostResponses,
    UploadDocumentApiDocumentUploadPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/document/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Get Home Documents
 *
 * Get documents for a home, optionally filtered, each annotated with its
 * category and any linked expense.
 */
export const getHomeDocumentsApiDocumentHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetHomeDocumentsApiDocumentHomeHomeIdGetData, ThrowOnError>,
): RequestResult<
  GetHomeDocumentsApiDocumentHomeHomeIdGetResponses,
  GetHomeDocumentsApiDocumentHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHomeDocumentsApiDocumentHomeHomeIdGetResponses,
    GetHomeDocumentsApiDocumentHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/document/home/{home_id}", ...options });

/**
 * Get Document Vault Overview
 *
 * The Documents screen's furniture: drawers and their counts, a preview of
 * each shelf, what needs attention, and upcoming renewals.
 *
 * Always describes the whole vault. An open drawer or a search is a different
 * read — ``/rows`` — so the rails stay a way back out of it.
 */
export const getDocumentVaultOverviewApiDocumentHomeHomeIdOverviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetDocumentVaultOverviewApiDocumentHomeHomeIdOverviewGetData,
    ThrowOnError
  >,
): RequestResult<
  GetDocumentVaultOverviewApiDocumentHomeHomeIdOverviewGetResponses,
  GetDocumentVaultOverviewApiDocumentHomeHomeIdOverviewGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetDocumentVaultOverviewApiDocumentHomeHomeIdOverviewGetResponses,
    GetDocumentVaultOverviewApiDocumentHomeHomeIdOverviewGetErrors,
    ThrowOnError
  >({ url: "/api/document/home/{home_id}/overview", ...options });

/**
 * List Document Vault Rows
 *
 * One page of an open drawer, or of a search across the whole vault.
 *
 * Unlike the overview's shelf previews this is not capped: it is the list a
 * member reaches by opening a drawer, and it pages until it runs out.
 */
export const listDocumentVaultRowsApiDocumentHomeHomeIdRowsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListDocumentVaultRowsApiDocumentHomeHomeIdRowsGetData,
    ThrowOnError
  >,
): RequestResult<
  ListDocumentVaultRowsApiDocumentHomeHomeIdRowsGetResponses,
  ListDocumentVaultRowsApiDocumentHomeHomeIdRowsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListDocumentVaultRowsApiDocumentHomeHomeIdRowsGetResponses,
    ListDocumentVaultRowsApiDocumentHomeHomeIdRowsGetErrors,
    ThrowOnError
  >({ url: "/api/document/home/{home_id}/rows", ...options });

/**
 * Delete Document
 *
 * Delete a document. Service still enforces uploader-or-owner rules.
 */
export const deleteDocumentApiDocumentDocumentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteDocumentApiDocumentDocumentIdDeleteData, ThrowOnError>,
): RequestResult<
  DeleteDocumentApiDocumentDocumentIdDeleteResponses,
  DeleteDocumentApiDocumentDocumentIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteDocumentApiDocumentDocumentIdDeleteResponses,
    DeleteDocumentApiDocumentDocumentIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/document/{document_id}", ...options });

/**
 * Get Document
 *
 * Get document metadata by ID. Service still applies the per-document
 * access_level (PRIVATE/HOME_MEMBERS/PUBLIC) filter.
 */
export const getDocumentApiDocumentDocumentIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDocumentApiDocumentDocumentIdGetData, ThrowOnError>,
): RequestResult<
  GetDocumentApiDocumentDocumentIdGetResponses,
  GetDocumentApiDocumentDocumentIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetDocumentApiDocumentDocumentIdGetResponses,
    GetDocumentApiDocumentDocumentIdGetErrors,
    ThrowOnError
  >({ url: "/api/document/{document_id}", ...options });

/**
 * Update Document
 *
 * Update a document's metadata: rename, move category, change access,
 * description, or renewal/expiry date.
 */
export const updateDocumentApiDocumentDocumentIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateDocumentApiDocumentDocumentIdPatchData, ThrowOnError>,
): RequestResult<
  UpdateDocumentApiDocumentDocumentIdPatchResponses,
  UpdateDocumentApiDocumentDocumentIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateDocumentApiDocumentDocumentIdPatchResponses,
    UpdateDocumentApiDocumentDocumentIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/document/{document_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Document Url
 *
 * Get a signed download URL for a document.
 */
export const getDocumentUrlApiDocumentDocumentIdUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDocumentUrlApiDocumentDocumentIdUrlGetData, ThrowOnError>,
): RequestResult<
  GetDocumentUrlApiDocumentDocumentIdUrlGetResponses,
  GetDocumentUrlApiDocumentDocumentIdUrlGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetDocumentUrlApiDocumentDocumentIdUrlGetResponses,
    GetDocumentUrlApiDocumentDocumentIdUrlGetErrors,
    ThrowOnError
  >({ url: "/api/document/{document_id}/url", ...options });

/**
 * Get All Notifications
 */
export const getAllNotificationsApiNotificationNotificationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAllNotificationsApiNotificationNotificationsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetAllNotificationsApiNotificationNotificationsGetResponses,
  GetAllNotificationsApiNotificationNotificationsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAllNotificationsApiNotificationNotificationsGetResponses,
    GetAllNotificationsApiNotificationNotificationsGetErrors,
    ThrowOnError
  >({ url: "/api/notification/notifications", ...options });

/**
 * Get Notification
 */
export const getNotificationApiNotificationNotificationsNotificationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetNotificationApiNotificationNotificationsNotificationIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetNotificationApiNotificationNotificationsNotificationIdGetResponses,
  GetNotificationApiNotificationNotificationsNotificationIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetNotificationApiNotificationNotificationsNotificationIdGetResponses,
    GetNotificationApiNotificationNotificationsNotificationIdGetErrors,
    ThrowOnError
  >({ url: "/api/notification/notifications/{notification_id}", ...options });

/**
 * Get User Notifications
 */
export const getUserNotificationsApiNotificationNotificationsUserRecipientIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetUserNotificationsApiNotificationNotificationsUserRecipientIdGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetUserNotificationsApiNotificationNotificationsUserRecipientIdGetResponses,
    GetUserNotificationsApiNotificationNotificationsUserRecipientIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetUserNotificationsApiNotificationNotificationsUserRecipientIdGetResponses,
      GetUserNotificationsApiNotificationNotificationsUserRecipientIdGetErrors,
      ThrowOnError
    >({
      url: "/api/notification/notifications/user/{recipient_id}",
      ...options,
    });

/**
 * Mark Notification As Read
 */
export const markNotificationAsReadApiNotificationNotificationsNotificationIdReadPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MarkNotificationAsReadApiNotificationNotificationsNotificationIdReadPatchData,
      ThrowOnError
    >,
  ): RequestResult<
    MarkNotificationAsReadApiNotificationNotificationsNotificationIdReadPatchResponses,
    MarkNotificationAsReadApiNotificationNotificationsNotificationIdReadPatchErrors,
    ThrowOnError
  > =>
    (options.client ?? client).patch<
      MarkNotificationAsReadApiNotificationNotificationsNotificationIdReadPatchResponses,
      MarkNotificationAsReadApiNotificationNotificationsNotificationIdReadPatchErrors,
      ThrowOnError
    >({
      url: "/api/notification/notifications/{notification_id}/read",
      ...options,
    });

/**
 * Send Notification To User
 */
export const sendNotificationToUserApiNotificationSendUserPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SendNotificationToUserApiNotificationSendUserPostData,
    ThrowOnError
  >,
): RequestResult<
  SendNotificationToUserApiNotificationSendUserPostResponses,
  SendNotificationToUserApiNotificationSendUserPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SendNotificationToUserApiNotificationSendUserPostResponses,
    SendNotificationToUserApiNotificationSendUserPostErrors,
    ThrowOnError
  >({
    url: "/api/notification/send/user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send Notification To Home Members
 */
export const sendNotificationToHomeMembersApiNotificationSendHomeMembersPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SendNotificationToHomeMembersApiNotificationSendHomeMembersPostData,
    ThrowOnError
  >,
): RequestResult<
  SendNotificationToHomeMembersApiNotificationSendHomeMembersPostResponses,
  SendNotificationToHomeMembersApiNotificationSendHomeMembersPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SendNotificationToHomeMembersApiNotificationSendHomeMembersPostResponses,
    SendNotificationToHomeMembersApiNotificationSendHomeMembersPostErrors,
    ThrowOnError
  >({
    url: "/api/notification/send/home-members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send Notification To All Users
 */
export const sendNotificationToAllUsersApiNotificationSendAllUsersPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SendNotificationToAllUsersApiNotificationSendAllUsersPostData,
    ThrowOnError
  >,
): RequestResult<
  SendNotificationToAllUsersApiNotificationSendAllUsersPostResponses,
  SendNotificationToAllUsersApiNotificationSendAllUsersPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SendNotificationToAllUsersApiNotificationSendAllUsersPostResponses,
    SendNotificationToAllUsersApiNotificationSendAllUsersPostErrors,
    ThrowOnError
  >({
    url: "/api/notification/send/all-users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Task Status
 */
export const getTaskStatusApiNotificationTasksTaskIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTaskStatusApiNotificationTasksTaskIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetTaskStatusApiNotificationTasksTaskIdGetResponses,
  GetTaskStatusApiNotificationTasksTaskIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTaskStatusApiNotificationTasksTaskIdGetResponses,
    GetTaskStatusApiNotificationTasksTaskIdGetErrors,
    ThrowOnError
  >({ url: "/api/notification/tasks/{task_id}", ...options });

/**
 * Get notification preferences
 *
 * Retrieve the current user's notification preferences.
 *
 * The preference resolution hierarchy is: Override → User Default → System Default
 */
export const getNotificationPreferencesApiNotificationPreferencesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetNotificationPreferencesApiNotificationPreferencesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetNotificationPreferencesApiNotificationPreferencesGetResponses,
  GetNotificationPreferencesApiNotificationPreferencesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetNotificationPreferencesApiNotificationPreferencesGetResponses,
    GetNotificationPreferencesApiNotificationPreferencesGetErrors,
    ThrowOnError
  >({ url: "/api/notification/preferences", ...options });

/**
 * Update notification preferences
 *
 * Update the current user's notification preferences.
 *
 * The update replaces all existing overrides with the provided list.
 * To remove all overrides, pass an empty list.
 */
export const updateNotificationPreferencesApiNotificationPreferencesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateNotificationPreferencesApiNotificationPreferencesPutData,
    ThrowOnError
  >,
): RequestResult<
  UpdateNotificationPreferencesApiNotificationPreferencesPutResponses,
  UpdateNotificationPreferencesApiNotificationPreferencesPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateNotificationPreferencesApiNotificationPreferencesPutResponses,
    UpdateNotificationPreferencesApiNotificationPreferencesPutErrors,
    ThrowOnError
  >({
    url: "/api/notification/preferences",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Apply default preferences to all groups and homes
 *
 * Apply the user's default notification preferences to all their groups and homes.
 *
 * This creates override records for each active group membership and home membership,
 * copying the user's default preferences.
 *
 * Useful when users want consistent notification settings across all their groups/homes.
 */
export const applyNotificationPreferencesToAllApiNotificationPreferencesApplyAllPost =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      ApplyNotificationPreferencesToAllApiNotificationPreferencesApplyAllPostData,
      ThrowOnError
    >,
  ): RequestResult<
    ApplyNotificationPreferencesToAllApiNotificationPreferencesApplyAllPostResponses,
    ApplyNotificationPreferencesToAllApiNotificationPreferencesApplyAllPostErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).post<
      ApplyNotificationPreferencesToAllApiNotificationPreferencesApplyAllPostResponses,
      ApplyNotificationPreferencesToAllApiNotificationPreferencesApplyAllPostErrors,
      ThrowOnError
    >({ url: "/api/notification/preferences/apply-all", ...options });

/**
 * List every configurable notification
 *
 * Describe the notifications a user can configure, with the module they belong
 * to, the scope they are overridden per (home or group), and their system
 * defaults.
 *
 * Only categories with an email behind them are listed — a toggle for a
 * category with no sender is a promise the product does not keep. Settings
 * pages render from this rather than carrying their own copy of the taxonomy.
 */
export const getNotificationCatalogApiNotificationPreferencesCatalogGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetNotificationCatalogApiNotificationPreferencesCatalogGetData,
    ThrowOnError
  >,
): RequestResult<
  GetNotificationCatalogApiNotificationPreferencesCatalogGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetNotificationCatalogApiNotificationPreferencesCatalogGetResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/notification/preferences/catalog", ...options });

/**
 * Get a home's notification settings
 *
 * Retrieve the current user's effective notification settings for a single home.
 *
 * Each category is resolved with the hierarchy: home override → user default →
 * system default. Requires active membership of the home.
 */
export const getHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdGetResponses,
    GetHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdGetResponses,
      GetHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdGetErrors,
      ThrowOnError
    >({ url: "/api/notification/preferences/home/{home_id}", ...options });

/**
 * Update a home's notification settings
 *
 * Upsert the current user's notification override for a single home.
 *
 * Unlike ``PUT /preferences`` (which replaces the entire override list), this
 * only touches this home's override — the user's other home/group overrides are
 * left intact. Requires active membership of the home.
 */
export const updateHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdPutData,
      ThrowOnError
    >,
  ): RequestResult<
    UpdateHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdPutResponses,
    UpdateHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdPutResponses,
      UpdateHomeNotificationPreferencesApiNotificationPreferencesHomeHomeIdPutErrors,
      ThrowOnError
    >({
      url: "/api/notification/preferences/home/{home_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get a group's notification settings
 *
 * Retrieve the current user's effective notification settings for a single
 * explore group — the group-scoped counterpart of the home endpoint.
 *
 * Group overrides have always been storable, but nothing exposed them per
 * group, so explore notifications could only be configured globally.
 * Requires active membership of the group.
 */
export const getGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdGetResponses,
    GetGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdGetResponses,
      GetGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdGetErrors,
      ThrowOnError
    >({ url: "/api/notification/preferences/group/{group_id}", ...options });

/**
 * Update a group's notification settings
 *
 * Upsert the current user's notification override for a single explore group.
 *
 * Only touches this group's override — the user's other overrides are left
 * intact. Requires active membership of the group.
 */
export const updateGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdPutData,
      ThrowOnError
    >,
  ): RequestResult<
    UpdateGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdPutResponses,
    UpdateGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpdateGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdPutResponses,
      UpdateGroupNotificationPreferencesApiNotificationPreferencesGroupGroupIdPutErrors,
      ThrowOnError
    >({
      url: "/api/notification/preferences/group/{group_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get Email Alias Availability
 */
export const getEmailAliasAvailabilityApiNotificationEmailAliasesAvailabilityGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetEmailAliasAvailabilityApiNotificationEmailAliasesAvailabilityGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetEmailAliasAvailabilityApiNotificationEmailAliasesAvailabilityGetResponses,
    GetEmailAliasAvailabilityApiNotificationEmailAliasesAvailabilityGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetEmailAliasAvailabilityApiNotificationEmailAliasesAvailabilityGetResponses,
      GetEmailAliasAvailabilityApiNotificationEmailAliasesAvailabilityGetErrors,
      ThrowOnError
    >({ url: "/api/notification/email-aliases/availability", ...options });

/**
 * Suggest Email Alias
 */
export const suggestEmailAliasApiNotificationEmailAliasesSuggestionGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SuggestEmailAliasApiNotificationEmailAliasesSuggestionGetData,
    ThrowOnError
  >,
): RequestResult<
  SuggestEmailAliasApiNotificationEmailAliasesSuggestionGetResponses,
  SuggestEmailAliasApiNotificationEmailAliasesSuggestionGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SuggestEmailAliasApiNotificationEmailAliasesSuggestionGetResponses,
    SuggestEmailAliasApiNotificationEmailAliasesSuggestionGetErrors,
    ThrowOnError
  >({ url: "/api/notification/email-aliases/suggestion", ...options });

/**
 * Handle Inbound Email
 */
export const handleInboundEmailApiEmailsInboundPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HandleInboundEmailApiEmailsInboundPostData, ThrowOnError>,
): RequestResult<
  HandleInboundEmailApiEmailsInboundPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    HandleInboundEmailApiEmailsInboundPostResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/emails/inbound", ...options });

/**
 * List Extraction Jobs
 */
export const listExtractionJobsApiExtractionHomesHomeIdJobsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListExtractionJobsApiExtractionHomesHomeIdJobsGetData,
    ThrowOnError
  >,
): RequestResult<
  ListExtractionJobsApiExtractionHomesHomeIdJobsGetResponses,
  ListExtractionJobsApiExtractionHomesHomeIdJobsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListExtractionJobsApiExtractionHomesHomeIdJobsGetResponses,
    ListExtractionJobsApiExtractionHomesHomeIdJobsGetErrors,
    ThrowOnError
  >({ url: "/api/extraction/homes/{home_id}/jobs", ...options });

/**
 * Create Extraction Job
 *
 * Store an upload and return a durable background-processing job.
 */
export const createExtractionJobApiExtractionHomesHomeIdJobsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateExtractionJobApiExtractionHomesHomeIdJobsPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateExtractionJobApiExtractionHomesHomeIdJobsPostResponses,
  CreateExtractionJobApiExtractionHomesHomeIdJobsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateExtractionJobApiExtractionHomesHomeIdJobsPostResponses,
    CreateExtractionJobApiExtractionHomesHomeIdJobsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/extraction/homes/{home_id}/jobs",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Create Extraction Job Batch
 */
export const createExtractionJobBatchApiExtractionHomesHomeIdJobsBatchPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateExtractionJobBatchApiExtractionHomesHomeIdJobsBatchPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateExtractionJobBatchApiExtractionHomesHomeIdJobsBatchPostResponses,
  CreateExtractionJobBatchApiExtractionHomesHomeIdJobsBatchPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateExtractionJobBatchApiExtractionHomesHomeIdJobsBatchPostResponses,
    CreateExtractionJobBatchApiExtractionHomesHomeIdJobsBatchPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/extraction/homes/{home_id}/jobs/batch",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Get Extraction Job
 */
export const getExtractionJobApiExtractionHomesHomeIdJobsJobIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetExtractionJobApiExtractionHomesHomeIdJobsJobIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetExtractionJobApiExtractionHomesHomeIdJobsJobIdGetResponses,
  GetExtractionJobApiExtractionHomesHomeIdJobsJobIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetExtractionJobApiExtractionHomesHomeIdJobsJobIdGetResponses,
    GetExtractionJobApiExtractionHomesHomeIdJobsJobIdGetErrors,
    ThrowOnError
  >({ url: "/api/extraction/homes/{home_id}/jobs/{job_id}", ...options });

/**
 * Retry Extraction Job
 */
export const retryExtractionJobApiExtractionHomesHomeIdJobsJobIdRetryPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RetryExtractionJobApiExtractionHomesHomeIdJobsJobIdRetryPostData,
    ThrowOnError
  >,
): RequestResult<
  RetryExtractionJobApiExtractionHomesHomeIdJobsJobIdRetryPostResponses,
  RetryExtractionJobApiExtractionHomesHomeIdJobsJobIdRetryPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RetryExtractionJobApiExtractionHomesHomeIdJobsJobIdRetryPostResponses,
    RetryExtractionJobApiExtractionHomesHomeIdJobsJobIdRetryPostErrors,
    ThrowOnError
  >({ url: "/api/extraction/homes/{home_id}/jobs/{job_id}/retry", ...options });

/**
 * Complete Extraction Job
 */
export const completeExtractionJobApiExtractionHomesHomeIdJobsJobIdCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CompleteExtractionJobApiExtractionHomesHomeIdJobsJobIdCompletePostData,
      ThrowOnError
    >,
  ): RequestResult<
    CompleteExtractionJobApiExtractionHomesHomeIdJobsJobIdCompletePostResponses,
    CompleteExtractionJobApiExtractionHomesHomeIdJobsJobIdCompletePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      CompleteExtractionJobApiExtractionHomesHomeIdJobsJobIdCompletePostResponses,
      CompleteExtractionJobApiExtractionHomesHomeIdJobsJobIdCompletePostErrors,
      ThrowOnError
    >({
      url: "/api/extraction/homes/{home_id}/jobs/{job_id}/complete",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Dismiss Extraction Job
 *
 * Keep the uploaded source as a document without creating another record.
 */
export const dismissExtractionJobApiExtractionHomesHomeIdJobsJobIdDismissPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DismissExtractionJobApiExtractionHomesHomeIdJobsJobIdDismissPostData,
      ThrowOnError
    >,
  ): RequestResult<
    DismissExtractionJobApiExtractionHomesHomeIdJobsJobIdDismissPostResponses,
    DismissExtractionJobApiExtractionHomesHomeIdJobsJobIdDismissPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      DismissExtractionJobApiExtractionHomesHomeIdJobsJobIdDismissPostResponses,
      DismissExtractionJobApiExtractionHomesHomeIdJobsJobIdDismissPostErrors,
      ThrowOnError
    >({
      url: "/api/extraction/homes/{home_id}/jobs/{job_id}/dismiss",
      ...options,
    });

/**
 * Extraction Events
 */
export const extractionEventsApiExtractionHomesHomeIdEventsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExtractionEventsApiExtractionHomesHomeIdEventsGetData,
    ThrowOnError
  >,
): RequestResult<
  ExtractionEventsApiExtractionHomesHomeIdEventsGetResponses,
  ExtractionEventsApiExtractionHomesHomeIdEventsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ExtractionEventsApiExtractionHomesHomeIdEventsGetResponses,
    ExtractionEventsApiExtractionHomesHomeIdEventsGetErrors,
    ThrowOnError
  >({ url: "/api/extraction/homes/{home_id}/events", ...options });

/**
 * Home Feed
 */
export const homeFeedApiActivityHomesHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<HomeFeedApiActivityHomesHomeIdGetData, ThrowOnError>,
): RequestResult<
  HomeFeedApiActivityHomesHomeIdGetResponses,
  HomeFeedApiActivityHomesHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    HomeFeedApiActivityHomesHomeIdGetResponses,
    HomeFeedApiActivityHomesHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/activity/homes/{home_id}", ...options });

/**
 * Group Feed
 */
export const groupFeedApiActivityGroupsGroupIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupFeedApiActivityGroupsGroupIdGetData, ThrowOnError>,
): RequestResult<
  GroupFeedApiActivityGroupsGroupIdGetResponses,
  GroupFeedApiActivityGroupsGroupIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GroupFeedApiActivityGroupsGroupIdGetResponses,
    GroupFeedApiActivityGroupsGroupIdGetErrors,
    ThrowOnError
  >({ url: "/api/activity/groups/{group_id}", ...options });

/**
 * Home Count
 */
export const homeCountApiActivityHomesHomeIdCountGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<HomeCountApiActivityHomesHomeIdCountGetData, ThrowOnError>,
): RequestResult<
  HomeCountApiActivityHomesHomeIdCountGetResponses,
  HomeCountApiActivityHomesHomeIdCountGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    HomeCountApiActivityHomesHomeIdCountGetResponses,
    HomeCountApiActivityHomesHomeIdCountGetErrors,
    ThrowOnError
  >({ url: "/api/activity/homes/{home_id}/count", ...options });

/**
 * Group Count
 */
export const groupCountApiActivityGroupsGroupIdCountGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupCountApiActivityGroupsGroupIdCountGetData,
    ThrowOnError
  >,
): RequestResult<
  GroupCountApiActivityGroupsGroupIdCountGetResponses,
  GroupCountApiActivityGroupsGroupIdCountGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GroupCountApiActivityGroupsGroupIdCountGetResponses,
    GroupCountApiActivityGroupsGroupIdCountGetErrors,
    ThrowOnError
  >({ url: "/api/activity/groups/{group_id}/count", ...options });

/**
 * Mark Home Read
 */
export const markHomeReadApiActivityHomesHomeIdReadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MarkHomeReadApiActivityHomesHomeIdReadPostData,
    ThrowOnError
  >,
): RequestResult<
  MarkHomeReadApiActivityHomesHomeIdReadPostResponses,
  MarkHomeReadApiActivityHomesHomeIdReadPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkHomeReadApiActivityHomesHomeIdReadPostResponses,
    MarkHomeReadApiActivityHomesHomeIdReadPostErrors,
    ThrowOnError
  >({
    url: "/api/activity/homes/{home_id}/read",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Mark Group Read
 */
export const markGroupReadApiActivityGroupsGroupIdReadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MarkGroupReadApiActivityGroupsGroupIdReadPostData,
    ThrowOnError
  >,
): RequestResult<
  MarkGroupReadApiActivityGroupsGroupIdReadPostResponses,
  MarkGroupReadApiActivityGroupsGroupIdReadPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MarkGroupReadApiActivityGroupsGroupIdReadPostResponses,
    MarkGroupReadApiActivityGroupsGroupIdReadPostErrors,
    ThrowOnError
  >({
    url: "/api/activity/groups/{group_id}/read",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Groups
 *
 * List the caller's own groups, enriched with per-group aggregates for the
 * Your Groups page (members, saved-listing cover photos, pending-vote count
 * for the viewer, recent activity).
 */
export const getGroupsApiExploreGroupsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetGroupsApiExploreGroupsGetData, ThrowOnError>,
): RequestResult<
  GetGroupsApiExploreGroupsGetResponses,
  GetGroupsApiExploreGroupsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetGroupsApiExploreGroupsGetResponses,
    GetGroupsApiExploreGroupsGetErrors,
    ThrowOnError
  >({ url: "/api/explore/groups", ...options });

/**
 * Create Group
 *
 * Create a new explore group. Any authenticated user can create a group;
 * the creator is automatically added as the group's owner via
 * RbacSyncService.
 */
export const createGroupApiExploreGroupsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateGroupApiExploreGroupsPostData, ThrowOnError>,
): RequestResult<
  CreateGroupApiExploreGroupsPostResponses,
  CreateGroupApiExploreGroupsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateGroupApiExploreGroupsPostResponses,
    CreateGroupApiExploreGroupsPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Group
 */
export const deleteGroupApiExploreGroupsGroupIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteGroupApiExploreGroupsGroupIdDeleteData, ThrowOnError>,
): RequestResult<
  DeleteGroupApiExploreGroupsGroupIdDeleteResponses,
  DeleteGroupApiExploreGroupsGroupIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteGroupApiExploreGroupsGroupIdDeleteResponses,
    DeleteGroupApiExploreGroupsGroupIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/explore/groups/{group_id}", ...options });

/**
 * Get Group
 */
export const getGroupApiExploreGroupsGroupIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetGroupApiExploreGroupsGroupIdGetData, ThrowOnError>,
): RequestResult<
  GetGroupApiExploreGroupsGroupIdGetResponses,
  GetGroupApiExploreGroupsGroupIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetGroupApiExploreGroupsGroupIdGetResponses,
    GetGroupApiExploreGroupsGroupIdGetErrors,
    ThrowOnError
  >({ url: "/api/explore/groups/{group_id}", ...options });

/**
 * Update Group
 */
export const updateGroupApiExploreGroupsGroupIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateGroupApiExploreGroupsGroupIdPatchData, ThrowOnError>,
): RequestResult<
  UpdateGroupApiExploreGroupsGroupIdPatchResponses,
  UpdateGroupApiExploreGroupsGroupIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateGroupApiExploreGroupsGroupIdPatchResponses,
    UpdateGroupApiExploreGroupsGroupIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/explore/groups/{group_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove Group Cover
 *
 * Remove a group's cover photo and best-effort delete the stored object.
 */
export const removeGroupCoverApiExploreGroupsGroupIdCoverDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RemoveGroupCoverApiExploreGroupsGroupIdCoverDeleteData,
    ThrowOnError
  >,
): RequestResult<
  RemoveGroupCoverApiExploreGroupsGroupIdCoverDeleteResponses,
  RemoveGroupCoverApiExploreGroupsGroupIdCoverDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RemoveGroupCoverApiExploreGroupsGroupIdCoverDeleteResponses,
    RemoveGroupCoverApiExploreGroupsGroupIdCoverDeleteErrors,
    ThrowOnError
  >({ url: "/api/explore/groups/{group_id}/cover", ...options });

/**
 * Upload Group Cover
 *
 * Upload and set a group's cover photo; only the stored image's public URL is persisted.
 */
export const uploadGroupCoverApiExploreGroupsGroupIdCoverPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadGroupCoverApiExploreGroupsGroupIdCoverPostData,
    ThrowOnError
  >,
): RequestResult<
  UploadGroupCoverApiExploreGroupsGroupIdCoverPostResponses,
  UploadGroupCoverApiExploreGroupsGroupIdCoverPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadGroupCoverApiExploreGroupsGroupIdCoverPostResponses,
    UploadGroupCoverApiExploreGroupsGroupIdCoverPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/explore/groups/{group_id}/cover",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Get Group Amenities
 */
export const getGroupAmenitiesApiExploreGroupsGroupIdAmenitiesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGroupAmenitiesApiExploreGroupsGroupIdAmenitiesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetGroupAmenitiesApiExploreGroupsGroupIdAmenitiesGetResponses,
  GetGroupAmenitiesApiExploreGroupsGroupIdAmenitiesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetGroupAmenitiesApiExploreGroupsGroupIdAmenitiesGetResponses,
    GetGroupAmenitiesApiExploreGroupsGroupIdAmenitiesGetErrors,
    ThrowOnError
  >({ url: "/api/explore/groups/{group_id}/amenities", ...options });

/**
 * Create Group Amenity
 */
export const createGroupAmenityApiExploreGroupsGroupIdAmenitiesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateGroupAmenityApiExploreGroupsGroupIdAmenitiesPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateGroupAmenityApiExploreGroupsGroupIdAmenitiesPostResponses,
  CreateGroupAmenityApiExploreGroupsGroupIdAmenitiesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateGroupAmenityApiExploreGroupsGroupIdAmenitiesPostResponses,
    CreateGroupAmenityApiExploreGroupsGroupIdAmenitiesPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/groups/{group_id}/amenities",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Members
 */
export const getMembersApiExploreGroupsGroupIdMembersGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMembersApiExploreGroupsGroupIdMembersGetData,
    ThrowOnError
  >,
): RequestResult<
  GetMembersApiExploreGroupsGroupIdMembersGetResponses,
  GetMembersApiExploreGroupsGroupIdMembersGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMembersApiExploreGroupsGroupIdMembersGetResponses,
    GetMembersApiExploreGroupsGroupIdMembersGetErrors,
    ThrowOnError
  >({ url: "/api/explore/groups/{group_id}/members", ...options });

/**
 * Remove Member
 */
export const removeMemberApiExploreMembersMemberIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RemoveMemberApiExploreMembersMemberIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  RemoveMemberApiExploreMembersMemberIdDeleteResponses,
  RemoveMemberApiExploreMembersMemberIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RemoveMemberApiExploreMembersMemberIdDeleteResponses,
    RemoveMemberApiExploreMembersMemberIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/explore/members/{member_id}", ...options });

/**
 * Update Member
 */
export const updateMemberApiExploreMembersMemberIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateMemberApiExploreMembersMemberIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateMemberApiExploreMembersMemberIdPatchResponses,
  UpdateMemberApiExploreMembersMemberIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateMemberApiExploreMembersMemberIdPatchResponses,
    UpdateMemberApiExploreMembersMemberIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/explore/members/{member_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get My Preferences
 */
export const getMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesGetResponses,
  GetMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesGetResponses,
    GetMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesGetErrors,
    ThrowOnError
  >({
    url: "/api/explore/groups/{group_id}/members/me/preferences",
    ...options,
  });

/**
 * Upsert My Preferences
 */
export const upsertMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpsertMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesPutData,
      ThrowOnError
    >,
  ): RequestResult<
    UpsertMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesPutResponses,
    UpsertMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesPutErrors,
    ThrowOnError
  > =>
    (options.client ?? client).put<
      UpsertMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesPutResponses,
      UpsertMyPreferencesApiExploreGroupsGroupIdMembersMePreferencesPutErrors,
      ThrowOnError
    >({
      url: "/api/explore/groups/{group_id}/members/me/preferences",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get Group Preferences
 */
export const getGroupPreferencesApiExploreGroupsGroupIdMemberPreferencesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGroupPreferencesApiExploreGroupsGroupIdMemberPreferencesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetGroupPreferencesApiExploreGroupsGroupIdMemberPreferencesGetResponses,
  GetGroupPreferencesApiExploreGroupsGroupIdMemberPreferencesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetGroupPreferencesApiExploreGroupsGroupIdMemberPreferencesGetResponses,
    GetGroupPreferencesApiExploreGroupsGroupIdMemberPreferencesGetErrors,
    ThrowOnError
  >({ url: "/api/explore/groups/{group_id}/member-preferences", ...options });

/**
 * Get User Invites
 *
 * List all pending invites addressed to the current user. Service
 * filters by user; no per-domain Casbin check applies.
 */
export const getUserInvitesApiExploreInvitesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUserInvitesApiExploreInvitesGetData, ThrowOnError>,
): RequestResult<
  GetUserInvitesApiExploreInvitesGetResponses,
  GetUserInvitesApiExploreInvitesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUserInvitesApiExploreInvitesGetResponses,
    GetUserInvitesApiExploreInvitesGetErrors,
    ThrowOnError
  >({ url: "/api/explore/invites", ...options });

/**
 * Get Invites
 */
export const getInvitesApiExploreGroupsGroupIdInvitesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInvitesApiExploreGroupsGroupIdInvitesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetInvitesApiExploreGroupsGroupIdInvitesGetResponses,
  GetInvitesApiExploreGroupsGroupIdInvitesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetInvitesApiExploreGroupsGroupIdInvitesGetResponses,
    GetInvitesApiExploreGroupsGroupIdInvitesGetErrors,
    ThrowOnError
  >({ url: "/api/explore/groups/{group_id}/invites", ...options });

/**
 * Create Invite
 */
export const createInviteApiExploreGroupsGroupIdInvitesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateInviteApiExploreGroupsGroupIdInvitesPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateInviteApiExploreGroupsGroupIdInvitesPostResponses,
  CreateInviteApiExploreGroupsGroupIdInvitesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateInviteApiExploreGroupsGroupIdInvitesPostResponses,
    CreateInviteApiExploreGroupsGroupIdInvitesPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/groups/{group_id}/invites",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Invite
 *
 * Update an invite status (accept/reject by invitee, revoke by inviter).
 *
 * Authorization is intentionally service-driven here: an invitee can act on
 * their own invite without being a group member, while a revoke is gated
 * by group ownership inside the service.
 */
export const updateInviteApiExploreInvitesInviteIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateInviteApiExploreInvitesInviteIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateInviteApiExploreInvitesInviteIdPatchResponses,
  UpdateInviteApiExploreInvitesInviteIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateInviteApiExploreInvitesInviteIdPatchResponses,
    UpdateInviteApiExploreInvitesInviteIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/explore/invites/{invite_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Resend Invite
 *
 * Resend the invitation email for a pending invite. Service enforces
 * inviter/owner-only access.
 */
export const resendInviteApiExploreInvitesInviteIdResendPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResendInviteApiExploreInvitesInviteIdResendPostData,
    ThrowOnError
  >,
): RequestResult<
  ResendInviteApiExploreInvitesInviteIdResendPostResponses,
  ResendInviteApiExploreInvitesInviteIdResendPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ResendInviteApiExploreInvitesInviteIdResendPostResponses,
    ResendInviteApiExploreInvitesInviteIdResendPostErrors,
    ThrowOnError
  >({ url: "/api/explore/invites/{invite_id}/resend", ...options });

/**
 * Accept Invite Public
 *
 * Accept an invite using a public signed token (no auth required).
 */
export const acceptInvitePublicApiExploreInvitesTokenAcceptPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AcceptInvitePublicApiExploreInvitesTokenAcceptPostData,
    ThrowOnError
  >,
): RequestResult<
  AcceptInvitePublicApiExploreInvitesTokenAcceptPostResponses,
  AcceptInvitePublicApiExploreInvitesTokenAcceptPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AcceptInvitePublicApiExploreInvitesTokenAcceptPostResponses,
    AcceptInvitePublicApiExploreInvitesTokenAcceptPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/invites/token/accept",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Decline Invite Public
 *
 * Decline an invite using a public signed token (no auth required).
 */
export const declineInvitePublicApiExploreInvitesTokenDeclinePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeclineInvitePublicApiExploreInvitesTokenDeclinePostData,
    ThrowOnError
  >,
): RequestResult<
  DeclineInvitePublicApiExploreInvitesTokenDeclinePostResponses,
  DeclineInvitePublicApiExploreInvitesTokenDeclinePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeclineInvitePublicApiExploreInvitesTokenDeclinePostResponses,
    DeclineInvitePublicApiExploreInvitesTokenDeclinePostErrors,
    ThrowOnError
  >({
    url: "/api/explore/invites/token/decline",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract And Create Listing
 *
 * Create a skeleton listing with ``enrichment_status='pending'`` and
 * enqueue an async LLM extraction job to fill in the real fields.
 *
 * The full listing (with the placeholder values) is returned synchronously
 * so the FE can drop the new card into the list immediately; the
 * ``enrichment_status`` flip back to ``idle`` arrives over SSE.
 */
export const extractAndCreateListingApiExploreGroupsGroupIdListingsExtractPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ExtractAndCreateListingApiExploreGroupsGroupIdListingsExtractPostData,
      ThrowOnError
    >,
  ): RequestResult<
    ExtractAndCreateListingApiExploreGroupsGroupIdListingsExtractPostResponses,
    ExtractAndCreateListingApiExploreGroupsGroupIdListingsExtractPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      ExtractAndCreateListingApiExploreGroupsGroupIdListingsExtractPostResponses,
      ExtractAndCreateListingApiExploreGroupsGroupIdListingsExtractPostErrors,
      ThrowOnError
    >({
      url: "/api/explore/groups/{group_id}/listings/extract",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Extract And Update Listing
 *
 * Mark the listing as ``enrichment_status='pending'`` and enqueue an async
 * LLM extraction job; the FE renders the "Enriching…" cue from this state.
 */
export const extractAndUpdateListingApiExploreListingsListingIdExtractPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExtractAndUpdateListingApiExploreListingsListingIdExtractPostData,
    ThrowOnError
  >,
): RequestResult<
  ExtractAndUpdateListingApiExploreListingsListingIdExtractPostResponses,
  ExtractAndUpdateListingApiExploreListingsListingIdExtractPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ExtractAndUpdateListingApiExploreListingsListingIdExtractPostResponses,
    ExtractAndUpdateListingApiExploreListingsListingIdExtractPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/listings/{listing_id}/extract",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Group Listing Events
 *
 * Server-Sent Events stream of listing-state changes for a group.
 *
 * Used by the FE to keep listing cards in sync without polling — every
 * transition of ``enrichment_status`` (and ``listing.updated``) is pushed
 * here from the Celery worker via Redis pub/sub.
 *
 * Authentication uses the standard Authorization bearer header. RBAC is
 * enforced imperatively below because the stream has a custom lifecycle.
 */
export const groupListingEventsApiExploreGroupsGroupIdEventsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupListingEventsApiExploreGroupsGroupIdEventsGetData,
    ThrowOnError
  >,
): RequestResult<
  GroupListingEventsApiExploreGroupsGroupIdEventsGetResponses,
  GroupListingEventsApiExploreGroupsGroupIdEventsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GroupListingEventsApiExploreGroupsGroupIdEventsGetResponses,
    GroupListingEventsApiExploreGroupsGroupIdEventsGetErrors,
    ThrowOnError
  >({ url: "/api/explore/groups/{group_id}/events", ...options });

/**
 * Get Listings
 */
export const getListingsApiExploreGroupsGroupIdListingsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetListingsApiExploreGroupsGroupIdListingsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetListingsApiExploreGroupsGroupIdListingsGetResponses,
  GetListingsApiExploreGroupsGroupIdListingsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetListingsApiExploreGroupsGroupIdListingsGetResponses,
    GetListingsApiExploreGroupsGroupIdListingsGetErrors,
    ThrowOnError
  >({ url: "/api/explore/groups/{group_id}/listings", ...options });

/**
 * Create Listing
 */
export const createListingApiExploreGroupsGroupIdListingsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateListingApiExploreGroupsGroupIdListingsPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateListingApiExploreGroupsGroupIdListingsPostResponses,
  CreateListingApiExploreGroupsGroupIdListingsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateListingApiExploreGroupsGroupIdListingsPostResponses,
    CreateListingApiExploreGroupsGroupIdListingsPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/groups/{group_id}/listings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Listing
 */
export const deleteListingApiExploreListingsListingIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteListingApiExploreListingsListingIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  DeleteListingApiExploreListingsListingIdDeleteResponses,
  DeleteListingApiExploreListingsListingIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteListingApiExploreListingsListingIdDeleteResponses,
    DeleteListingApiExploreListingsListingIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/explore/listings/{listing_id}", ...options });

/**
 * Get Listing
 */
export const getListingApiExploreListingsListingIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetListingApiExploreListingsListingIdGetData, ThrowOnError>,
): RequestResult<
  GetListingApiExploreListingsListingIdGetResponses,
  GetListingApiExploreListingsListingIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetListingApiExploreListingsListingIdGetResponses,
    GetListingApiExploreListingsListingIdGetErrors,
    ThrowOnError
  >({ url: "/api/explore/listings/{listing_id}", ...options });

/**
 * Update Listing
 */
export const updateListingApiExploreListingsListingIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateListingApiExploreListingsListingIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateListingApiExploreListingsListingIdPatchResponses,
  UpdateListingApiExploreListingsListingIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateListingApiExploreListingsListingIdPatchResponses,
    UpdateListingApiExploreListingsListingIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/explore/listings/{listing_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add Listing Photo Urls
 */
export const addListingPhotoUrlsApiExploreListingsListingIdPhotosUrlsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddListingPhotoUrlsApiExploreListingsListingIdPhotosUrlsPostData,
    ThrowOnError
  >,
): RequestResult<
  AddListingPhotoUrlsApiExploreListingsListingIdPhotosUrlsPostResponses,
  AddListingPhotoUrlsApiExploreListingsListingIdPhotosUrlsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AddListingPhotoUrlsApiExploreListingsListingIdPhotosUrlsPostResponses,
    AddListingPhotoUrlsApiExploreListingsListingIdPhotosUrlsPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/listings/{listing_id}/photos/urls",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upload Listing Photo
 */
export const uploadListingPhotoApiExploreListingsListingIdPhotosUploadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadListingPhotoApiExploreListingsListingIdPhotosUploadPostData,
    ThrowOnError
  >,
): RequestResult<
  UploadListingPhotoApiExploreListingsListingIdPhotosUploadPostResponses,
  UploadListingPhotoApiExploreListingsListingIdPhotosUploadPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadListingPhotoApiExploreListingsListingIdPhotosUploadPostResponses,
    UploadListingPhotoApiExploreListingsListingIdPhotosUploadPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/explore/listings/{listing_id}/photos/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Get Votes
 */
export const getVotesApiExploreListingsListingIdVotesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVotesApiExploreListingsListingIdVotesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetVotesApiExploreListingsListingIdVotesGetResponses,
  GetVotesApiExploreListingsListingIdVotesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetVotesApiExploreListingsListingIdVotesGetResponses,
    GetVotesApiExploreListingsListingIdVotesGetErrors,
    ThrowOnError
  >({ url: "/api/explore/listings/{listing_id}/votes", ...options });

/**
 * Create Vote
 */
export const createVoteApiExploreListingsListingIdVotesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateVoteApiExploreListingsListingIdVotesPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateVoteApiExploreListingsListingIdVotesPostResponses,
  CreateVoteApiExploreListingsListingIdVotesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateVoteApiExploreListingsListingIdVotesPostResponses,
    CreateVoteApiExploreListingsListingIdVotesPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/listings/{listing_id}/votes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Vote
 *
 * Delete a vote. Service enforces voter-only deletion.
 */
export const deleteVoteApiExploreVotesVoteIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteVoteApiExploreVotesVoteIdDeleteData, ThrowOnError>,
): RequestResult<
  DeleteVoteApiExploreVotesVoteIdDeleteResponses,
  DeleteVoteApiExploreVotesVoteIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteVoteApiExploreVotesVoteIdDeleteResponses,
    DeleteVoteApiExploreVotesVoteIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/explore/votes/{vote_id}", ...options });

/**
 * Update Vote
 *
 * Update a vote. Service enforces voter-only edits.
 */
export const updateVoteApiExploreVotesVoteIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateVoteApiExploreVotesVoteIdPatchData, ThrowOnError>,
): RequestResult<
  UpdateVoteApiExploreVotesVoteIdPatchResponses,
  UpdateVoteApiExploreVotesVoteIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateVoteApiExploreVotesVoteIdPatchResponses,
    UpdateVoteApiExploreVotesVoteIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/explore/votes/{vote_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Comments
 */
export const getCommentsApiExploreListingsListingIdCommentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCommentsApiExploreListingsListingIdCommentsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetCommentsApiExploreListingsListingIdCommentsGetResponses,
  GetCommentsApiExploreListingsListingIdCommentsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetCommentsApiExploreListingsListingIdCommentsGetResponses,
    GetCommentsApiExploreListingsListingIdCommentsGetErrors,
    ThrowOnError
  >({ url: "/api/explore/listings/{listing_id}/comments", ...options });

/**
 * Create Comment
 */
export const createCommentApiExploreListingsListingIdCommentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateCommentApiExploreListingsListingIdCommentsPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateCommentApiExploreListingsListingIdCommentsPostResponses,
  CreateCommentApiExploreListingsListingIdCommentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateCommentApiExploreListingsListingIdCommentsPostResponses,
    CreateCommentApiExploreListingsListingIdCommentsPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/listings/{listing_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Comment
 *
 * Delete a comment. Service still enforces author-only deletion.
 */
export const deleteCommentApiExploreCommentsCommentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteCommentApiExploreCommentsCommentIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  DeleteCommentApiExploreCommentsCommentIdDeleteResponses,
  DeleteCommentApiExploreCommentsCommentIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteCommentApiExploreCommentsCommentIdDeleteResponses,
    DeleteCommentApiExploreCommentsCommentIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/explore/comments/{comment_id}", ...options });

/**
 * Update Comment
 *
 * Update a comment. Service still enforces author-only edits.
 */
export const updateCommentApiExploreCommentsCommentIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateCommentApiExploreCommentsCommentIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateCommentApiExploreCommentsCommentIdPatchResponses,
  UpdateCommentApiExploreCommentsCommentIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateCommentApiExploreCommentsCommentIdPatchResponses,
    UpdateCommentApiExploreCommentsCommentIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/explore/comments/{comment_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Listing Visits
 */
export const getListingVisitsApiExploreListingsListingIdVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetListingVisitsApiExploreListingsListingIdVisitsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetListingVisitsApiExploreListingsListingIdVisitsGetResponses,
  GetListingVisitsApiExploreListingsListingIdVisitsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetListingVisitsApiExploreListingsListingIdVisitsGetResponses,
    GetListingVisitsApiExploreListingsListingIdVisitsGetErrors,
    ThrowOnError
  >({ url: "/api/explore/listings/{listing_id}/visits", ...options });

/**
 * Create Listing Visit
 */
export const createListingVisitApiExploreListingsListingIdVisitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateListingVisitApiExploreListingsListingIdVisitsPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateListingVisitApiExploreListingsListingIdVisitsPostResponses,
  CreateListingVisitApiExploreListingsListingIdVisitsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateListingVisitApiExploreListingsListingIdVisitsPostResponses,
    CreateListingVisitApiExploreListingsListingIdVisitsPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/listings/{listing_id}/visits",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Listing Visit
 */
export const deleteListingVisitApiExploreVisitsVisitIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteListingVisitApiExploreVisitsVisitIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  DeleteListingVisitApiExploreVisitsVisitIdDeleteResponses,
  DeleteListingVisitApiExploreVisitsVisitIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteListingVisitApiExploreVisitsVisitIdDeleteResponses,
    DeleteListingVisitApiExploreVisitsVisitIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/explore/visits/{visit_id}", ...options });

/**
 * Update Listing Visit
 */
export const updateListingVisitApiExploreVisitsVisitIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateListingVisitApiExploreVisitsVisitIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateListingVisitApiExploreVisitsVisitIdPatchResponses,
  UpdateListingVisitApiExploreVisitsVisitIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateListingVisitApiExploreVisitsVisitIdPatchResponses,
    UpdateListingVisitApiExploreVisitsVisitIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/explore/visits/{visit_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Listing Visit Note
 */
export const createListingVisitNoteApiExploreVisitsVisitIdNotesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateListingVisitNoteApiExploreVisitsVisitIdNotesPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateListingVisitNoteApiExploreVisitsVisitIdNotesPostResponses,
  CreateListingVisitNoteApiExploreVisitsVisitIdNotesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateListingVisitNoteApiExploreVisitsVisitIdNotesPostResponses,
    CreateListingVisitNoteApiExploreVisitsVisitIdNotesPostErrors,
    ThrowOnError
  >({
    url: "/api/explore/visits/{visit_id}/notes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Listing Visit Note
 */
export const deleteListingVisitNoteApiExploreVisitNotesNoteIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteListingVisitNoteApiExploreVisitNotesNoteIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  DeleteListingVisitNoteApiExploreVisitNotesNoteIdDeleteResponses,
  DeleteListingVisitNoteApiExploreVisitNotesNoteIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteListingVisitNoteApiExploreVisitNotesNoteIdDeleteResponses,
    DeleteListingVisitNoteApiExploreVisitNotesNoteIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/explore/visit-notes/{note_id}", ...options });

/**
 * Update Listing Visit Note
 */
export const updateListingVisitNoteApiExploreVisitNotesNoteIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateListingVisitNoteApiExploreVisitNotesNoteIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateListingVisitNoteApiExploreVisitNotesNoteIdPatchResponses,
  UpdateListingVisitNoteApiExploreVisitNotesNoteIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateListingVisitNoteApiExploreVisitNotesNoteIdPatchResponses,
    UpdateListingVisitNoteApiExploreVisitNotesNoteIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/explore/visit-notes/{note_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upload Listing Visit Note Photo
 */
export const uploadListingVisitNotePhotoApiExploreVisitNotesNoteIdPhotosUploadPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadListingVisitNotePhotoApiExploreVisitNotesNoteIdPhotosUploadPostData,
      ThrowOnError
    >,
  ): RequestResult<
    UploadListingVisitNotePhotoApiExploreVisitNotesNoteIdPhotosUploadPostResponses,
    UploadListingVisitNotePhotoApiExploreVisitNotesNoteIdPhotosUploadPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      UploadListingVisitNotePhotoApiExploreVisitNotesNoteIdPhotosUploadPostResponses,
      UploadListingVisitNotePhotoApiExploreVisitNotesNoteIdPhotosUploadPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      url: "/api/explore/visit-notes/{note_id}/photos/upload",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });

/**
 * Delete Listing Visit Note Photo
 */
export const deleteListingVisitNotePhotoApiExploreVisitNotePhotosPhotoIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteListingVisitNotePhotoApiExploreVisitNotePhotosPhotoIdDeleteData,
      ThrowOnError
    >,
  ): RequestResult<
    DeleteListingVisitNotePhotoApiExploreVisitNotePhotosPhotoIdDeleteResponses,
    DeleteListingVisitNotePhotoApiExploreVisitNotePhotosPhotoIdDeleteErrors,
    ThrowOnError
  > =>
    (options.client ?? client).delete<
      DeleteListingVisitNotePhotoApiExploreVisitNotePhotosPhotoIdDeleteResponses,
      DeleteListingVisitNotePhotoApiExploreVisitNotePhotosPhotoIdDeleteErrors,
      ThrowOnError
    >({ url: "/api/explore/visit-note-photos/{photo_id}", ...options });

/**
 * Get Home Types
 */
export const getHomeTypesApiExploreOptionsHomeTypesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetHomeTypesApiExploreOptionsHomeTypesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetHomeTypesApiExploreOptionsHomeTypesGetResponses,
  GetHomeTypesApiExploreOptionsHomeTypesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetHomeTypesApiExploreOptionsHomeTypesGetResponses,
    GetHomeTypesApiExploreOptionsHomeTypesGetErrors,
    ThrowOnError
  >({ url: "/api/explore/options/home-types", ...options });

/**
 * Get Property Types
 */
export const getPropertyTypesApiExploreOptionsPropertyTypesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetPropertyTypesApiExploreOptionsPropertyTypesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetPropertyTypesApiExploreOptionsPropertyTypesGetResponses,
  GetPropertyTypesApiExploreOptionsPropertyTypesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPropertyTypesApiExploreOptionsPropertyTypesGetResponses,
    GetPropertyTypesApiExploreOptionsPropertyTypesGetErrors,
    ThrowOnError
  >({ url: "/api/explore/options/property-types", ...options });

/**
 * Get Amenities
 */
export const getAmenitiesApiExploreOptionsAmenitiesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAmenitiesApiExploreOptionsAmenitiesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetAmenitiesApiExploreOptionsAmenitiesGetResponses,
  GetAmenitiesApiExploreOptionsAmenitiesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAmenitiesApiExploreOptionsAmenitiesGetResponses,
    GetAmenitiesApiExploreOptionsAmenitiesGetErrors,
    ThrowOnError
  >({ url: "/api/explore/options/amenities", ...options });

/**
 * Get Currencies
 */
export const getCurrenciesApiExploreOptionsCurrenciesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetCurrenciesApiExploreOptionsCurrenciesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetCurrenciesApiExploreOptionsCurrenciesGetResponses,
  GetCurrenciesApiExploreOptionsCurrenciesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetCurrenciesApiExploreOptionsCurrenciesGetResponses,
    GetCurrenciesApiExploreOptionsCurrenciesGetErrors,
    ThrowOnError
  >({ url: "/api/explore/options/currencies", ...options });

/**
 * Public iCalendar feed for external subscribers
 *
 * Serve a home's busy dates as RFC 5545 iCalendar.
 *
 * Unauthenticated by necessity. Returns **404 for an unknown token, never
 * 403** — a 403 would confirm that a guessed token exists.
 */
export const getPublicFeedApiIntegrationFeedsExportTokenIcsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPublicFeedApiIntegrationFeedsExportTokenIcsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetPublicFeedApiIntegrationFeedsExportTokenIcsGetResponses,
  GetPublicFeedApiIntegrationFeedsExportTokenIcsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPublicFeedApiIntegrationFeedsExportTokenIcsGetResponses,
    GetPublicFeedApiIntegrationFeedsExportTokenIcsGetErrors,
    ThrowOnError
  >({ url: "/api/integration/feeds/{export_token}.ics", ...options });

/**
 * Shared house calendar for a home's members
 *
 * Serve one home's stays as RFC 5545 iCalendar, named rather than opaque.
 *
 * Unauthenticated by necessity — a calendar client cannot present credentials.
 * Served on a **separate path from the channel feed on purpose**: each
 * endpoint refuses the other's tokens, so a copy-paste slip 404s instead of
 * publishing member names to Airbnb.
 */
export const getHouseFeedApiIntegrationHouseExportTokenIcsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHouseFeedApiIntegrationHouseExportTokenIcsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetHouseFeedApiIntegrationHouseExportTokenIcsGetResponses,
  GetHouseFeedApiIntegrationHouseExportTokenIcsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHouseFeedApiIntegrationHouseExportTokenIcsGetResponses,
    GetHouseFeedApiIntegrationHouseExportTokenIcsGetErrors,
    ThrowOnError
  >({ url: "/api/integration/house/{export_token}.ics", ...options });

/**
 * Private iCalendar feed of one member's homes
 *
 * Serve the member's homes as RFC 5545 iCalendar.
 *
 * Unauthenticated by necessity — Google Calendar cannot present credentials.
 * Returns **404 for an unknown token, never 403**, so a guess is not
 * confirmed. A member with no homes gets an empty calendar, not a 404: their
 * subscription is working, it just has nothing in it.
 */
export const getPersonalCalendarFeedApiIntegrationCalendarTokenIcsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPersonalCalendarFeedApiIntegrationCalendarTokenIcsGetData,
    ThrowOnError
  >,
): RequestResult<
  GetPersonalCalendarFeedApiIntegrationCalendarTokenIcsGetResponses,
  GetPersonalCalendarFeedApiIntegrationCalendarTokenIcsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPersonalCalendarFeedApiIntegrationCalendarTokenIcsGetResponses,
    GetPersonalCalendarFeedApiIntegrationCalendarTokenIcsGetErrors,
    ThrowOnError
  >({ url: "/api/integration/calendar/{token}.ics", ...options });

/**
 * Disable My Calendar
 *
 * Revoke the caller's personal feed. Subscribed calendars stop updating.
 */
export const disableMyCalendarApiIntegrationMeCalendarDelete = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    DisableMyCalendarApiIntegrationMeCalendarDeleteData,
    ThrowOnError
  >,
): RequestResult<
  DisableMyCalendarApiIntegrationMeCalendarDeleteResponses,
  DisableMyCalendarApiIntegrationMeCalendarDeleteErrors,
  ThrowOnError
> =>
  (options?.client ?? client).delete<
    DisableMyCalendarApiIntegrationMeCalendarDeleteResponses,
    DisableMyCalendarApiIntegrationMeCalendarDeleteErrors,
    ThrowOnError
  >({ url: "/api/integration/me/calendar", ...options });

/**
 * Get My Calendar
 *
 * Get the caller's personal calendar subscription.
 *
 * No RBAC scope resolver: the resource is the caller's own user, not a home,
 * so authentication is the whole authorization. Never mints a token — a read
 * that created a capability would be a surprising side effect.
 */
export const getMyCalendarApiIntegrationMeCalendarGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetMyCalendarApiIntegrationMeCalendarGetData, ThrowOnError>,
): RequestResult<
  GetMyCalendarApiIntegrationMeCalendarGetResponses,
  GetMyCalendarApiIntegrationMeCalendarGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetMyCalendarApiIntegrationMeCalendarGetResponses,
    GetMyCalendarApiIntegrationMeCalendarGetErrors,
    ThrowOnError
  >({ url: "/api/integration/me/calendar", ...options });

/**
 * Enable My Calendar
 *
 * Enable the caller's personal calendar feed.
 *
 * Idempotent: calling it again returns the same URL rather than rotating the
 * token, so a double submit cannot break a subscription already added to
 * Google.
 */
export const enableMyCalendarApiIntegrationMeCalendarPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    EnableMyCalendarApiIntegrationMeCalendarPostData,
    ThrowOnError
  >,
): RequestResult<
  EnableMyCalendarApiIntegrationMeCalendarPostResponses,
  EnableMyCalendarApiIntegrationMeCalendarPostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    EnableMyCalendarApiIntegrationMeCalendarPostResponses,
    EnableMyCalendarApiIntegrationMeCalendarPostErrors,
    ThrowOnError
  >({ url: "/api/integration/me/calendar", ...options });

/**
 * Rotate My Calendar Token
 *
 * Issue a new personal feed URL. The previous one stops working at once.
 *
 * Every calendar app subscribed to the old URL must be re-subscribed.
 */
export const rotateMyCalendarTokenApiIntegrationMeCalendarRotatePost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    RotateMyCalendarTokenApiIntegrationMeCalendarRotatePostData,
    ThrowOnError
  >,
): RequestResult<
  RotateMyCalendarTokenApiIntegrationMeCalendarRotatePostResponses,
  RotateMyCalendarTokenApiIntegrationMeCalendarRotatePostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RotateMyCalendarTokenApiIntegrationMeCalendarRotatePostResponses,
    RotateMyCalendarTokenApiIntegrationMeCalendarRotatePostErrors,
    ThrowOnError
  >({ url: "/api/integration/me/calendar/rotate", ...options });

/**
 * List Integrations
 *
 * List a home's channel integrations and their sync status.
 */
export const listIntegrationsApiIntegrationHomeHomeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListIntegrationsApiIntegrationHomeHomeIdGetData,
    ThrowOnError
  >,
): RequestResult<
  ListIntegrationsApiIntegrationHomeHomeIdGetResponses,
  ListIntegrationsApiIntegrationHomeHomeIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListIntegrationsApiIntegrationHomeHomeIdGetResponses,
    ListIntegrationsApiIntegrationHomeHomeIdGetErrors,
    ThrowOnError
  >({ url: "/api/integration/home/{home_id}", ...options });

/**
 * Preview Airbnb Feed
 *
 * Validate and parse a candidate iCal URL without saving it.
 *
 * Lets an owner see the bookings that would be imported before committing to
 * the connection. Runs the same SSRF guard as a scheduled poll.
 */
export const previewAirbnbFeedApiIntegrationHomeHomeIdAirbnbPreviewPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PreviewAirbnbFeedApiIntegrationHomeHomeIdAirbnbPreviewPostData,
    ThrowOnError
  >,
): RequestResult<
  PreviewAirbnbFeedApiIntegrationHomeHomeIdAirbnbPreviewPostResponses,
  PreviewAirbnbFeedApiIntegrationHomeHomeIdAirbnbPreviewPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PreviewAirbnbFeedApiIntegrationHomeHomeIdAirbnbPreviewPostResponses,
    PreviewAirbnbFeedApiIntegrationHomeHomeIdAirbnbPreviewPostErrors,
    ThrowOnError
  >({
    url: "/api/integration/home/{home_id}/airbnb/preview",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Connect Airbnb
 *
 * Connect a home to Airbnb.
 *
 * ``import_url`` is optional — export-only (publish our feed, import nothing)
 * is a valid state.
 */
export const connectAirbnbApiIntegrationHomeHomeIdAirbnbPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ConnectAirbnbApiIntegrationHomeHomeIdAirbnbPostData,
    ThrowOnError
  >,
): RequestResult<
  ConnectAirbnbApiIntegrationHomeHomeIdAirbnbPostResponses,
  ConnectAirbnbApiIntegrationHomeHomeIdAirbnbPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ConnectAirbnbApiIntegrationHomeHomeIdAirbnbPostResponses,
    ConnectAirbnbApiIntegrationHomeHomeIdAirbnbPostErrors,
    ThrowOnError
  >({
    url: "/api/integration/home/{home_id}/airbnb",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Connect Google Calendar
 *
 * Publish this home's calendar for members to subscribe to.
 *
 * Not gated on ``home_channel_sync``: this is a read-only view of bookings
 * the home already has, not a rental-channel sync, so it is available on any
 * active home.
 */
export const connectGoogleCalendarApiIntegrationHomeHomeIdGoogleCalendarPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ConnectGoogleCalendarApiIntegrationHomeHomeIdGoogleCalendarPostData,
    ThrowOnError
  >,
): RequestResult<
  ConnectGoogleCalendarApiIntegrationHomeHomeIdGoogleCalendarPostResponses,
  ConnectGoogleCalendarApiIntegrationHomeHomeIdGoogleCalendarPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ConnectGoogleCalendarApiIntegrationHomeHomeIdGoogleCalendarPostResponses,
    ConnectGoogleCalendarApiIntegrationHomeHomeIdGoogleCalendarPostErrors,
    ThrowOnError
  >({ url: "/api/integration/home/{home_id}/google-calendar", ...options });

/**
 * Disconnect Integration
 *
 * Disconnect an integration.
 *
 * Imported reservations are soft-cancelled, not deleted: the dates are free
 * again, but the history and any ledger rows that reference them survive.
 */
export const disconnectIntegrationApiIntegrationIntegrationIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DisconnectIntegrationApiIntegrationIntegrationIdDeleteData,
    ThrowOnError
  >,
): RequestResult<
  DisconnectIntegrationApiIntegrationIntegrationIdDeleteResponses,
  DisconnectIntegrationApiIntegrationIntegrationIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DisconnectIntegrationApiIntegrationIntegrationIdDeleteResponses,
    DisconnectIntegrationApiIntegrationIntegrationIdDeleteErrors,
    ThrowOnError
  >({ url: "/api/integration/{integration_id}", ...options });

/**
 * Get Integration
 *
 * Get one integration with its sync status.
 */
export const getIntegrationApiIntegrationIntegrationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetIntegrationApiIntegrationIntegrationIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetIntegrationApiIntegrationIntegrationIdGetResponses,
  GetIntegrationApiIntegrationIntegrationIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetIntegrationApiIntegrationIntegrationIdGetResponses,
    GetIntegrationApiIntegrationIntegrationIdGetErrors,
    ThrowOnError
  >({ url: "/api/integration/{integration_id}", ...options });

/**
 * Update Integration
 *
 * Pause or resume an integration, or replace/clear its import URL.
 */
export const updateIntegrationApiIntegrationIntegrationIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateIntegrationApiIntegrationIntegrationIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateIntegrationApiIntegrationIntegrationIdPatchResponses,
  UpdateIntegrationApiIntegrationIntegrationIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateIntegrationApiIntegrationIntegrationIdPatchResponses,
    UpdateIntegrationApiIntegrationIntegrationIdPatchErrors,
    ThrowOnError
  >({
    url: "/api/integration/{integration_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Rotate Export Token
 *
 * Issue a new export token. The previous feed URL stops working at once.
 */
export const rotateExportTokenApiIntegrationIntegrationIdRotateTokenPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RotateExportTokenApiIntegrationIntegrationIdRotateTokenPostData,
    ThrowOnError
  >,
): RequestResult<
  RotateExportTokenApiIntegrationIntegrationIdRotateTokenPostResponses,
  RotateExportTokenApiIntegrationIntegrationIdRotateTokenPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RotateExportTokenApiIntegrationIntegrationIdRotateTokenPostResponses,
    RotateExportTokenApiIntegrationIntegrationIdRotateTokenPostErrors,
    ThrowOnError
  >({ url: "/api/integration/{integration_id}/rotate-token", ...options });

/**
 * Sync Integration
 *
 * Run a sync now, in addition to the scheduled polls.
 */
export const syncIntegrationApiIntegrationIntegrationIdSyncPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncIntegrationApiIntegrationIntegrationIdSyncPostData,
    ThrowOnError
  >,
): RequestResult<
  SyncIntegrationApiIntegrationIntegrationIdSyncPostResponses,
  SyncIntegrationApiIntegrationIntegrationIdSyncPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SyncIntegrationApiIntegrationIntegrationIdSyncPostResponses,
    SyncIntegrationApiIntegrationIntegrationIdSyncPostErrors,
    ThrowOnError
  >({ url: "/api/integration/{integration_id}/sync", ...options });

/**
 * List Payout Imports
 *
 * List this integration's payout imports, newest first.
 */
export const listPayoutImportsApiIntegrationIntegrationIdPayoutsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPayoutImportsApiIntegrationIntegrationIdPayoutsGetData,
    ThrowOnError
  >,
): RequestResult<
  ListPayoutImportsApiIntegrationIntegrationIdPayoutsGetResponses,
  ListPayoutImportsApiIntegrationIntegrationIdPayoutsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPayoutImportsApiIntegrationIntegrationIdPayoutsGetResponses,
    ListPayoutImportsApiIntegrationIntegrationIdPayoutsGetErrors,
    ThrowOnError
  >({ url: "/api/integration/{integration_id}/payouts", ...options });

/**
 * Preview Payout Csv
 *
 * Dry-run a payout CSV. **Writes nothing to the ledger.**
 *
 * Returns matched, unmatched and already-imported rows, the total, and — when
 * the payout currency differs from the ledger's — the proposed rate, its
 * source, and the converted per-row amounts.
 */
export const previewPayoutCsvApiIntegrationIntegrationIdPayoutsPreviewPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PreviewPayoutCsvApiIntegrationIntegrationIdPayoutsPreviewPostData,
    ThrowOnError
  >,
): RequestResult<
  PreviewPayoutCsvApiIntegrationIntegrationIdPayoutsPreviewPostResponses,
  PreviewPayoutCsvApiIntegrationIntegrationIdPayoutsPreviewPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PreviewPayoutCsvApiIntegrationIntegrationIdPayoutsPreviewPostResponses,
    PreviewPayoutCsvApiIntegrationIntegrationIdPayoutsPreviewPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/integration/{integration_id}/payouts/preview",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Commit Payout Import
 *
 * Commit a previewed payout import to the operating ledger account.
 *
 * Idempotent: re-committing, or committing an overlapping export, posts each
 * ``external_id`` at most once.
 */
export const commitPayoutImportApiIntegrationIntegrationIdPayoutsCommitPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CommitPayoutImportApiIntegrationIntegrationIdPayoutsCommitPostData,
    ThrowOnError
  >,
): RequestResult<
  CommitPayoutImportApiIntegrationIntegrationIdPayoutsCommitPostResponses,
  CommitPayoutImportApiIntegrationIntegrationIdPayoutsCommitPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CommitPayoutImportApiIntegrationIntegrationIdPayoutsCommitPostResponses,
    CommitPayoutImportApiIntegrationIntegrationIdPayoutsCommitPostErrors,
    ThrowOnError
  >({
    url: "/api/integration/{integration_id}/payouts/commit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Health Live
 *
 * Docker/K8s liveness probe: API responsiveness only, no dependency checks.
 */
export const healthLiveApiHealthLiveGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthLiveApiHealthLiveGetData, ThrowOnError>,
): RequestResult<HealthLiveApiHealthLiveGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    HealthLiveApiHealthLiveGetResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/health/live", ...options });

/**
 * Health Ready
 *
 * Readiness probe for dependencies required to accept production traffic.
 */
export const healthReadyApiHealthReadyGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthReadyApiHealthReadyGetData, ThrowOnError>,
): RequestResult<
  HealthReadyApiHealthReadyGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    HealthReadyApiHealthReadyGetResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/health/ready", ...options });

/**
 * Health Check
 *
 * Checks API, database, and Supabase auth connectivity for monitoring.
 */
export const healthCheckApiHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckApiHealthGetData, ThrowOnError>,
): RequestResult<HealthCheckApiHealthGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    HealthCheckApiHealthGetResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/health", ...options });

/**
 * Sign Up
 *
 * Sign up a new user.
 */
export const signUpApiAuthSignupPost = <ThrowOnError extends boolean = false>(
  options: Options<SignUpApiAuthSignupPostData, ThrowOnError>,
): RequestResult<
  SignUpApiAuthSignupPostResponses,
  SignUpApiAuthSignupPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SignUpApiAuthSignupPostResponses,
    SignUpApiAuthSignupPostErrors,
    ThrowOnError
  >({
    url: "/api/auth/signup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sign In
 *
 * Sign in an existing user.
 */
export const signInApiAuthSigninPost = <ThrowOnError extends boolean = false>(
  options: Options<SignInApiAuthSigninPostData, ThrowOnError>,
): RequestResult<
  SignInApiAuthSigninPostResponses,
  SignInApiAuthSigninPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SignInApiAuthSigninPostResponses,
    SignInApiAuthSigninPostErrors,
    ThrowOnError
  >({
    url: "/api/auth/signin",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sign Out
 *
 * Sign out a user.
 */
export const signOutApiAuthSignoutPost = <ThrowOnError extends boolean = false>(
  options?: Options<SignOutApiAuthSignoutPostData, ThrowOnError>,
): RequestResult<
  SignOutApiAuthSignoutPostResponses,
  SignOutApiAuthSignoutPostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SignOutApiAuthSignoutPostResponses,
    SignOutApiAuthSignoutPostErrors,
    ThrowOnError
  >({ url: "/api/auth/signout", ...options });

/**
 * Delete Current User
 *
 * Removes the local user row (cascading to related records) and best-effort
 * deletes the Supabase auth user so the email can be reused.
 */
export const deleteCurrentUserApiAuthMeDelete = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DeleteCurrentUserApiAuthMeDeleteData, ThrowOnError>,
): RequestResult<
  DeleteCurrentUserApiAuthMeDeleteResponses,
  DeleteCurrentUserApiAuthMeDeleteErrors,
  ThrowOnError
> =>
  (options?.client ?? client).delete<
    DeleteCurrentUserApiAuthMeDeleteResponses,
    DeleteCurrentUserApiAuthMeDeleteErrors,
    ThrowOnError
  >({ url: "/api/auth/me", ...options });

/**
 * Get Current User Profile
 */
export const getCurrentUserProfileApiAuthMeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCurrentUserProfileApiAuthMeGetData, ThrowOnError>,
): RequestResult<
  GetCurrentUserProfileApiAuthMeGetResponses,
  GetCurrentUserProfileApiAuthMeGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetCurrentUserProfileApiAuthMeGetResponses,
    GetCurrentUserProfileApiAuthMeGetErrors,
    ThrowOnError
  >({ url: "/api/auth/me", ...options });

/**
 * Update Current User Profile
 */
export const updateCurrentUserProfileApiAuthMePatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCurrentUserProfileApiAuthMePatchData, ThrowOnError>,
): RequestResult<
  UpdateCurrentUserProfileApiAuthMePatchResponses,
  UpdateCurrentUserProfileApiAuthMePatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateCurrentUserProfileApiAuthMePatchResponses,
    UpdateCurrentUserProfileApiAuthMePatchErrors,
    ThrowOnError
  >({
    url: "/api/auth/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Current User Profile
 */
export const updateCurrentUserProfileApiAuthMePut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCurrentUserProfileApiAuthMePutData, ThrowOnError>,
): RequestResult<
  UpdateCurrentUserProfileApiAuthMePutResponses,
  UpdateCurrentUserProfileApiAuthMePutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateCurrentUserProfileApiAuthMePutResponses,
    UpdateCurrentUserProfileApiAuthMePutErrors,
    ThrowOnError
  >({
    url: "/api/auth/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upload Current User Avatar
 *
 * The image is shrunk server-side and stored in object storage; only the
 * resulting public URL is persisted on the user.
 */
export const uploadCurrentUserAvatarApiAuthMeAvatarPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadCurrentUserAvatarApiAuthMeAvatarPostData,
    ThrowOnError
  >,
): RequestResult<
  UploadCurrentUserAvatarApiAuthMeAvatarPostResponses,
  UploadCurrentUserAvatarApiAuthMeAvatarPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadCurrentUserAvatarApiAuthMeAvatarPostResponses,
    UploadCurrentUserAvatarApiAuthMeAvatarPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/auth/me/avatar",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Refresh Session
 *
 * Refresh user session.
 */
export const refreshSessionApiAuthRefreshPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RefreshSessionApiAuthRefreshPostData, ThrowOnError>,
): RequestResult<
  RefreshSessionApiAuthRefreshPostResponses,
  RefreshSessionApiAuthRefreshPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RefreshSessionApiAuthRefreshPostResponses,
    RefreshSessionApiAuthRefreshPostErrors,
    ThrowOnError
  >({
    url: "/api/auth/refresh",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Verify Email
 *
 * Verify email confirmation via token hash.
 */
export const verifyEmailApiAuthVerifyEmailPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VerifyEmailApiAuthVerifyEmailPostData, ThrowOnError>,
): RequestResult<
  VerifyEmailApiAuthVerifyEmailPostResponses,
  VerifyEmailApiAuthVerifyEmailPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    VerifyEmailApiAuthVerifyEmailPostResponses,
    VerifyEmailApiAuthVerifyEmailPostErrors,
    ThrowOnError
  >({
    url: "/api/auth/verify-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Invite Session
 *
 * Create a session from an invite token.
 */
export const inviteSessionApiAuthInviteSessionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InviteSessionApiAuthInviteSessionPostData, ThrowOnError>,
): RequestResult<
  InviteSessionApiAuthInviteSessionPostResponses,
  InviteSessionApiAuthInviteSessionPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    InviteSessionApiAuthInviteSessionPostResponses,
    InviteSessionApiAuthInviteSessionPostErrors,
    ThrowOnError
  >({
    url: "/api/auth/invite-session",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Resend Confirmation Email
 *
 * Resend email confirmation.
 */
export const resendConfirmationEmailApiAuthResendConfirmationPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResendConfirmationEmailApiAuthResendConfirmationPostData,
    ThrowOnError
  >,
): RequestResult<
  ResendConfirmationEmailApiAuthResendConfirmationPostResponses,
  ResendConfirmationEmailApiAuthResendConfirmationPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ResendConfirmationEmailApiAuthResendConfirmationPostResponses,
    ResendConfirmationEmailApiAuthResendConfirmationPostErrors,
    ThrowOnError
  >({
    url: "/api/auth/resend-confirmation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Forgot Password
 *
 * Request password reset.
 */
export const forgotPasswordApiAuthForgotPasswordPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ForgotPasswordApiAuthForgotPasswordPostData, ThrowOnError>,
): RequestResult<
  ForgotPasswordApiAuthForgotPasswordPostResponses,
  ForgotPasswordApiAuthForgotPasswordPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ForgotPasswordApiAuthForgotPasswordPostResponses,
    ForgotPasswordApiAuthForgotPasswordPostErrors,
    ThrowOnError
  >({
    url: "/api/auth/forgot-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reset Password
 *
 * Reset password using recovery token.
 */
export const resetPasswordApiAuthResetPasswordPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResetPasswordApiAuthResetPasswordPostData, ThrowOnError>,
): RequestResult<
  ResetPasswordApiAuthResetPasswordPostResponses,
  ResetPasswordApiAuthResetPasswordPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ResetPasswordApiAuthResetPasswordPostResponses,
    ResetPasswordApiAuthResetPasswordPostErrors,
    ThrowOnError
  >({
    url: "/api/auth/reset-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sign In With Id Token
 *
 * Sign in using an ID token from an OAuth provider.
 */
export const signInWithIdTokenApiAuthIdTokenPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SignInWithIdTokenApiAuthIdTokenPostData, ThrowOnError>,
): RequestResult<
  SignInWithIdTokenApiAuthIdTokenPostResponses,
  SignInWithIdTokenApiAuthIdTokenPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SignInWithIdTokenApiAuthIdTokenPostResponses,
    SignInWithIdTokenApiAuthIdTokenPostErrors,
    ThrowOnError
  >({
    url: "/api/auth/id-token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
